
/*
=============================================================================
auto-generated ***
to refresh you will need to run
npm run build:model
This code was generated by a tool.
¯\_(ツ)_/¯

Changes to this file may cause incorrect behavior and will be lost if
the code is regenerated.
=============================================================================
*/



export interface IAttributeOptionSet {
	[key: string]: IAttributeOptionSetItem
}

export interface IAttributeOptionSetItem {
	[key: string]: IAttributeOptionSetItemValue
}

export interface IAttributeOptionSetItemValue {
		name: string;
		value: number;
		order: number;
}
export namespace account {
	export const bcbs_usedefaultvalues = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_usedefaultvalues = keyof typeof bcbs_usedefaultvalues;

	export const bcbs_sameasphysicaladdress = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_sameasphysicaladdress = keyof typeof bcbs_sameasphysicaladdress;

	export const bcbs_requiredivision = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_requiredivision = keyof typeof bcbs_requiredivision;

	export const territorycode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Tterritorycode = keyof typeof territorycode;

	export const ownershipcode = {
		"Public(1)" : {
			name: "Public",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Public",
			value: 1,
			order: 1,
		},
		"Private(2)" : {
			name: "Private",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Private",
			value: 2,
			order: 2,
		},
		"Subsidiary(3)" : {
			name: "Subsidiary",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Subsidiary",
			value: 3,
			order: 3,
		},
		"Other(4)" : {
			name: "Other",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Other",
			value: 4,
			order: 4,
		},
	}
	export type Townershipcode = keyof typeof ownershipcode;

	export const customersizecode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Tcustomersizecode = keyof typeof customersizecode;

	export const donotbulkpostalmail = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tdonotbulkpostalmail = keyof typeof donotbulkpostalmail;

	export const address1_freighttermscode = {
		"FOB(1)" : {
			name: "FOB",
			value: 1,
			order: 1,
		},
		1 : {
			name: "FOB",
			value: 1,
			order: 1,
		},
		"No Charge(2)" : {
			name: "No Charge",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No Charge",
			value: 2,
			order: 2,
		},
	}
	export type Taddress1_freighttermscode = keyof typeof address1_freighttermscode;

	export const shippingmethodcode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Tshippingmethodcode = keyof typeof shippingmethodcode;

	export const preferredcontactmethodcode = {
		"Any(1)" : {
			name: "Any",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Any",
			value: 1,
			order: 1,
		},
		"Email(2)" : {
			name: "Email",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Email",
			value: 2,
			order: 2,
		},
		"Phone(3)" : {
			name: "Phone",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Phone",
			value: 3,
			order: 3,
		},
		"Fax(4)" : {
			name: "Fax",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Fax",
			value: 4,
			order: 4,
		},
		"Mail(5)" : {
			name: "Mail",
			value: 5,
			order: 5,
		},
		5 : {
			name: "Mail",
			value: 5,
			order: 5,
		},
	}
	export type Tpreferredcontactmethodcode = keyof typeof preferredcontactmethodcode;

	export const merged = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tmerged = keyof typeof merged;

	export const preferredappointmentdaycode = {
		"Sunday(0)" : {
			name: "Sunday",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Sunday",
			value: 0,
			order: 1,
		},
		"Monday(1)" : {
			name: "Monday",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Monday",
			value: 1,
			order: 2,
		},
		"Tuesday(2)" : {
			name: "Tuesday",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Tuesday",
			value: 2,
			order: 3,
		},
		"Wednesday(3)" : {
			name: "Wednesday",
			value: 3,
			order: 4,
		},
		3 : {
			name: "Wednesday",
			value: 3,
			order: 4,
		},
		"Thursday(4)" : {
			name: "Thursday",
			value: 4,
			order: 5,
		},
		4 : {
			name: "Thursday",
			value: 4,
			order: 5,
		},
		"Friday(5)" : {
			name: "Friday",
			value: 5,
			order: 6,
		},
		5 : {
			name: "Friday",
			value: 5,
			order: 6,
		},
		"Saturday(6)" : {
			name: "Saturday",
			value: 6,
			order: 7,
		},
		6 : {
			name: "Saturday",
			value: 6,
			order: 7,
		},
	}
	export type Tpreferredappointmentdaycode = keyof typeof preferredappointmentdaycode;

	export const paymenttermscode = {
		"Net 30(1)" : {
			name: "Net 30",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Net 30",
			value: 1,
			order: 1,
		},
		"2 10 Net 30(2)" : {
			name: "2 10 Net 30",
			value: 2,
			order: 2,
		},
		2 : {
			name: "2 10 Net 30",
			value: 2,
			order: 2,
		},
		"Net 45(3)" : {
			name: "Net 45",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Net 45",
			value: 3,
			order: 3,
		},
		"Net 60(4)" : {
			name: "Net 60",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Net 60",
			value: 4,
			order: 4,
		},
	}
	export type Tpaymenttermscode = keyof typeof paymenttermscode;

	export const donotbulkemail = {
		"Allow(0)" : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		"Do Not Allow(1)" : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
	}
	export type Tdonotbulkemail = keyof typeof donotbulkemail;

	export const address1_shippingmethodcode = {
		"Airborne(1)" : {
			name: "Airborne",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Airborne",
			value: 1,
			order: 1,
		},
		"DHL(2)" : {
			name: "DHL",
			value: 2,
			order: 2,
		},
		2 : {
			name: "DHL",
			value: 2,
			order: 2,
		},
		"FedEx(3)" : {
			name: "FedEx",
			value: 3,
			order: 3,
		},
		3 : {
			name: "FedEx",
			value: 3,
			order: 3,
		},
		"UPS(4)" : {
			name: "UPS",
			value: 4,
			order: 4,
		},
		4 : {
			name: "UPS",
			value: 4,
			order: 4,
		},
		"Postal Mail(5)" : {
			name: "Postal Mail",
			value: 5,
			order: 5,
		},
		5 : {
			name: "Postal Mail",
			value: 5,
			order: 5,
		},
		"Full Load(6)" : {
			name: "Full Load",
			value: 6,
			order: 6,
		},
		6 : {
			name: "Full Load",
			value: 6,
			order: 6,
		},
		"Will Call(7)" : {
			name: "Will Call",
			value: 7,
			order: 7,
		},
		7 : {
			name: "Will Call",
			value: 7,
			order: 7,
		},
	}
	export type Taddress1_shippingmethodcode = keyof typeof address1_shippingmethodcode;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const isprivate = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tisprivate = keyof typeof isprivate;

	export const accountcategorycode = {
		"Preferred Customer(1)" : {
			name: "Preferred Customer",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Preferred Customer",
			value: 1,
			order: 1,
		},
		"Standard(2)" : {
			name: "Standard",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Standard",
			value: 2,
			order: 2,
		},
	}
	export type Taccountcategorycode = keyof typeof accountcategorycode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const donotfax = {
		"Allow(0)" : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		"Do Not Allow(1)" : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
	}
	export type Tdonotfax = keyof typeof donotfax;

	export const marketingonly = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tmarketingonly = keyof typeof marketingonly;

	export const donotemail = {
		"Allow(0)" : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		"Do Not Allow(1)" : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
	}
	export type Tdonotemail = keyof typeof donotemail;

	export const donotsendmm = {
		"Send(0)" : {
			name: "Send",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Send",
			value: 0,
			order: 1,
		},
		"Do Not Send(1)" : {
			name: "Do Not Send",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Do Not Send",
			value: 1,
			order: 2,
		},
	}
	export type Tdonotsendmm = keyof typeof donotsendmm;

	export const address2_freighttermscode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Taddress2_freighttermscode = keyof typeof address2_freighttermscode;

	export const accountratingcode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Taccountratingcode = keyof typeof accountratingcode;

	export const participatesinworkflow = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tparticipatesinworkflow = keyof typeof participatesinworkflow;

	export const creditonhold = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tcreditonhold = keyof typeof creditonhold;

	export const address2_addresstypecode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Taddress2_addresstypecode = keyof typeof address2_addresstypecode;

	export const followemail = {
		"Do Not Allow(0)" : {
			name: "Do Not Allow",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Do Not Allow",
			value: 0,
			order: 1,
		},
		"Allow(1)" : {
			name: "Allow",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Allow",
			value: 1,
			order: 2,
		},
	}
	export type Tfollowemail = keyof typeof followemail;

	export const donotphone = {
		"Allow(0)" : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		"Do Not Allow(1)" : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
	}
	export type Tdonotphone = keyof typeof donotphone;

	export const accountclassificationcode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Taccountclassificationcode = keyof typeof accountclassificationcode;

	export const donotpostalmail = {
		"Allow(0)" : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		"Do Not Allow(1)" : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
	}
	export type Tdonotpostalmail = keyof typeof donotpostalmail;

	export const address1_addresstypecode = {
		"Bill To(1)" : {
			name: "Bill To",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Bill To",
			value: 1,
			order: 1,
		},
		"Ship To(2)" : {
			name: "Ship To",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Ship To",
			value: 2,
			order: 2,
		},
		"Primary(3)" : {
			name: "Primary",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Primary",
			value: 3,
			order: 3,
		},
		"Other(4)" : {
			name: "Other",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Other",
			value: 4,
			order: 4,
		},
	}
	export type Taddress1_addresstypecode = keyof typeof address1_addresstypecode;

	export const businesstypecode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Tbusinesstypecode = keyof typeof businesstypecode;

	export const address2_shippingmethodcode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Taddress2_shippingmethodcode = keyof typeof address2_shippingmethodcode;

	export const preferredappointmenttimecode = {
		"Morning(1)" : {
			name: "Morning",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Morning",
			value: 1,
			order: 1,
		},
		"Afternoon(2)" : {
			name: "Afternoon",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Afternoon",
			value: 2,
			order: 2,
		},
		"Evening(3)" : {
			name: "Evening",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Evening",
			value: 3,
			order: 3,
		},
	}
	export type Tpreferredappointmenttimecode = keyof typeof preferredappointmenttimecode;

	export const industrycode = {
		"Accounting(1)" : {
			name: "Accounting",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Accounting",
			value: 1,
			order: 1,
		},
		"Agriculture and Nonpetrol Natural Resource Extraction(2)" : {
			name: "Agriculture and Nonpetrol Natural Resource Extraction",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Agriculture and Nonpetrol Natural Resource Extraction",
			value: 2,
			order: 2,
		},
		"Broadcasting Printing and Publishing(3)" : {
			name: "Broadcasting Printing and Publishing",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Broadcasting Printing and Publishing",
			value: 3,
			order: 3,
		},
		"Brokers(4)" : {
			name: "Brokers",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Brokers",
			value: 4,
			order: 4,
		},
		"Building Supply Retail(5)" : {
			name: "Building Supply Retail",
			value: 5,
			order: 5,
		},
		5 : {
			name: "Building Supply Retail",
			value: 5,
			order: 5,
		},
		"Business Services(6)" : {
			name: "Business Services",
			value: 6,
			order: 6,
		},
		6 : {
			name: "Business Services",
			value: 6,
			order: 6,
		},
		"Consulting(7)" : {
			name: "Consulting",
			value: 7,
			order: 7,
		},
		7 : {
			name: "Consulting",
			value: 7,
			order: 7,
		},
		"Consumer Services(8)" : {
			name: "Consumer Services",
			value: 8,
			order: 8,
		},
		8 : {
			name: "Consumer Services",
			value: 8,
			order: 8,
		},
		"Design Direction and Creative Management(9)" : {
			name: "Design Direction and Creative Management",
			value: 9,
			order: 9,
		},
		9 : {
			name: "Design Direction and Creative Management",
			value: 9,
			order: 9,
		},
		"Distributors Dispatchers and Processors(10)" : {
			name: "Distributors Dispatchers and Processors",
			value: 10,
			order: 10,
		},
		10 : {
			name: "Distributors Dispatchers and Processors",
			value: 10,
			order: 10,
		},
		"Doctors Offices and Clinics(11)" : {
			name: "Doctors Offices and Clinics",
			value: 11,
			order: 11,
		},
		11 : {
			name: "Doctors Offices and Clinics",
			value: 11,
			order: 11,
		},
		"Durable Manufacturing(12)" : {
			name: "Durable Manufacturing",
			value: 12,
			order: 12,
		},
		12 : {
			name: "Durable Manufacturing",
			value: 12,
			order: 12,
		},
		"Eating and Drinking Places(13)" : {
			name: "Eating and Drinking Places",
			value: 13,
			order: 13,
		},
		13 : {
			name: "Eating and Drinking Places",
			value: 13,
			order: 13,
		},
		"Entertainment Retail(14)" : {
			name: "Entertainment Retail",
			value: 14,
			order: 14,
		},
		14 : {
			name: "Entertainment Retail",
			value: 14,
			order: 14,
		},
		"Equipment Rental and Leasing(15)" : {
			name: "Equipment Rental and Leasing",
			value: 15,
			order: 15,
		},
		15 : {
			name: "Equipment Rental and Leasing",
			value: 15,
			order: 15,
		},
		"Financial(16)" : {
			name: "Financial",
			value: 16,
			order: 16,
		},
		16 : {
			name: "Financial",
			value: 16,
			order: 16,
		},
		"Food and Tobacco Processing(17)" : {
			name: "Food and Tobacco Processing",
			value: 17,
			order: 17,
		},
		17 : {
			name: "Food and Tobacco Processing",
			value: 17,
			order: 17,
		},
		"Inbound Capital Intensive Processing(18)" : {
			name: "Inbound Capital Intensive Processing",
			value: 18,
			order: 18,
		},
		18 : {
			name: "Inbound Capital Intensive Processing",
			value: 18,
			order: 18,
		},
		"Inbound Repair and Services(19)" : {
			name: "Inbound Repair and Services",
			value: 19,
			order: 19,
		},
		19 : {
			name: "Inbound Repair and Services",
			value: 19,
			order: 19,
		},
		"Insurance(20)" : {
			name: "Insurance",
			value: 20,
			order: 20,
		},
		20 : {
			name: "Insurance",
			value: 20,
			order: 20,
		},
		"Legal Services(21)" : {
			name: "Legal Services",
			value: 21,
			order: 21,
		},
		21 : {
			name: "Legal Services",
			value: 21,
			order: 21,
		},
		"NonDurable Merchandise Retail(22)" : {
			name: "NonDurable Merchandise Retail",
			value: 22,
			order: 22,
		},
		22 : {
			name: "NonDurable Merchandise Retail",
			value: 22,
			order: 22,
		},
		"Outbound Consumer Service(23)" : {
			name: "Outbound Consumer Service",
			value: 23,
			order: 23,
		},
		23 : {
			name: "Outbound Consumer Service",
			value: 23,
			order: 23,
		},
		"Petrochemical Extraction and Distribution(24)" : {
			name: "Petrochemical Extraction and Distribution",
			value: 24,
			order: 24,
		},
		24 : {
			name: "Petrochemical Extraction and Distribution",
			value: 24,
			order: 24,
		},
		"Service Retail(25)" : {
			name: "Service Retail",
			value: 25,
			order: 25,
		},
		25 : {
			name: "Service Retail",
			value: 25,
			order: 25,
		},
		"SIG Affiliations(26)" : {
			name: "SIG Affiliations",
			value: 26,
			order: 26,
		},
		26 : {
			name: "SIG Affiliations",
			value: 26,
			order: 26,
		},
		"Social Services(27)" : {
			name: "Social Services",
			value: 27,
			order: 27,
		},
		27 : {
			name: "Social Services",
			value: 27,
			order: 27,
		},
		"Special Outbound Trade Contractors(28)" : {
			name: "Special Outbound Trade Contractors",
			value: 28,
			order: 28,
		},
		28 : {
			name: "Special Outbound Trade Contractors",
			value: 28,
			order: 28,
		},
		"Specialty Realty(29)" : {
			name: "Specialty Realty",
			value: 29,
			order: 29,
		},
		29 : {
			name: "Specialty Realty",
			value: 29,
			order: 29,
		},
		"Transportation(30)" : {
			name: "Transportation",
			value: 30,
			order: 30,
		},
		30 : {
			name: "Transportation",
			value: 30,
			order: 30,
		},
		"Utility Creation and Distribution(31)" : {
			name: "Utility Creation and Distribution",
			value: 31,
			order: 31,
		},
		31 : {
			name: "Utility Creation and Distribution",
			value: 31,
			order: 31,
		},
		"Vehicle Retail(32)" : {
			name: "Vehicle Retail",
			value: 32,
			order: 32,
		},
		32 : {
			name: "Vehicle Retail",
			value: 32,
			order: 32,
		},
		"Wholesale(33)" : {
			name: "Wholesale",
			value: 33,
			order: 33,
		},
		33 : {
			name: "Wholesale",
			value: 33,
			order: 33,
		},
	}
	export type Tindustrycode = keyof typeof industrycode;

	export const bcbs_iscancelled = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tbcbs_iscancelled = keyof typeof bcbs_iscancelled;

	export const bcbs_lineofbusiness = {
		"FEP(808900006)" : {
			name: "FEP",
			value: 808900006,
			order: 1,
		},
		808900006 : {
			name: "FEP",
			value: 808900006,
			order: 1,
		},
		"GI(808900000)" : {
			name: "GI",
			value: 808900000,
			order: 2,
		},
		808900000 : {
			name: "GI",
			value: 808900000,
			order: 2,
		},
		"State Group(808900005)" : {
			name: "State Group",
			value: 808900005,
			order: 3,
		},
		808900005 : {
			name: "State Group",
			value: 808900005,
			order: 3,
		},
		"Major Group(808900003)" : {
			name: "Major Group",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Major Group",
			value: 808900003,
			order: 4,
		},
		"National Alliance(808900001)" : {
			name: "National Alliance",
			value: 808900001,
			order: 5,
		},
		808900001 : {
			name: "National Alliance",
			value: 808900001,
			order: 5,
		},
		"BlueChoice(808900002)" : {
			name: "BlueChoice",
			value: 808900002,
			order: 6,
		},
		808900002 : {
			name: "BlueChoice",
			value: 808900002,
			order: 6,
		},
		"GI(808900004)" : {
			name: "GI",
			value: 808900004,
			order: 7,
		},
		808900004 : {
			name: "GI",
			value: 808900004,
			order: 7,
		},
	}
	export type Tbcbs_lineofbusiness = keyof typeof bcbs_lineofbusiness;

	export const bcbs_renewalmonthcode = {
		"January(1)" : {
			name: "January",
			value: 1,
			order: 1,
		},
		1 : {
			name: "January",
			value: 1,
			order: 1,
		},
		"February(2)" : {
			name: "February",
			value: 2,
			order: 2,
		},
		2 : {
			name: "February",
			value: 2,
			order: 2,
		},
		"March(3)" : {
			name: "March",
			value: 3,
			order: 3,
		},
		3 : {
			name: "March",
			value: 3,
			order: 3,
		},
		"April(4)" : {
			name: "April",
			value: 4,
			order: 4,
		},
		4 : {
			name: "April",
			value: 4,
			order: 4,
		},
		"May(5)" : {
			name: "May",
			value: 5,
			order: 5,
		},
		5 : {
			name: "May",
			value: 5,
			order: 5,
		},
		"June(6)" : {
			name: "June",
			value: 6,
			order: 6,
		},
		6 : {
			name: "June",
			value: 6,
			order: 6,
		},
		"July(7)" : {
			name: "July",
			value: 7,
			order: 7,
		},
		7 : {
			name: "July",
			value: 7,
			order: 7,
		},
		"August(8)" : {
			name: "August",
			value: 8,
			order: 8,
		},
		8 : {
			name: "August",
			value: 8,
			order: 8,
		},
		"September(9)" : {
			name: "September",
			value: 9,
			order: 9,
		},
		9 : {
			name: "September",
			value: 9,
			order: 9,
		},
		"October(10)" : {
			name: "October",
			value: 10,
			order: 10,
		},
		10 : {
			name: "October",
			value: 10,
			order: 10,
		},
		"November(11)" : {
			name: "November",
			value: 11,
			order: 11,
		},
		11 : {
			name: "November",
			value: 11,
			order: 11,
		},
		"December(12)" : {
			name: "December",
			value: 12,
			order: 12,
		},
		12 : {
			name: "December",
			value: 12,
			order: 12,
		},
	}
	export type Tbcbs_renewalmonthcode = keyof typeof bcbs_renewalmonthcode;

	export const customertypecode = {
		"ConsultantBroker(2)" : {
			name: "ConsultantBroker",
			value: 2,
			order: 1,
		},
		2 : {
			name: "ConsultantBroker",
			value: 2,
			order: 1,
		},
		"Prospect(808900000)" : {
			name: "Prospect",
			value: 808900000,
			order: 2,
		},
		808900000 : {
			name: "Prospect",
			value: 808900000,
			order: 2,
		},
		"Cancelled(808900001)" : {
			name: "Cancelled",
			value: 808900001,
			order: 3,
		},
		808900001 : {
			name: "Cancelled",
			value: 808900001,
			order: 3,
		},
		"Agency(808900003)" : {
			name: "Agency",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Agency",
			value: 808900003,
			order: 4,
		},
		"External Service Vendor(808900002)" : {
			name: "External Service Vendor",
			value: 808900002,
			order: 5,
		},
		808900002 : {
			name: "External Service Vendor",
			value: 808900002,
			order: 5,
		},
		"Group(3)" : {
			name: "Group",
			value: 3,
			order: 6,
		},
		3 : {
			name: "Group",
			value: 3,
			order: 6,
		},
		"Partner Plan(5)" : {
			name: "Partner Plan",
			value: 5,
			order: 7,
		},
		5 : {
			name: "Partner Plan",
			value: 5,
			order: 7,
		},
	}
	export type Tcustomertypecode = keyof typeof customertypecode;

	export const bcbs_hidemygroupportaldashboardsection = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_hidemygroupportaldashboardsection = keyof typeof bcbs_hidemygroupportaldashboardsection;

	export const bcbs_licensed = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_licensed = keyof typeof bcbs_licensed;

	export const bcbs_accounttype = {
		"Agency(808900000)" : {
			name: "Agency",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Agency",
			value: 808900000,
			order: 1,
		},
		"Group(808900001)" : {
			name: "Group",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Group",
			value: 808900001,
			order: 2,
		},
		"Location(808900002)" : {
			name: "Location",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Location",
			value: 808900002,
			order: 3,
		},
		"Partner Plan(808900003)" : {
			name: "Partner Plan",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Partner Plan",
			value: 808900003,
			order: 4,
		},
		"Vendor(808900004)" : {
			name: "Vendor",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Vendor",
			value: 808900004,
			order: 5,
		},
		"Other(808900005)" : {
			name: "Other",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "Other",
			value: 808900005,
			order: 6,
		},
	}
	export type Tbcbs_accounttype = keyof typeof bcbs_accounttype;

	export const bcbs_partnerplan = {
		"Arizona(808900000)" : {
			name: "Arizona",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Arizona",
			value: 808900000,
			order: 1,
		},
		"Excellus(808900001)" : {
			name: "Excellus",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Excellus",
			value: 808900001,
			order: 2,
		},
		"Florida(808900002)" : {
			name: "Florida",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Florida",
			value: 808900002,
			order: 3,
		},
		"Louisiana(808900003)" : {
			name: "Louisiana",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Louisiana",
			value: 808900003,
			order: 4,
		},
		"Kansas City(808900004)" : {
			name: "Kansas City",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Kansas City",
			value: 808900004,
			order: 5,
		},
		"North Carolina(808900005)" : {
			name: "North Carolina",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "North Carolina",
			value: 808900005,
			order: 6,
		},
		"Regence(808900006)" : {
			name: "Regence",
			value: 808900006,
			order: 7,
		},
		808900006 : {
			name: "Regence",
			value: 808900006,
			order: 7,
		},
		"Western New York(808900007)" : {
			name: "Western New York",
			value: 808900007,
			order: 8,
		},
		808900007 : {
			name: "Western New York",
			value: 808900007,
			order: 8,
		},
	}
	export type Tbcbs_partnerplan = keyof typeof bcbs_partnerplan;

	export const bcbs_isrenewalcreated = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isrenewalcreated = keyof typeof bcbs_isrenewalcreated;

	export const bcbs_customerstatuscode = {
		"Prospect(808900000)" : {
			name: "Prospect",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Prospect",
			value: 808900000,
			order: 1,
		},
		"Customer(808900001)" : {
			name: "Customer",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Customer",
			value: 808900001,
			order: 2,
		},
		"Suspect(808900002)" : {
			name: "Suspect",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Suspect",
			value: 808900002,
			order: 3,
		},
		"Cancelled(808900003)" : {
			name: "Cancelled",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Cancelled",
			value: 808900003,
			order: 4,
		},
	}
	export type Tbcbs_customerstatuscode = keyof typeof bcbs_customerstatuscode;

	export const bcbs_complexity = {
		"Simple(808900000)" : {
			name: "Simple",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Simple",
			value: 808900000,
			order: 1,
		},
		"Complex(808900001)" : {
			name: "Complex",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Complex",
			value: 808900001,
			order: 2,
		},
		"Super Complex(808900002)" : {
			name: "Super Complex",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Super Complex",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_complexity = keyof typeof bcbs_complexity;

	export const bcbs_priority = {
		"Premier(808900000)" : {
			name: "Premier",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Premier",
			value: 808900000,
			order: 1,
		},
		"Standard(808900001)" : {
			name: "Standard",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Standard",
			value: 808900001,
			order: 2,
		},
	}
	export type Tbcbs_priority = keyof typeof bcbs_priority;

	export const bcbs_agenttypeofbusiness = {
		"150500(808900000)" : {
			name: "150500",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "150500",
			value: 808900000,
			order: 1,
		},
		"500(808900001)" : {
			name: "500",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "500",
			value: 808900001,
			order: 2,
		},
		"All(808900002)" : {
			name: "All",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "All",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_agenttypeofbusiness = keyof typeof bcbs_agenttypeofbusiness;

	export const bcbs_partnerplanstatus = {
		"Active(808900000)" : {
			name: "Active",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Active",
			value: 808900000,
			order: 1,
		},
		"Prospect(808900001)" : {
			name: "Prospect",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Prospect",
			value: 808900001,
			order: 2,
		},
	}
	export type Tbcbs_partnerplanstatus = keyof typeof bcbs_partnerplanstatus;

	export const bcbs_fundingtype = {
		"Administrative Services Only(808900000)" : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		"ASO with Stop Loss(808900001)" : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		"Fully Insured(808900002)" : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		"National Alliance(808900003)" : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		"Level Funded(808900004)" : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
	}
	export type Tbcbs_fundingtype = keyof typeof bcbs_fundingtype;

	export const bcbs_activerenewal = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_activerenewal = keyof typeof bcbs_activerenewal;

	export const bcbs_readyforintegration = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_readyforintegration = keyof typeof bcbs_readyforintegration;

	export const bcbs_notificationsenabled = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_notificationsenabled = keyof typeof bcbs_notificationsenabled;

	export const bcbs_portalonboarded = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_portalonboarded = keyof typeof bcbs_portalonboarded;

	export const bcbs_latestfinancialconfigurationstatus = {
		"In Progress(808900000)" : {
			name: "In Progress",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "In Progress",
			value: 808900000,
			order: 1,
		},
		"Submitted to National Alliance Stop Loss Pending(808900001)" : {
			name: "Submitted to National Alliance Stop Loss Pending",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Submitted to National Alliance Stop Loss Pending",
			value: 808900001,
			order: 2,
		},
		"Submitted to National Alliance No Stop Loss(808900004)" : {
			name: "Submitted to National Alliance No Stop Loss",
			value: 808900004,
			order: 3,
		},
		808900004 : {
			name: "Submitted to National Alliance No Stop Loss",
			value: 808900004,
			order: 3,
		},
		"Submitted to National Alliance Stop Loss Submitted(808900005)" : {
			name: "Submitted to National Alliance Stop Loss Submitted",
			value: 808900005,
			order: 4,
		},
		808900005 : {
			name: "Submitted to National Alliance Stop Loss Submitted",
			value: 808900005,
			order: 4,
		},
		"Pending Issues(808900002)" : {
			name: "Pending Issues",
			value: 808900002,
			order: 5,
		},
		808900002 : {
			name: "Pending Issues",
			value: 808900002,
			order: 5,
		},
		"Marketing Consultant Released(808900003)" : {
			name: "Marketing Consultant Released",
			value: 808900003,
			order: 6,
		},
		808900003 : {
			name: "Marketing Consultant Released",
			value: 808900003,
			order: 6,
		},
	}
	export type Tbcbs_latestfinancialconfigurationstatus = keyof typeof bcbs_latestfinancialconfigurationstatus;

	export const bcbs_lateststoplossstatus = {
		"In Progress(808900000)" : {
			name: "In Progress",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "In Progress",
			value: 808900000,
			order: 1,
		},
		"Submitted to National Alliance Stop Loss Pending(808900001)" : {
			name: "Submitted to National Alliance Stop Loss Pending",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Submitted to National Alliance Stop Loss Pending",
			value: 808900001,
			order: 2,
		},
		"Submitted to National Alliance No Stop Loss(808900004)" : {
			name: "Submitted to National Alliance No Stop Loss",
			value: 808900004,
			order: 3,
		},
		808900004 : {
			name: "Submitted to National Alliance No Stop Loss",
			value: 808900004,
			order: 3,
		},
		"Submitted to National Alliance Stop Loss Submitted(808900005)" : {
			name: "Submitted to National Alliance Stop Loss Submitted",
			value: 808900005,
			order: 4,
		},
		808900005 : {
			name: "Submitted to National Alliance Stop Loss Submitted",
			value: 808900005,
			order: 4,
		},
		"Pending Issues(808900002)" : {
			name: "Pending Issues",
			value: 808900002,
			order: 5,
		},
		808900002 : {
			name: "Pending Issues",
			value: 808900002,
			order: 5,
		},
		"Marketing Consultant Released(808900003)" : {
			name: "Marketing Consultant Released",
			value: 808900003,
			order: 6,
		},
		808900003 : {
			name: "Marketing Consultant Released",
			value: 808900003,
			order: 6,
		},
	}
	export type Tbcbs_lateststoplossstatus = keyof typeof bcbs_lateststoplossstatus;

	export const bcbs_mgconciergeprogram = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tbcbs_mgconciergeprogram = keyof typeof bcbs_mgconciergeprogram;

	export const bcbs_salesoffice = {
		"Charleston(808900002)" : {
			name: "Charleston",
			value: 808900002,
			order: 1,
		},
		808900002 : {
			name: "Charleston",
			value: 808900002,
			order: 1,
		},
		"Columbia(808900001)" : {
			name: "Columbia",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Columbia",
			value: 808900001,
			order: 2,
		},
		"Greenville(808900000)" : {
			name: "Greenville",
			value: 808900000,
			order: 3,
		},
		808900000 : {
			name: "Greenville",
			value: 808900000,
			order: 3,
		},
		"Key Accounts(808900003)" : {
			name: "Key Accounts",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Key Accounts",
			value: 808900003,
			order: 4,
		},
		"National Alliance(808900004)" : {
			name: "National Alliance",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "National Alliance",
			value: 808900004,
			order: 5,
		},
		"State Group(808900005)" : {
			name: "State Group",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "State Group",
			value: 808900005,
			order: 6,
		},
	}
	export type Tbcbs_salesoffice = keyof typeof bcbs_salesoffice;

	export const bcbs_servicingoffice = {
		"Charleston(808900002)" : {
			name: "Charleston",
			value: 808900002,
			order: 1,
		},
		808900002 : {
			name: "Charleston",
			value: 808900002,
			order: 1,
		},
		"Columbia(808900001)" : {
			name: "Columbia",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Columbia",
			value: 808900001,
			order: 2,
		},
		"Greenville(808900000)" : {
			name: "Greenville",
			value: 808900000,
			order: 3,
		},
		808900000 : {
			name: "Greenville",
			value: 808900000,
			order: 3,
		},
		"Key Accounts(808900003)" : {
			name: "Key Accounts",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Key Accounts",
			value: 808900003,
			order: 4,
		},
		"National Alliance(808900004)" : {
			name: "National Alliance",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "National Alliance",
			value: 808900004,
			order: 5,
		},
		"State Group(808900005)" : {
			name: "State Group",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "State Group",
			value: 808900005,
			order: 6,
		},
	}
	export type Tbcbs_servicingoffice = keyof typeof bcbs_servicingoffice;

	export const msdyn_gdproptout = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tmsdyn_gdproptout = keyof typeof msdyn_gdproptout;

	export const bcbs_alwaysavailableinrequestview = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_alwaysavailableinrequestview = keyof typeof bcbs_alwaysavailableinrequestview;

	export const bcbs_sameasphysicaladdress_address3 = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_sameasphysicaladdress_address3 = keyof typeof bcbs_sameasphysicaladdress_address3;

}

export namespace opportunity {
	export const bcbs_drugopportunitytypecode = {
		"New Business(808900000)" : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		"Renewal(808900001)" : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		"New Lives(808900002)" : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_drugopportunitytypecode = keyof typeof bcbs_drugopportunitytypecode;

	export const bcbs_dentalopportunitytypecode = {
		"New Business(808900000)" : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		"Renewal(808900001)" : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		"New Lives(808900002)" : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_dentalopportunitytypecode = keyof typeof bcbs_dentalopportunitytypecode;

	export const bcbs_lifeopportunitytypecode = {
		"New Business(808900000)" : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		"Renewal(808900001)" : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		"New Lives(808900002)" : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_lifeopportunitytypecode = keyof typeof bcbs_lifeopportunitytypecode;

	export const bcbs_accruehealthotheropportunitytype = {
		"New Business(808900000)" : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		"Renewal(808900001)" : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		"New Lives(808900002)" : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_accruehealthotheropportunitytype = keyof typeof bcbs_accruehealthotheropportunitytype;

	export const bcbs_stoplossopportunitytypecode = {
		"New Business(808900000)" : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		"Renewal(808900001)" : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		"New Lives(808900002)" : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_stoplossopportunitytypecode = keyof typeof bcbs_stoplossopportunitytypecode;

	export const bcbs_medicalopportunitytypecode = {
		"New Business(808900000)" : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		"Renewal(808900001)" : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		"New Lives(808900002)" : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_medicalopportunitytypecode = keyof typeof bcbs_medicalopportunitytypecode;

	export const bcbs_visionopportunitytypecode = {
		"New Business(808900000)" : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		"Renewal(808900001)" : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		"New Lives(808900002)" : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_visionopportunitytypecode = keyof typeof bcbs_visionopportunitytypecode;

	export const bcbs_accruehealthhsaopportunitytypecode = {
		"New Business(808900000)" : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		"Renewal(808900001)" : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		"New Lives(808900002)" : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_accruehealthhsaopportunitytypecode = keyof typeof bcbs_accruehealthhsaopportunitytypecode;

	export const bcbs_accruehealthhrawithdebitopptypecode = {
		"New Business(808900000)" : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		"Renewal(808900001)" : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		"New Lives(808900002)" : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_accruehealthhrawithdebitopptypecode = keyof typeof bcbs_accruehealthhrawithdebitopptypecode;

	export const bcbs_opportunitytype = {
		"New Business(808900000)" : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "New Business",
			value: 808900000,
			order: 1,
		},
		"Renewal(808900001)" : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Renewal",
			value: 808900001,
			order: 2,
		},
		"New Lives(808900002)" : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "New Lives",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_opportunitytype = keyof typeof bcbs_opportunitytype;

	export const decisionmaker = {
		"mark complete(0)" : {
			name: "mark complete",
			value: 0,
			order: 1,
		},
		0 : {
			name: "mark complete",
			value: 0,
			order: 1,
		},
		"completed(1)" : {
			name: "completed",
			value: 1,
			order: 2,
		},
		1 : {
			name: "completed",
			value: 1,
			order: 2,
		},
	}
	export type Tdecisionmaker = keyof typeof decisionmaker;

	export const budgetstatus = {
		"No Committed Budget(0)" : {
			name: "No Committed Budget",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No Committed Budget",
			value: 0,
			order: 1,
		},
		"May Buy(1)" : {
			name: "May Buy",
			value: 1,
			order: 2,
		},
		1 : {
			name: "May Buy",
			value: 1,
			order: 2,
		},
		"Can Buy(2)" : {
			name: "Can Buy",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Can Buy",
			value: 2,
			order: 3,
		},
		"Will Buy(3)" : {
			name: "Will Buy",
			value: 3,
			order: 4,
		},
		3 : {
			name: "Will Buy",
			value: 3,
			order: 4,
		},
	}
	export type Tbudgetstatus = keyof typeof budgetstatus;

	export const isprivate = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tisprivate = keyof typeof isprivate;

	export const timeline = {
		"Immediate(0)" : {
			name: "Immediate",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Immediate",
			value: 0,
			order: 1,
		},
		"This Quarter(1)" : {
			name: "This Quarter",
			value: 1,
			order: 2,
		},
		1 : {
			name: "This Quarter",
			value: 1,
			order: 2,
		},
		"Next Quarter(2)" : {
			name: "Next Quarter",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Next Quarter",
			value: 2,
			order: 3,
		},
		"This Year(3)" : {
			name: "This Year",
			value: 3,
			order: 4,
		},
		3 : {
			name: "This Year",
			value: 3,
			order: 4,
		},
		"Not known(4)" : {
			name: "Not known",
			value: 4,
			order: 5,
		},
		4 : {
			name: "Not known",
			value: 4,
			order: 5,
		},
	}
	export type Ttimeline = keyof typeof timeline;

	export const purchasetimeframe = {
		"Immediate(0)" : {
			name: "Immediate",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Immediate",
			value: 0,
			order: 1,
		},
		"This Quarter(1)" : {
			name: "This Quarter",
			value: 1,
			order: 2,
		},
		1 : {
			name: "This Quarter",
			value: 1,
			order: 2,
		},
		"Next Quarter(2)" : {
			name: "Next Quarter",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Next Quarter",
			value: 2,
			order: 3,
		},
		"This Year(3)" : {
			name: "This Year",
			value: 3,
			order: 4,
		},
		3 : {
			name: "This Year",
			value: 3,
			order: 4,
		},
		"Unknown(4)" : {
			name: "Unknown",
			value: 4,
			order: 5,
		},
		4 : {
			name: "Unknown",
			value: 4,
			order: 5,
		},
	}
	export type Tpurchasetimeframe = keyof typeof purchasetimeframe;

	export const pricingerrorcode = {
		"None(0)" : {
			name: "None",
			value: 0,
			order: 1,
		},
		0 : {
			name: "None",
			value: 0,
			order: 1,
		},
		"Detail Error(1)" : {
			name: "Detail Error",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Detail Error",
			value: 1,
			order: 2,
		},
		"Missing Price Level(2)" : {
			name: "Missing Price Level",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Missing Price Level",
			value: 2,
			order: 3,
		},
		"Inactive Price Level(3)" : {
			name: "Inactive Price Level",
			value: 3,
			order: 4,
		},
		3 : {
			name: "Inactive Price Level",
			value: 3,
			order: 4,
		},
		"Missing Quantity(4)" : {
			name: "Missing Quantity",
			value: 4,
			order: 5,
		},
		4 : {
			name: "Missing Quantity",
			value: 4,
			order: 5,
		},
		"Missing Unit Price(5)" : {
			name: "Missing Unit Price",
			value: 5,
			order: 6,
		},
		5 : {
			name: "Missing Unit Price",
			value: 5,
			order: 6,
		},
		"Missing Product(6)" : {
			name: "Missing Product",
			value: 6,
			order: 7,
		},
		6 : {
			name: "Missing Product",
			value: 6,
			order: 7,
		},
		"Invalid Product(7)" : {
			name: "Invalid Product",
			value: 7,
			order: 8,
		},
		7 : {
			name: "Invalid Product",
			value: 7,
			order: 8,
		},
		"Missing Pricing Code(8)" : {
			name: "Missing Pricing Code",
			value: 8,
			order: 9,
		},
		8 : {
			name: "Missing Pricing Code",
			value: 8,
			order: 9,
		},
		"Invalid Pricing Code(9)" : {
			name: "Invalid Pricing Code",
			value: 9,
			order: 10,
		},
		9 : {
			name: "Invalid Pricing Code",
			value: 9,
			order: 10,
		},
		"Missing UOM(10)" : {
			name: "Missing UOM",
			value: 10,
			order: 11,
		},
		10 : {
			name: "Missing UOM",
			value: 10,
			order: 11,
		},
		"Product Not In Price Level(11)" : {
			name: "Product Not In Price Level",
			value: 11,
			order: 12,
		},
		11 : {
			name: "Product Not In Price Level",
			value: 11,
			order: 12,
		},
		"Missing Price Level Amount(12)" : {
			name: "Missing Price Level Amount",
			value: 12,
			order: 13,
		},
		12 : {
			name: "Missing Price Level Amount",
			value: 12,
			order: 13,
		},
		"Missing Price Level Percentage(13)" : {
			name: "Missing Price Level Percentage",
			value: 13,
			order: 14,
		},
		13 : {
			name: "Missing Price Level Percentage",
			value: 13,
			order: 14,
		},
		"Missing Price(14)" : {
			name: "Missing Price",
			value: 14,
			order: 15,
		},
		14 : {
			name: "Missing Price",
			value: 14,
			order: 15,
		},
		"Missing Current Cost(15)" : {
			name: "Missing Current Cost",
			value: 15,
			order: 16,
		},
		15 : {
			name: "Missing Current Cost",
			value: 15,
			order: 16,
		},
		"Missing Standard Cost(16)" : {
			name: "Missing Standard Cost",
			value: 16,
			order: 17,
		},
		16 : {
			name: "Missing Standard Cost",
			value: 16,
			order: 17,
		},
		"Invalid Price Level Amount(17)" : {
			name: "Invalid Price Level Amount",
			value: 17,
			order: 18,
		},
		17 : {
			name: "Invalid Price Level Amount",
			value: 17,
			order: 18,
		},
		"Invalid Price Level Percentage(18)" : {
			name: "Invalid Price Level Percentage",
			value: 18,
			order: 19,
		},
		18 : {
			name: "Invalid Price Level Percentage",
			value: 18,
			order: 19,
		},
		"Invalid Price(19)" : {
			name: "Invalid Price",
			value: 19,
			order: 20,
		},
		19 : {
			name: "Invalid Price",
			value: 19,
			order: 20,
		},
		"Invalid Current Cost(20)" : {
			name: "Invalid Current Cost",
			value: 20,
			order: 21,
		},
		20 : {
			name: "Invalid Current Cost",
			value: 20,
			order: 21,
		},
		"Invalid Standard Cost(21)" : {
			name: "Invalid Standard Cost",
			value: 21,
			order: 22,
		},
		21 : {
			name: "Invalid Standard Cost",
			value: 21,
			order: 22,
		},
		"Invalid Rounding Policy(22)" : {
			name: "Invalid Rounding Policy",
			value: 22,
			order: 23,
		},
		22 : {
			name: "Invalid Rounding Policy",
			value: 22,
			order: 23,
		},
		"Invalid Rounding Option(23)" : {
			name: "Invalid Rounding Option",
			value: 23,
			order: 24,
		},
		23 : {
			name: "Invalid Rounding Option",
			value: 23,
			order: 24,
		},
		"Invalid Rounding Amount(24)" : {
			name: "Invalid Rounding Amount",
			value: 24,
			order: 25,
		},
		24 : {
			name: "Invalid Rounding Amount",
			value: 24,
			order: 25,
		},
		"Price Calculation Error(25)" : {
			name: "Price Calculation Error",
			value: 25,
			order: 26,
		},
		25 : {
			name: "Price Calculation Error",
			value: 25,
			order: 26,
		},
		"Invalid Discount Type(26)" : {
			name: "Invalid Discount Type",
			value: 26,
			order: 27,
		},
		26 : {
			name: "Invalid Discount Type",
			value: 26,
			order: 27,
		},
		"Discount Type Invalid State(27)" : {
			name: "Discount Type Invalid State",
			value: 27,
			order: 28,
		},
		27 : {
			name: "Discount Type Invalid State",
			value: 27,
			order: 28,
		},
		"Invalid Discount(28)" : {
			name: "Invalid Discount",
			value: 28,
			order: 29,
		},
		28 : {
			name: "Invalid Discount",
			value: 28,
			order: 29,
		},
		"Invalid Quantity(29)" : {
			name: "Invalid Quantity",
			value: 29,
			order: 30,
		},
		29 : {
			name: "Invalid Quantity",
			value: 29,
			order: 30,
		},
		"Invalid Pricing Precision(30)" : {
			name: "Invalid Pricing Precision",
			value: 30,
			order: 31,
		},
		30 : {
			name: "Invalid Pricing Precision",
			value: 30,
			order: 31,
		},
		"Missing Product Default UOM(31)" : {
			name: "Missing Product Default UOM",
			value: 31,
			order: 32,
		},
		31 : {
			name: "Missing Product Default UOM",
			value: 31,
			order: 32,
		},
		"Missing Product UOM Schedule (32)" : {
			name: "Missing Product UOM Schedule ",
			value: 32,
			order: 33,
		},
		32 : {
			name: "Missing Product UOM Schedule ",
			value: 32,
			order: 33,
		},
		"Inactive Discount Type(33)" : {
			name: "Inactive Discount Type",
			value: 33,
			order: 34,
		},
		33 : {
			name: "Inactive Discount Type",
			value: 33,
			order: 34,
		},
		"Invalid Price Level Currency(34)" : {
			name: "Invalid Price Level Currency",
			value: 34,
			order: 35,
		},
		34 : {
			name: "Invalid Price Level Currency",
			value: 34,
			order: 35,
		},
		"Price Attribute Out Of Range(35)" : {
			name: "Price Attribute Out Of Range",
			value: 35,
			order: 36,
		},
		35 : {
			name: "Price Attribute Out Of Range",
			value: 35,
			order: 36,
		},
		"Base Currency Attribute Overflow(36)" : {
			name: "Base Currency Attribute Overflow",
			value: 36,
			order: 37,
		},
		36 : {
			name: "Base Currency Attribute Overflow",
			value: 36,
			order: 37,
		},
		"Base Currency Attribute Underflow(37)" : {
			name: "Base Currency Attribute Underflow",
			value: 37,
			order: 38,
		},
		37 : {
			name: "Base Currency Attribute Underflow",
			value: 37,
			order: 38,
		},
		"Transaction currency is not set for the product price list item(38)" : {
			name: "Transaction currency is not set for the product price list item",
			value: 38,
			order: 39,
		},
		38 : {
			name: "Transaction currency is not set for the product price list item",
			value: 38,
			order: 39,
		},
	}
	export type Tpricingerrorcode = keyof typeof pricingerrorcode;

	export const participatesinworkflow = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tparticipatesinworkflow = keyof typeof participatesinworkflow;

	export const isrevenuesystemcalculated = {
		"System Calculated(1)" : {
			name: "System Calculated",
			value: 1,
			order: 1,
		},
		1 : {
			name: "System Calculated",
			value: 1,
			order: 1,
		},
		"User Provided(0)" : {
			name: "User Provided",
			value: 0,
			order: 2,
		},
		0 : {
			name: "User Provided",
			value: 0,
			order: 2,
		},
	}
	export type Tisrevenuesystemcalculated = keyof typeof isrevenuesystemcalculated;

	export const identifycompetitors = {
		"mark complete(0)" : {
			name: "mark complete",
			value: 0,
			order: 1,
		},
		0 : {
			name: "mark complete",
			value: 0,
			order: 1,
		},
		"completed(1)" : {
			name: "completed",
			value: 1,
			order: 2,
		},
		1 : {
			name: "completed",
			value: 1,
			order: 2,
		},
	}
	export type Tidentifycompetitors = keyof typeof identifycompetitors;

	export const initialcommunication = {
		"Contacted(0)" : {
			name: "Contacted",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Contacted",
			value: 0,
			order: 1,
		},
		"Not Contacted(1)" : {
			name: "Not Contacted",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Not Contacted",
			value: 1,
			order: 2,
		},
	}
	export type Tinitialcommunication = keyof typeof initialcommunication;

	export const need = {
		"Must have(0)" : {
			name: "Must have",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Must have",
			value: 0,
			order: 1,
		},
		"Should have(1)" : {
			name: "Should have",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Should have",
			value: 1,
			order: 2,
		},
		"Good to have(2)" : {
			name: "Good to have",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Good to have",
			value: 2,
			order: 3,
		},
		"No need(3)" : {
			name: "No need",
			value: 3,
			order: 4,
		},
		3 : {
			name: "No need",
			value: 3,
			order: 4,
		},
	}
	export type Tneed = keyof typeof need;

	export const evaluatefit = {
		"Yes(0)" : {
			name: "Yes",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Yes",
			value: 0,
			order: 1,
		},
		"No(1)" : {
			name: "No",
			value: 1,
			order: 2,
		},
		1 : {
			name: "No",
			value: 1,
			order: 2,
		},
	}
	export type Tevaluatefit = keyof typeof evaluatefit;

	export const captureproposalfeedback = {
		"Yes(0)" : {
			name: "Yes",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Yes",
			value: 0,
			order: 1,
		},
		"No(1)" : {
			name: "No",
			value: 1,
			order: 2,
		},
		1 : {
			name: "No",
			value: 1,
			order: 2,
		},
	}
	export type Tcaptureproposalfeedback = keyof typeof captureproposalfeedback;

	export const statuscode = {
		"In Progress(1)" : {
			name: "In Progress",
			value: 1,
			order: 1,
		},
		1 : {
			name: "In Progress",
			value: 1,
			order: 1,
		},
		"On Hold(2)" : {
			name: "On Hold",
			value: 2,
			order: 2,
		},
		2 : {
			name: "On Hold",
			value: 2,
			order: 2,
		},
		"Won(3)" : {
			name: "Won",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Won",
			value: 3,
			order: 3,
		},
		"Canceled(4)" : {
			name: "Canceled",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Canceled",
			value: 4,
			order: 4,
		},
		"OutSold(5)" : {
			name: "OutSold",
			value: 5,
			order: 5,
		},
		5 : {
			name: "OutSold",
			value: 5,
			order: 5,
		},
		"Opportunity Created in Error(6)" : {
			name: "Opportunity Created in Error",
			value: 6,
			order: 6,
		},
		6 : {
			name: "Opportunity Created in Error",
			value: 6,
			order: 6,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const statecode = {
		"Open(0)" : {
			name: "Open",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Open",
			value: 0,
			order: 1,
		},
		"Won(1)" : {
			name: "Won",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Won",
			value: 1,
			order: 2,
		},
		"Lost(2)" : {
			name: "Lost",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Lost",
			value: 2,
			order: 3,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const presentfinalproposal = {
		"mark complete(0)" : {
			name: "mark complete",
			value: 0,
			order: 1,
		},
		0 : {
			name: "mark complete",
			value: 0,
			order: 1,
		},
		"completed(1)" : {
			name: "completed",
			value: 1,
			order: 2,
		},
		1 : {
			name: "completed",
			value: 1,
			order: 2,
		},
	}
	export type Tpresentfinalproposal = keyof typeof presentfinalproposal;

	export const confirminterest = {
		"Yes(0)" : {
			name: "Yes",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Yes",
			value: 0,
			order: 1,
		},
		"No(1)" : {
			name: "No",
			value: 1,
			order: 2,
		},
		1 : {
			name: "No",
			value: 1,
			order: 2,
		},
	}
	export type Tconfirminterest = keyof typeof confirminterest;

	export const identifycustomercontacts = {
		"mark complete(0)" : {
			name: "mark complete",
			value: 0,
			order: 1,
		},
		0 : {
			name: "mark complete",
			value: 0,
			order: 1,
		},
		"completed(1)" : {
			name: "completed",
			value: 1,
			order: 2,
		},
		1 : {
			name: "completed",
			value: 1,
			order: 2,
		},
	}
	export type Tidentifycustomercontacts = keyof typeof identifycustomercontacts;

	export const purchaseprocess = {
		"Individual(0)" : {
			name: "Individual",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Individual",
			value: 0,
			order: 1,
		},
		"Committee(1)" : {
			name: "Committee",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Committee",
			value: 1,
			order: 2,
		},
		"Unknown(2)" : {
			name: "Unknown",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Unknown",
			value: 2,
			order: 3,
		},
	}
	export type Tpurchaseprocess = keyof typeof purchaseprocess;

	export const prioritycode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Tprioritycode = keyof typeof prioritycode;

	export const identifypursuitteam = {
		"mark complete(0)" : {
			name: "mark complete",
			value: 0,
			order: 1,
		},
		0 : {
			name: "mark complete",
			value: 0,
			order: 1,
		},
		"completed(1)" : {
			name: "completed",
			value: 1,
			order: 2,
		},
		1 : {
			name: "completed",
			value: 1,
			order: 2,
		},
	}
	export type Tidentifypursuitteam = keyof typeof identifypursuitteam;

	export const opportunityratingcode = {
		"Hot(1)" : {
			name: "Hot",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Hot",
			value: 1,
			order: 1,
		},
		"Warm(2)" : {
			name: "Warm",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Warm",
			value: 2,
			order: 2,
		},
		"Cold(3)" : {
			name: "Cold",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Cold",
			value: 3,
			order: 3,
		},
	}
	export type Topportunityratingcode = keyof typeof opportunityratingcode;

	export const resolvefeedback = {
		"Yes(0)" : {
			name: "Yes",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Yes",
			value: 0,
			order: 1,
		},
		"No(1)" : {
			name: "No",
			value: 1,
			order: 2,
		},
		1 : {
			name: "No",
			value: 1,
			order: 2,
		},
	}
	export type Tresolvefeedback = keyof typeof resolvefeedback;

	export const salesstage = {
		"Qualify(0)" : {
			name: "Qualify",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Qualify",
			value: 0,
			order: 1,
		},
		"Develop(1)" : {
			name: "Develop",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Develop",
			value: 1,
			order: 2,
		},
		"Propose(2)" : {
			name: "Propose",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Propose",
			value: 2,
			order: 3,
		},
		"Close(3)" : {
			name: "Close",
			value: 3,
			order: 4,
		},
		3 : {
			name: "Close",
			value: 3,
			order: 4,
		},
	}
	export type Tsalesstage = keyof typeof salesstage;

	export const pursuitdecision = {
		"Yes(0)" : {
			name: "Yes",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Yes",
			value: 0,
			order: 1,
		},
		"No(1)" : {
			name: "No",
			value: 1,
			order: 2,
		},
		1 : {
			name: "No",
			value: 1,
			order: 2,
		},
	}
	export type Tpursuitdecision = keyof typeof pursuitdecision;

	export const skippricecalculation = {
		"DoPriceCalcAlways(0)" : {
			name: "DoPriceCalcAlways",
			value: 0,
			order: 1,
		},
		0 : {
			name: "DoPriceCalcAlways",
			value: 0,
			order: 1,
		},
		"SkipPriceCalcOnRetrieve(1)" : {
			name: "SkipPriceCalcOnRetrieve",
			value: 1,
			order: 2,
		},
		1 : {
			name: "SkipPriceCalcOnRetrieve",
			value: 1,
			order: 2,
		},
	}
	export type Tskippricecalculation = keyof typeof skippricecalculation;

	export const msdyn_forecastcategory = {
		"Pipeline(100000001)" : {
			name: "Pipeline",
			value: 100000001,
			order: 1,
		},
		100000001 : {
			name: "Pipeline",
			value: 100000001,
			order: 1,
		},
		"Best case(100000002)" : {
			name: "Best case",
			value: 100000002,
			order: 2,
		},
		100000002 : {
			name: "Best case",
			value: 100000002,
			order: 2,
		},
		"Committed(100000003)" : {
			name: "Committed",
			value: 100000003,
			order: 3,
		},
		100000003 : {
			name: "Committed",
			value: 100000003,
			order: 3,
		},
		"Omitted(100000004)" : {
			name: "Omitted",
			value: 100000004,
			order: 4,
		},
		100000004 : {
			name: "Omitted",
			value: 100000004,
			order: 4,
		},
		"Won(100000005)" : {
			name: "Won",
			value: 100000005,
			order: 5,
		},
		100000005 : {
			name: "Won",
			value: 100000005,
			order: 5,
		},
		"Lost(100000006)" : {
			name: "Lost",
			value: 100000006,
			order: 6,
		},
		100000006 : {
			name: "Lost",
			value: 100000006,
			order: 6,
		},
	}
	export type Tmsdyn_forecastcategory = keyof typeof msdyn_forecastcategory;

	export const bcbs_reasonforquotepharmacy = {
		"Current rates high(808900000)" : {
			name: "Current rates high",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Current rates high",
			value: 808900000,
			order: 1,
		},
		"Renewal increase over budget(808900001)" : {
			name: "Renewal increase over budget",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Renewal increase over budget",
			value: 808900001,
			order: 2,
		},
		"Network bad match for Ees(808900002)" : {
			name: "Network bad match for Ees",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Network bad match for Ees",
			value: 808900002,
			order: 3,
		},
		"Inadequate network discounts(808900003)" : {
			name: "Inadequate network discounts",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Inadequate network discounts",
			value: 808900003,
			order: 4,
		},
		"Service issues(808900004)" : {
			name: "Service issues",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Service issues",
			value: 808900004,
			order: 5,
		},
		"Insufficient detail in reporting(808900005)" : {
			name: "Insufficient detail in reporting",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "Insufficient detail in reporting",
			value: 808900005,
			order: 6,
		},
		"Other(808900006)" : {
			name: "Other",
			value: 808900006,
			order: 7,
		},
		808900006 : {
			name: "Other",
			value: 808900006,
			order: 7,
		},
	}
	export type Tbcbs_reasonforquotepharmacy = keyof typeof bcbs_reasonforquotepharmacy;

	export const bcbs_drugoutcome = {
		"Open(808900000)" : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		"Won(808900001)" : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		"Lost(808900002)" : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		"NA(808900003)" : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
	}
	export type Tbcbs_drugoutcome = keyof typeof bcbs_drugoutcome;

	export const bcbs_percenttowinrenewvision = {
		"0(808900000)" : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		"20(808900001)" : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		"40(808900002)" : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		"60(808900003)" : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		"80(808900004)" : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		"100(808900005)" : {
			name: "100",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "100",
			value: 808900005,
			order: 6,
		},
	}
	export type Tbcbs_percenttowinrenewvision = keyof typeof bcbs_percenttowinrenewvision;

	export const bcbs_accruehealthhrawithdebitcardoutcome = {
		"Open(808900000)" : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		"Won(808900001)" : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		"Lost(808900002)" : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		"NA(808900003)" : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
	}
	export type Tbcbs_accruehealthhrawithdebitcardoutcome = keyof typeof bcbs_accruehealthhrawithdebitcardoutcome;

	export const bcbs_hasmultiplefundingtypes_dental = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_hasmultiplefundingtypes_dental = keyof typeof bcbs_hasmultiplefundingtypes_dental;

	export const bcbs_reasonforquotestoploss = {
		"Current rates high(808900000)" : {
			name: "Current rates high",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Current rates high",
			value: 808900000,
			order: 1,
		},
		"Renewal increase over budget(808900001)" : {
			name: "Renewal increase over budget",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Renewal increase over budget",
			value: 808900001,
			order: 2,
		},
		"Network bad match for Ees(808900002)" : {
			name: "Network bad match for Ees",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Network bad match for Ees",
			value: 808900002,
			order: 3,
		},
		"Inadequate network discounts(808900003)" : {
			name: "Inadequate network discounts",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Inadequate network discounts",
			value: 808900003,
			order: 4,
		},
		"Service issues(808900004)" : {
			name: "Service issues",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Service issues",
			value: 808900004,
			order: 5,
		},
		"Insufficient detail in reporting(808900005)" : {
			name: "Insufficient detail in reporting",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "Insufficient detail in reporting",
			value: 808900005,
			order: 6,
		},
		"Other(808900006)" : {
			name: "Other",
			value: 808900006,
			order: 7,
		},
		808900006 : {
			name: "Other",
			value: 808900006,
			order: 7,
		},
	}
	export type Tbcbs_reasonforquotestoploss = keyof typeof bcbs_reasonforquotestoploss;

	export const bcbs_medicaloutcome = {
		"Open(808900000)" : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		"Won(808900001)" : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		"Lost(808900002)" : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		"NA(808900003)" : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
	}
	export type Tbcbs_medicaloutcome = keyof typeof bcbs_medicaloutcome;

	export const bcbs_issnapshotcreated = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_issnapshotcreated = keyof typeof bcbs_issnapshotcreated;

	export const bcbs_fundingtype_dentalcode = {
		"Administrative Services Only(808900000)" : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		"ASO with Stop Loss(808900001)" : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		"Fully Insured(808900002)" : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		"National Alliance(808900003)" : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		"Level Funded(808900004)" : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
	}
	export type Tbcbs_fundingtype_dentalcode = keyof typeof bcbs_fundingtype_dentalcode;

	export const bcbs_pendinginformationunderwritingcode = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_pendinginformationunderwritingcode = keyof typeof bcbs_pendinginformationunderwritingcode;

	export const bcbs_percenttowinrenewstoploss = {
		"0(808900000)" : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		"20(808900001)" : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		"40(808900002)" : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		"60(808900003)" : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		"80(808900004)" : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		"100(808900005)" : {
			name: "100",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "100",
			value: 808900005,
			order: 6,
		},
	}
	export type Tbcbs_percenttowinrenewstoploss = keyof typeof bcbs_percenttowinrenewstoploss;

	export const bcbs_stoplossoutcome = {
		"Open(808900000)" : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		"Won(808900001)" : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		"Lost(808900002)" : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		"NA(808900003)" : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
	}
	export type Tbcbs_stoplossoutcome = keyof typeof bcbs_stoplossoutcome;

	export const bcbs_lineofbusiness = {
		"FEP(808900006)" : {
			name: "FEP",
			value: 808900006,
			order: 1,
		},
		808900006 : {
			name: "FEP",
			value: 808900006,
			order: 1,
		},
		"GI(808900000)" : {
			name: "GI",
			value: 808900000,
			order: 2,
		},
		808900000 : {
			name: "GI",
			value: 808900000,
			order: 2,
		},
		"State Group(808900005)" : {
			name: "State Group",
			value: 808900005,
			order: 3,
		},
		808900005 : {
			name: "State Group",
			value: 808900005,
			order: 3,
		},
		"Major Group(808900003)" : {
			name: "Major Group",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Major Group",
			value: 808900003,
			order: 4,
		},
		"National Alliance(808900001)" : {
			name: "National Alliance",
			value: 808900001,
			order: 5,
		},
		808900001 : {
			name: "National Alliance",
			value: 808900001,
			order: 5,
		},
		"BlueChoice(808900002)" : {
			name: "BlueChoice",
			value: 808900002,
			order: 6,
		},
		808900002 : {
			name: "BlueChoice",
			value: 808900002,
			order: 6,
		},
		"GI(808900004)" : {
			name: "GI",
			value: 808900004,
			order: 7,
		},
		808900004 : {
			name: "GI",
			value: 808900004,
			order: 7,
		},
	}
	export type Tbcbs_lineofbusiness = keyof typeof bcbs_lineofbusiness;

	export const bcbs_pendinginformationdecisioncode = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_pendinginformationdecisioncode = keyof typeof bcbs_pendinginformationdecisioncode;

	export const bcbs_finalist = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_finalist = keyof typeof bcbs_finalist;

	export const bcbs_percenttowinrenewaccruehlthhrawdebit = {
		"0(808900000)" : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		"20(808900001)" : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		"40(808900002)" : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		"60(808900003)" : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		"80(808900004)" : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		"100(808900005)" : {
			name: "100",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "100",
			value: 808900005,
			order: 6,
		},
	}
	export type Tbcbs_percenttowinrenewaccruehlthhrawdebit = keyof typeof bcbs_percenttowinrenewaccruehlthhrawdebit;

	export const bcbs_atrisk = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_atrisk = keyof typeof bcbs_atrisk;

	export const salesstagecode = {
		"Initial Contact(1)" : {
			name: "Initial Contact",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Initial Contact",
			value: 1,
			order: 1,
		},
		"RFP Received(808900001)" : {
			name: "RFP Received",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "RFP Received",
			value: 808900001,
			order: 2,
		},
		"Submitted to Underwriting(808900002)" : {
			name: "Submitted to Underwriting",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Submitted to Underwriting",
			value: 808900002,
			order: 3,
		},
		"Submitted to Partner(808900003)" : {
			name: "Submitted to Partner",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Submitted to Partner",
			value: 808900003,
			order: 4,
		},
		"Submitted to Client(808900004)" : {
			name: "Submitted to Client",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Submitted to Client",
			value: 808900004,
			order: 5,
		},
		"Pending Information(808900005)" : {
			name: "Pending Information",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "Pending Information",
			value: 808900005,
			order: 6,
		},
		"Pending Additional Information(808900006)" : {
			name: "Pending Additional Information",
			value: 808900006,
			order: 7,
		},
		808900006 : {
			name: "Pending Additional Information",
			value: 808900006,
			order: 7,
		},
		"Pending Cancellation(808900007)" : {
			name: "Pending Cancellation",
			value: 808900007,
			order: 8,
		},
		808900007 : {
			name: "Pending Cancellation",
			value: 808900007,
			order: 8,
		},
		"Decision Pending(808900008)" : {
			name: "Decision Pending",
			value: 808900008,
			order: 9,
		},
		808900008 : {
			name: "Decision Pending",
			value: 808900008,
			order: 9,
		},
		"Complete(808900009)" : {
			name: "Complete",
			value: 808900009,
			order: 10,
		},
		808900009 : {
			name: "Complete",
			value: 808900009,
			order: 10,
		},
	}
	export type Tsalesstagecode = keyof typeof salesstagecode;

	export const bcbs_quotingadditionalproductscode = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_quotingadditionalproductscode = keyof typeof bcbs_quotingadditionalproductscode;

	export const bcbs_life = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_life = keyof typeof bcbs_life;

	export const bcbs_reasonforquotedental = {
		"Current rates high(808900000)" : {
			name: "Current rates high",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Current rates high",
			value: 808900000,
			order: 1,
		},
		"Renewal increase over budget(808900001)" : {
			name: "Renewal increase over budget",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Renewal increase over budget",
			value: 808900001,
			order: 2,
		},
		"Network bad match for Ees(808900002)" : {
			name: "Network bad match for Ees",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Network bad match for Ees",
			value: 808900002,
			order: 3,
		},
		"Inadequate network discounts(808900003)" : {
			name: "Inadequate network discounts",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Inadequate network discounts",
			value: 808900003,
			order: 4,
		},
		"Service issues(808900004)" : {
			name: "Service issues",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Service issues",
			value: 808900004,
			order: 5,
		},
		"Insufficient detail in reporting(808900005)" : {
			name: "Insufficient detail in reporting",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "Insufficient detail in reporting",
			value: 808900005,
			order: 6,
		},
		"Other(808900006)" : {
			name: "Other",
			value: 808900006,
			order: 7,
		},
		808900006 : {
			name: "Other",
			value: 808900006,
			order: 7,
		},
	}
	export type Tbcbs_reasonforquotedental = keyof typeof bcbs_reasonforquotedental;

	export const bcbs_pendingcancelationcode = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_pendingcancelationcode = keyof typeof bcbs_pendingcancelationcode;

	export const bcbs_accruehealthhsaincludeingoal = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_accruehealthhsaincludeingoal = keyof typeof bcbs_accruehealthhsaincludeingoal;

	export const bcbs_percenttowinrenewaccruehealthother = {
		"0(808900000)" : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		"20(808900001)" : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		"40(808900002)" : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		"60(808900003)" : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		"80(808900004)" : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		"100(808900005)" : {
			name: "100",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "100",
			value: 808900005,
			order: 6,
		},
	}
	export type Tbcbs_percenttowinrenewaccruehealthother = keyof typeof bcbs_percenttowinrenewaccruehealthother;

	export const bcbs_accruehealthotherincludeingoal = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_accruehealthotherincludeingoal = keyof typeof bcbs_accruehealthotherincludeingoal;

	export const bcbs_potentialforwinningadditionalbusinesscode = {
		"0(808900000)" : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		"20(808900001)" : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		"40(808900002)" : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		"60(808900003)" : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		"80(808900004)" : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		"100(808900005)" : {
			name: "100",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "100",
			value: 808900005,
			order: 6,
		},
	}
	export type Tbcbs_potentialforwinningadditionalbusinesscode = keyof typeof bcbs_potentialforwinningadditionalbusinesscode;

	export const bcbs_fundingtype_medicalcode = {
		"Administrative Services Only(808900000)" : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		"ASO with Stop Loss(808900001)" : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		"Fully Insured(808900002)" : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		"National Alliance(808900003)" : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		"Level Funded(808900004)" : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
	}
	export type Tbcbs_fundingtype_medicalcode = keyof typeof bcbs_fundingtype_medicalcode;

	export const bcbs_vision = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_vision = keyof typeof bcbs_vision;

	export const bcbs_pendingrenewalcode = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_pendingrenewalcode = keyof typeof bcbs_pendingrenewalcode;

	export const bcbs_percenttowinrenew_medical = {
		"0(808900000)" : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		"20(808900001)" : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		"40(808900002)" : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		"60(808900003)" : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		"80(808900004)" : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		"100(808900005)" : {
			name: "100",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "100",
			value: 808900005,
			order: 6,
		},
	}
	export type Tbcbs_percenttowinrenew_medical = keyof typeof bcbs_percenttowinrenew_medical;

	export const bcbs_medical = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_medical = keyof typeof bcbs_medical;

	export const bcbs_percenttowinrenewaccruehealthhsa = {
		"0(808900000)" : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		"20(808900001)" : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		"40(808900002)" : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		"60(808900003)" : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		"80(808900004)" : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		"100(808900005)" : {
			name: "100",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "100",
			value: 808900005,
			order: 6,
		},
	}
	export type Tbcbs_percenttowinrenewaccruehealthhsa = keyof typeof bcbs_percenttowinrenewaccruehealthhsa;

	export const bcbs_dentaloutcome = {
		"Open(808900000)" : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		"Won(808900001)" : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		"Lost(808900002)" : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		"NA(808900003)" : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
	}
	export type Tbcbs_dentaloutcome = keyof typeof bcbs_dentaloutcome;

	export const bcbs_pendinginformationrenewalscode = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_pendinginformationrenewalscode = keyof typeof bcbs_pendinginformationrenewalscode;

	export const bcbs_creatingoptionscode = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_creatingoptionscode = keyof typeof bcbs_creatingoptionscode;

	export const bcbs_dental = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_dental = keyof typeof bcbs_dental;

	export const bcbs_accruehealthhrawithdebitinclingoal = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_accruehealthhrawithdebitinclingoal = keyof typeof bcbs_accruehealthhrawithdebitinclingoal;

	export const bcbs_accruehealthother = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_accruehealthother = keyof typeof bcbs_accruehealthother;

	export const bcbs_processstoplosspending = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_processstoplosspending = keyof typeof bcbs_processstoplosspending;

	export const bcbs_dentalincludeingoal = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_dentalincludeingoal = keyof typeof bcbs_dentalincludeingoal;

	export const bcbs_stoploss = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_stoploss = keyof typeof bcbs_stoploss;

	export const bcbs_accruehealthhrawithdebitcard = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_accruehealthhrawithdebitcard = keyof typeof bcbs_accruehealthhrawithdebitcard;

	export const bcbs_lifeincludeingoal = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_lifeincludeingoal = keyof typeof bcbs_lifeincludeingoal;

	export const bcbs_percenttowinrenewdrug = {
		"0(808900000)" : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		"20(808900001)" : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		"40(808900002)" : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		"60(808900003)" : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		"80(808900004)" : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		"100(808900005)" : {
			name: "100",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "100",
			value: 808900005,
			order: 6,
		},
	}
	export type Tbcbs_percenttowinrenewdrug = keyof typeof bcbs_percenttowinrenewdrug;

	export const bcbs_visionoutcome = {
		"Open(808900000)" : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		"Won(808900001)" : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		"Lost(808900002)" : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		"NA(808900003)" : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
	}
	export type Tbcbs_visionoutcome = keyof typeof bcbs_visionoutcome;

	export const bcbs_hasmultiplefundingtypes_medical = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_hasmultiplefundingtypes_medical = keyof typeof bcbs_hasmultiplefundingtypes_medical;

	export const bcbs_accruehealthhsaoutcome = {
		"Open(808900000)" : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		"Won(808900001)" : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		"Lost(808900002)" : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		"NA(808900003)" : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
	}
	export type Tbcbs_accruehealthhsaoutcome = keyof typeof bcbs_accruehealthhsaoutcome;

	export const bcbs_accruehealthhsa = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_accruehealthhsa = keyof typeof bcbs_accruehealthhsa;

	export const bcbs_potentialforwinningopportunitycode = {
		"0(808900000)" : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		"20(808900001)" : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		"40(808900002)" : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		"60(808900003)" : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		"80(808900004)" : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		"100(808900005)" : {
			name: "100",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "100",
			value: 808900005,
			order: 6,
		},
	}
	export type Tbcbs_potentialforwinningopportunitycode = keyof typeof bcbs_potentialforwinningopportunitycode;

	export const bcbs_status = {
		"Open(808900000)" : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		"Won(808900001)" : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		"Lost(808900002)" : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		"NA(808900003)" : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
	}
	export type Tbcbs_status = keyof typeof bcbs_status;

	export const bcbs_medicalincludeingoal = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_medicalincludeingoal = keyof typeof bcbs_medicalincludeingoal;

	export const bcbs_lifeoutcome = {
		"Open(808900000)" : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		"Won(808900001)" : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		"Lost(808900002)" : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		"NA(808900003)" : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
	}
	export type Tbcbs_lifeoutcome = keyof typeof bcbs_lifeoutcome;

	export const bcbs_drug = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_drug = keyof typeof bcbs_drug;

	export const bcbs_requestedfactorscode = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_requestedfactorscode = keyof typeof bcbs_requestedfactorscode;

	export const bcbs_reasonforquotemedical = {
		"Current rates high(808900000)" : {
			name: "Current rates high",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Current rates high",
			value: 808900000,
			order: 1,
		},
		"Renewal increase over budget(808900001)" : {
			name: "Renewal increase over budget",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Renewal increase over budget",
			value: 808900001,
			order: 2,
		},
		"Network bad match for Ees(808900002)" : {
			name: "Network bad match for Ees",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Network bad match for Ees",
			value: 808900002,
			order: 3,
		},
		"Inadequate network discounts(808900003)" : {
			name: "Inadequate network discounts",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Inadequate network discounts",
			value: 808900003,
			order: 4,
		},
		"Service issues(808900004)" : {
			name: "Service issues",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Service issues",
			value: 808900004,
			order: 5,
		},
		"Insufficient detail in reporting(808900005)" : {
			name: "Insufficient detail in reporting",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "Insufficient detail in reporting",
			value: 808900005,
			order: 6,
		},
		"Other(808900006)" : {
			name: "Other",
			value: 808900006,
			order: 7,
		},
		808900006 : {
			name: "Other",
			value: 808900006,
			order: 7,
		},
	}
	export type Tbcbs_reasonforquotemedical = keyof typeof bcbs_reasonforquotemedical;

	export const bcbs_percenttowinrenewdental = {
		"0(808900000)" : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		"20(808900001)" : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		"40(808900002)" : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		"60(808900003)" : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		"80(808900004)" : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		"100(808900005)" : {
			name: "100",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "100",
			value: 808900005,
			order: 6,
		},
	}
	export type Tbcbs_percenttowinrenewdental = keyof typeof bcbs_percenttowinrenewdental;

	export const bcbs_potentialforlosinggroupcode = {
		"0(808900000)" : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "0",
			value: 808900000,
			order: 1,
		},
		"20(808900001)" : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "20",
			value: 808900001,
			order: 2,
		},
		"40(808900002)" : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "40",
			value: 808900002,
			order: 3,
		},
		"60(808900003)" : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "60",
			value: 808900003,
			order: 4,
		},
		"80(808900004)" : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "80",
			value: 808900004,
			order: 5,
		},
		"100(808900005)" : {
			name: "100",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "100",
			value: 808900005,
			order: 6,
		},
	}
	export type Tbcbs_potentialforlosinggroupcode = keyof typeof bcbs_potentialforlosinggroupcode;

	export const bcbs_accruehealthotheroutcome = {
		"Open(808900000)" : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		"Won(808900001)" : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		"Lost(808900002)" : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		"NA(808900003)" : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
	}
	export type Tbcbs_accruehealthotheroutcome = keyof typeof bcbs_accruehealthotheroutcome;

	export const msdyn_opportunitygrade = {
		"Grade A(0)" : {
			name: "Grade A",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Grade A",
			value: 0,
			order: 1,
		},
		"Grade B(1)" : {
			name: "Grade B",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Grade B",
			value: 1,
			order: 2,
		},
		"Grade C(2)" : {
			name: "Grade C",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Grade C",
			value: 2,
			order: 3,
		},
		"Grade D(3)" : {
			name: "Grade D",
			value: 3,
			order: 4,
		},
		3 : {
			name: "Grade D",
			value: 3,
			order: 4,
		},
	}
	export type Tmsdyn_opportunitygrade = keyof typeof msdyn_opportunitygrade;

	export const msdyn_opportunityscoretrend = {
		"Improving(0)" : {
			name: "Improving",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Improving",
			value: 0,
			order: 1,
		},
		"Steady(1)" : {
			name: "Steady",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Steady",
			value: 1,
			order: 2,
		},
		"Declining(2)" : {
			name: "Declining",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Declining",
			value: 2,
			order: 3,
		},
		"Not enough info(3)" : {
			name: "Not enough info",
			value: 3,
			order: 4,
		},
		3 : {
			name: "Not enough info",
			value: 3,
			order: 4,
		},
	}
	export type Tmsdyn_opportunityscoretrend = keyof typeof msdyn_opportunityscoretrend;

	export const msdyn_gdproptout = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tmsdyn_gdproptout = keyof typeof msdyn_gdproptout;

	export const bcbs_chamberoutcomecode = {
		"Open(808900000)" : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Open",
			value: 808900000,
			order: 1,
		},
		"Won(808900001)" : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Won",
			value: 808900001,
			order: 2,
		},
		"Lost(808900002)" : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Lost",
			value: 808900002,
			order: 3,
		},
		"NA(808900003)" : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "NA",
			value: 808900003,
			order: 4,
		},
	}
	export type Tbcbs_chamberoutcomecode = keyof typeof bcbs_chamberoutcomecode;

	export const bcbs_ischamber = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ischamber = keyof typeof bcbs_ischamber;

	export const sendthankyounote = {
		"Mark complete(0)" : {
			name: "Mark complete",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Mark complete",
			value: 0,
			order: 1,
		},
		"Completed(1)" : {
			name: "Completed",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Completed",
			value: 1,
			order: 2,
		},
	}
	export type Tsendthankyounote = keyof typeof sendthankyounote;

	export const developproposal = {
		"Mark complete(0)" : {
			name: "Mark complete",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Mark complete",
			value: 0,
			order: 1,
		},
		"Completed(1)" : {
			name: "Completed",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Completed",
			value: 1,
			order: 2,
		},
	}
	export type Tdevelopproposal = keyof typeof developproposal;

	export const filedebrief = {
		"Mark complete(0)" : {
			name: "Mark complete",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Mark complete",
			value: 0,
			order: 1,
		},
		"Completed(1)" : {
			name: "Completed",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Completed",
			value: 1,
			order: 2,
		},
	}
	export type Tfiledebrief = keyof typeof filedebrief;

	export const presentproposal = {
		"Mark complete(0)" : {
			name: "Mark complete",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Mark complete",
			value: 0,
			order: 1,
		},
		"Completed(1)" : {
			name: "Completed",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Completed",
			value: 1,
			order: 2,
		},
	}
	export type Tpresentproposal = keyof typeof presentproposal;

	export const completeinternalreview = {
		"Mark complete(0)" : {
			name: "Mark complete",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Mark complete",
			value: 0,
			order: 1,
		},
		"Completed(1)" : {
			name: "Completed",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Completed",
			value: 1,
			order: 2,
		},
	}
	export type Tcompleteinternalreview = keyof typeof completeinternalreview;

	export const completefinalproposal = {
		"Mark complete(0)" : {
			name: "Mark complete",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Mark complete",
			value: 0,
			order: 1,
		},
		"Completed(1)" : {
			name: "Completed",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Completed",
			value: 1,
			order: 2,
		},
	}
	export type Tcompletefinalproposal = keyof typeof completefinalproposal;

}

export namespace bcbs_copaycoinoption {
	export const bcbs_iscurrencyonly = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_iscurrencyonly = keyof typeof bcbs_iscurrencyonly;

	export const bcbs_ispercentageonly = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ispercentageonly = keyof typeof bcbs_ispercentageonly;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_copaycoinsurancetypecode = {
		"General(808900000)" : {
			name: "General",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "General",
			value: 808900000,
			order: 1,
		},
		"Pharmacy(808900001)" : {
			name: "Pharmacy",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Pharmacy",
			value: 808900001,
			order: 2,
		},
		"Vision(808900002)" : {
			name: "Vision",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Vision",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_copaycoinsurancetypecode = keyof typeof bcbs_copaycoinsurancetypecode;

	export const bcbs_isreleased = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isreleased = keyof typeof bcbs_isreleased;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

}

export namespace bcbs_emchecklist {
	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_ismarketingnotificationsent = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ismarketingnotificationsent = keyof typeof bcbs_ismarketingnotificationsent;

	export const statuscode = {
		"Primary Review(1)" : {
			name: "Primary Review",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Primary Review",
			value: 1,
			order: 1,
		},
		"Secondary Review(2)" : {
			name: "Secondary Review",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Secondary Review",
			value: 2,
			order: 2,
		},
		"Marketing Review(3)" : {
			name: "Marketing Review",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Marketing Review",
			value: 3,
			order: 3,
		},
		"Approved(4)" : {
			name: "Approved",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Approved",
			value: 4,
			order: 4,
		},
		"Cancelled(5)" : {
			name: "Cancelled",
			value: 5,
			order: 5,
		},
		5 : {
			name: "Cancelled",
			value: 5,
			order: 5,
		},
		"Pending Issues(6)" : {
			name: "Pending Issues",
			value: 6,
			order: 6,
		},
		6 : {
			name: "Pending Issues",
			value: 6,
			order: 6,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const bcbs_sendnotificationcode = {
		"Marketing(808900000)" : {
			name: "Marketing",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Marketing",
			value: 808900000,
			order: 1,
		},
	}
	export type Tbcbs_sendnotificationcode = keyof typeof bcbs_sendnotificationcode;

}

export namespace bcbs_groupconfigurationsnapshot {
	export const bcbs_ismnil = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ismnil = keyof typeof bcbs_ismnil;

	export const statuscode = {
		"In Progress(1)" : {
			name: "In Progress",
			value: 1,
			order: 1,
		},
		1 : {
			name: "In Progress",
			value: 1,
			order: 1,
		},
		"Corrections Pending(808900005)" : {
			name: "Corrections Pending",
			value: 808900005,
			order: 2,
		},
		808900005 : {
			name: "Corrections Pending",
			value: 808900005,
			order: 2,
		},
		"Data Entry Complete(808900000)" : {
			name: "Data Entry Complete",
			value: 808900000,
			order: 3,
		},
		808900000 : {
			name: "Data Entry Complete",
			value: 808900000,
			order: 3,
		},
		"MNIL Data Entry Complete(808900003)" : {
			name: "MNIL Data Entry Complete",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "MNIL Data Entry Complete",
			value: 808900003,
			order: 4,
		},
		"Pending Underwriting(808900009)" : {
			name: "Pending Underwriting",
			value: 808900009,
			order: 5,
		},
		808900009 : {
			name: "Pending Underwriting",
			value: 808900009,
			order: 5,
		},
		"Gold Standard(808900006)" : {
			name: "Gold Standard",
			value: 808900006,
			order: 6,
		},
		808900006 : {
			name: "Gold Standard",
			value: 808900006,
			order: 6,
		},
		"Underwriting Review Complete(2)" : {
			name: "Underwriting Review Complete",
			value: 2,
			order: 7,
		},
		2 : {
			name: "Underwriting Review Complete",
			value: 2,
			order: 7,
		},
		"Retired(808900001)" : {
			name: "Retired",
			value: 808900001,
			order: 8,
		},
		808900001 : {
			name: "Retired",
			value: 808900001,
			order: 8,
		},
		"MNIL Underwriting Complete(808900004)" : {
			name: "MNIL Underwriting Complete",
			value: 808900004,
			order: 9,
		},
		808900004 : {
			name: "MNIL Underwriting Complete",
			value: 808900004,
			order: 9,
		},
		"Merged and Closed(808900010)" : {
			name: "Merged and Closed",
			value: 808900010,
			order: 10,
		},
		808900010 : {
			name: "Merged and Closed",
			value: 808900010,
			order: 10,
		},
		"Cancelled(808900011)" : {
			name: "Cancelled",
			value: 808900011,
			order: 11,
		},
		808900011 : {
			name: "Cancelled",
			value: 808900011,
			order: 11,
		},
		"Transferred to Other LOB(808900012)" : {
			name: "Transferred to Other LOB",
			value: 808900012,
			order: 12,
		},
		808900012 : {
			name: "Transferred to Other LOB",
			value: 808900012,
			order: 12,
		},
		"Inactive(808900002)" : {
			name: "Inactive",
			value: 808900002,
			order: 13,
		},
		808900002 : {
			name: "Inactive",
			value: 808900002,
			order: 13,
		},
		"Cancellation in Progress(808900013)" : {
			name: "Cancellation in Progress",
			value: 808900013,
			order: 14,
		},
		808900013 : {
			name: "Cancellation in Progress",
			value: 808900013,
			order: 14,
		},
		"Transfer to Other LOB in Progress(808900014)" : {
			name: "Transfer to Other LOB in Progress",
			value: 808900014,
			order: 15,
		},
		808900014 : {
			name: "Transfer to Other LOB in Progress",
			value: 808900014,
			order: 15,
		},
		"Pending Power User Review(808900015)" : {
			name: "Pending Power User Review",
			value: 808900015,
			order: 16,
		},
		808900015 : {
			name: "Pending Power User Review",
			value: 808900015,
			order: 16,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const bcbs_isbypassuwandtasks = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isbypassuwandtasks = keyof typeof bcbs_isbypassuwandtasks;

	export const bcbs_isparentoverriddenbyuw = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isparentoverriddenbyuw = keyof typeof bcbs_isparentoverriddenbyuw;

	export const bcbs_iseffectivedategoldstandard = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_iseffectivedategoldstandard = keyof typeof bcbs_iseffectivedategoldstandard;

	export const bcbs_fundingtypecode = {
		"Administrative Services Only(808900000)" : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		"ASO with Stop Loss(808900001)" : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		"Fully Insured(808900002)" : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		"National Alliance(808900003)" : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		"Level Funded(808900004)" : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
		"Mixed(808900005)" : {
			name: "Mixed",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "Mixed",
			value: 808900005,
			order: 6,
		},
	}
	export type Tbcbs_fundingtypecode = keyof typeof bcbs_fundingtypecode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_istemplate = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_istemplate = keyof typeof bcbs_istemplate;

	export const bcbs_isreconciliation = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isreconciliation = keyof typeof bcbs_isreconciliation;

	export const bcbs_changetypecode = {
		"Initial Setup(808900002)" : {
			name: "Initial Setup",
			value: 808900002,
			order: 1,
		},
		808900002 : {
			name: "Initial Setup",
			value: 808900002,
			order: 1,
		},
		"Comprehensive Renewal(808900001)" : {
			name: "Comprehensive Renewal",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Comprehensive Renewal",
			value: 808900001,
			order: 2,
		},
		"Benefit Renewal(808900010)" : {
			name: "Benefit Renewal",
			value: 808900010,
			order: 3,
		},
		808900010 : {
			name: "Benefit Renewal",
			value: 808900010,
			order: 3,
		},
		"Financial Renewal(808900011)" : {
			name: "Financial Renewal",
			value: 808900011,
			order: 4,
		},
		808900011 : {
			name: "Financial Renewal",
			value: 808900011,
			order: 4,
		},
		"Comprehensive Change(808900004)" : {
			name: "Comprehensive Change",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Comprehensive Change",
			value: 808900004,
			order: 5,
		},
		"Benefit Change(808900000)" : {
			name: "Benefit Change",
			value: 808900000,
			order: 6,
		},
		808900000 : {
			name: "Benefit Change",
			value: 808900000,
			order: 6,
		},
		"Financial Change(808900006)" : {
			name: "Financial Change",
			value: 808900006,
			order: 7,
		},
		808900006 : {
			name: "Financial Change",
			value: 808900006,
			order: 7,
		},
		"Stop Loss(808900009)" : {
			name: "Stop Loss",
			value: 808900009,
			order: 8,
		},
		808900009 : {
			name: "Stop Loss",
			value: 808900009,
			order: 8,
		},
		"Administrative Change(808900003)" : {
			name: "Administrative Change",
			value: 808900003,
			order: 9,
		},
		808900003 : {
			name: "Administrative Change",
			value: 808900003,
			order: 9,
		},
		"MNIL  Initial Setup Continuation(808900005)" : {
			name: "MNIL  Initial Setup Continuation",
			value: 808900005,
			order: 10,
		},
		808900005 : {
			name: "MNIL  Initial Setup Continuation",
			value: 808900005,
			order: 10,
		},
		"MNIL  Renewal Continuation(808900008)" : {
			name: "MNIL  Renewal Continuation",
			value: 808900008,
			order: 11,
		},
		808900008 : {
			name: "MNIL  Renewal Continuation",
			value: 808900008,
			order: 11,
		},
		"MNIL  Benefit Change Continuation(808900007)" : {
			name: "MNIL  Benefit Change Continuation",
			value: 808900007,
			order: 12,
		},
		808900007 : {
			name: "MNIL  Benefit Change Continuation",
			value: 808900007,
			order: 12,
		},
		"MNIL  Comprehensive Change Continuation(808900013)" : {
			name: "MNIL  Comprehensive Change Continuation",
			value: 808900013,
			order: 13,
		},
		808900013 : {
			name: "MNIL  Comprehensive Change Continuation",
			value: 808900013,
			order: 13,
		},
		"MNIL  Comprehensive Renewal Continuation(808900014)" : {
			name: "MNIL  Comprehensive Renewal Continuation",
			value: 808900014,
			order: 14,
		},
		808900014 : {
			name: "MNIL  Comprehensive Renewal Continuation",
			value: 808900014,
			order: 14,
		},
		"PSA Change(808900012)" : {
			name: "PSA Change",
			value: 808900012,
			order: 15,
		},
		808900012 : {
			name: "PSA Change",
			value: 808900012,
			order: 15,
		},
		"Post Cancel Update(808900015)" : {
			name: "Post Cancel Update",
			value: 808900015,
			order: 16,
		},
		808900015 : {
			name: "Post Cancel Update",
			value: 808900015,
			order: 16,
		},
	}
	export type Tbcbs_changetypecode = keyof typeof bcbs_changetypecode;

	export const bcbs_iscurrentcancelledversion = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_iscurrentcancelledversion = keyof typeof bcbs_iscurrentcancelledversion;

	export const bcbs_isrevision = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isrevision = keyof typeof bcbs_isrevision;

}

export namespace bcbs_config_actionitem {
	export const bcbs_trigger = {
		"When a Group Configuration Snapshot is Created(808900000)" : {
			name: "When a Group Configuration Snapshot is Created",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "When a Group Configuration Snapshot is Created",
			value: 808900000,
			order: 1,
		},
		"When Service Data Entry is Completed(808900002)" : {
			name: "When Service Data Entry is Completed",
			value: 808900002,
			order: 2,
		},
		808900002 : {
			name: "When Service Data Entry is Completed",
			value: 808900002,
			order: 2,
		},
		"When Underwriting Review is Completed(808900003)" : {
			name: "When Underwriting Review is Completed",
			value: 808900003,
			order: 3,
		},
		808900003 : {
			name: "When Underwriting Review is Completed",
			value: 808900003,
			order: 3,
		},
		"When a Parent Task is Completed(808900004)" : {
			name: "When a Parent Task is Completed",
			value: 808900004,
			order: 4,
		},
		808900004 : {
			name: "When a Parent Task is Completed",
			value: 808900004,
			order: 4,
		},
		"When an Opportunity is Won(808900001)" : {
			name: "When an Opportunity is Won",
			value: 808900001,
			order: 5,
		},
		808900001 : {
			name: "When an Opportunity is Won",
			value: 808900001,
			order: 5,
		},
		"When MNIL Service Data Entry is Completed(808900005)" : {
			name: "When MNIL Service Data Entry is Completed",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "When MNIL Service Data Entry is Completed",
			value: 808900005,
			order: 6,
		},
		"When MNIL Underwriting Review is Completed(808900006)" : {
			name: "When MNIL Underwriting Review is Completed",
			value: 808900006,
			order: 7,
		},
		808900006 : {
			name: "When MNIL Underwriting Review is Completed",
			value: 808900006,
			order: 7,
		},
		"When a Quote Request is Released(808900007)" : {
			name: "When a Quote Request is Released",
			value: 808900007,
			order: 8,
		},
		808900007 : {
			name: "When a Quote Request is Released",
			value: 808900007,
			order: 8,
		},
		"When a Quote Request is Underwriting Review Completed(808900008)" : {
			name: "When a Quote Request is Underwriting Review Completed",
			value: 808900008,
			order: 9,
		},
		808900008 : {
			name: "When a Quote Request is Underwriting Review Completed",
			value: 808900008,
			order: 9,
		},
		"When a Revision is Requested(808900009)" : {
			name: "When a Revision is Requested",
			value: 808900009,
			order: 10,
		},
		808900009 : {
			name: "When a Revision is Requested",
			value: 808900009,
			order: 10,
		},
		"When an Event is Created(808900010)" : {
			name: "When an Event is Created",
			value: 808900010,
			order: 11,
		},
		808900010 : {
			name: "When an Event is Created",
			value: 808900010,
			order: 11,
		},
		"When a Group is Cancelled(808900011)" : {
			name: "When a Group is Cancelled",
			value: 808900011,
			order: 12,
		},
		808900011 : {
			name: "When a Group is Cancelled",
			value: 808900011,
			order: 12,
		},
	}
	export type Tbcbs_trigger = keyof typeof bcbs_trigger;

	export const bcbs_filter_nationalalliancecode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_filter_nationalalliancecode = keyof typeof bcbs_filter_nationalalliancecode;

	export const bcbs_isdisplayonbusinessrollup = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isdisplayonbusinessrollup = keyof typeof bcbs_isdisplayonbusinessrollup;

	export const bcbs_filter_majorgroupcode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_filter_majorgroupcode = keyof typeof bcbs_filter_majorgroupcode;

	export const bcbs_filter_financialchangecode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_filter_financialchangecode = keyof typeof bcbs_filter_financialchangecode;

	export const bcbs_actionitemtypecode = {
		"Task(808900000)" : {
			name: "Task",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Task",
			value: 808900000,
			order: 1,
		},
		"Email Notification(808900001)" : {
			name: "Email Notification",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Email Notification",
			value: 808900001,
			order: 2,
		},
	}
	export type Tbcbs_actionitemtypecode = keyof typeof bcbs_actionitemtypecode;

	export const bcbs_filter_benefitchangecode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_filter_benefitchangecode = keyof typeof bcbs_filter_benefitchangecode;

	export const bcbs_filter_stategroupcode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_filter_stategroupcode = keyof typeof bcbs_filter_stategroupcode;

	export const bcbs_filter_fullyinsuredcode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_filter_fullyinsuredcode = keyof typeof bcbs_filter_fullyinsuredcode;

	export const bcbs_filter_psachangecode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_filter_psachangecode = keyof typeof bcbs_filter_psachangecode;

	export const bcbs_filter_renewalcode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_filter_renewalcode = keyof typeof bcbs_filter_renewalcode;

	export const bcbs_reconciliationcode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_reconciliationcode = keyof typeof bcbs_reconciliationcode;

	export const bcbs_filter_financialrenewalcode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_filter_financialrenewalcode = keyof typeof bcbs_filter_financialrenewalcode;

	export const bcbs_filter_newimplementationcode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_filter_newimplementationcode = keyof typeof bcbs_filter_newimplementationcode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_filter_comprehensivechangecode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_filter_comprehensivechangecode = keyof typeof bcbs_filter_comprehensivechangecode;

	export const bcbs_filter_benefitrenewalcode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_filter_benefitrenewalcode = keyof typeof bcbs_filter_benefitrenewalcode;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const bcbs_filter_stoplosscode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_filter_stoplosscode = keyof typeof bcbs_filter_stoplosscode;

	export const bcbs_filter_mnilcode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_filter_mnilcode = keyof typeof bcbs_filter_mnilcode;

	export const bcbs_filter_administrativechangecode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_filter_administrativechangecode = keyof typeof bcbs_filter_administrativechangecode;

	export const bcbs_assigntospecificusercode = {
		"Line of Business(808900012)" : {
			name: "Line of Business",
			value: 808900012,
			order: 1,
		},
		808900012 : {
			name: "Line of Business",
			value: 808900012,
			order: 1,
		},
		"Sales Rep(808900000)" : {
			name: "Sales Rep",
			value: 808900000,
			order: 2,
		},
		808900000 : {
			name: "Sales Rep",
			value: 808900000,
			order: 2,
		},
		"Service Rep(808900001)" : {
			name: "Service Rep",
			value: 808900001,
			order: 3,
		},
		808900001 : {
			name: "Service Rep",
			value: 808900001,
			order: 3,
		},
		"Renewal Rep(808900002)" : {
			name: "Renewal Rep",
			value: 808900002,
			order: 4,
		},
		808900002 : {
			name: "Renewal Rep",
			value: 808900002,
			order: 4,
		},
		"Account Coordinator(808900003)" : {
			name: "Account Coordinator",
			value: 808900003,
			order: 5,
		},
		808900003 : {
			name: "Account Coordinator",
			value: 808900003,
			order: 5,
		},
		"Account Executive(808900004)" : {
			name: "Account Executive",
			value: 808900004,
			order: 6,
		},
		808900004 : {
			name: "Account Executive",
			value: 808900004,
			order: 6,
		},
		"Additional Rep(808900005)" : {
			name: "Additional Rep",
			value: 808900005,
			order: 7,
		},
		808900005 : {
			name: "Additional Rep",
			value: 808900005,
			order: 7,
		},
		"Implementation Manager(808900006)" : {
			name: "Implementation Manager",
			value: 808900006,
			order: 8,
		},
		808900006 : {
			name: "Implementation Manager",
			value: 808900006,
			order: 8,
		},
		"Underwriter(808900007)" : {
			name: "Underwriter",
			value: 808900007,
			order: 9,
		},
		808900007 : {
			name: "Underwriter",
			value: 808900007,
			order: 9,
		},
		"Admin(808900008)" : {
			name: "Admin",
			value: 808900008,
			order: 10,
		},
		808900008 : {
			name: "Admin",
			value: 808900008,
			order: 10,
		},
		"Parent Task Owner(808900009)" : {
			name: "Parent Task Owner",
			value: 808900009,
			order: 11,
		},
		808900009 : {
			name: "Parent Task Owner",
			value: 808900009,
			order: 11,
		},
		"Snapshot Created By(808900010)" : {
			name: "Snapshot Created By",
			value: 808900010,
			order: 12,
		},
		808900010 : {
			name: "Snapshot Created By",
			value: 808900010,
			order: 12,
		},
		"Distribution List Email Only(808900011)" : {
			name: "Distribution List Email Only",
			value: 808900011,
			order: 13,
		},
		808900011 : {
			name: "Distribution List Email Only",
			value: 808900011,
			order: 13,
		},
		"Strategic Account Executive(808900013)" : {
			name: "Strategic Account Executive",
			value: 808900013,
			order: 14,
		},
		808900013 : {
			name: "Strategic Account Executive",
			value: 808900013,
			order: 14,
		},
		"Client Relationship Manager(808900014)" : {
			name: "Client Relationship Manager",
			value: 808900014,
			order: 15,
		},
		808900014 : {
			name: "Client Relationship Manager",
			value: 808900014,
			order: 15,
		},
		"Client Implementation Manager(808900015)" : {
			name: "Client Implementation Manager",
			value: 808900015,
			order: 16,
		},
		808900015 : {
			name: "Client Implementation Manager",
			value: 808900015,
			order: 16,
		},
		"Account Specialist(808900016)" : {
			name: "Account Specialist",
			value: 808900016,
			order: 17,
		},
		808900016 : {
			name: "Account Specialist",
			value: 808900016,
			order: 17,
		},
		"NA Partner Plan Director(808900017)" : {
			name: "NA Partner Plan Director",
			value: 808900017,
			order: 18,
		},
		808900017 : {
			name: "NA Partner Plan Director",
			value: 808900017,
			order: 18,
		},
	}
	export type Tbcbs_assigntospecificusercode = keyof typeof bcbs_assigntospecificusercode;

	export const bcbs_postcancelupdatecode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_postcancelupdatecode = keyof typeof bcbs_postcancelupdatecode;

	export const bcbs_targeteventorigin = {
		"Clone from Parent(808900000)" : {
			name: "Clone from Parent",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Clone from Parent",
			value: 808900000,
			order: 1,
		},
		"Update(808900001)" : {
			name: "Update",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Update",
			value: 808900001,
			order: 2,
		},
	}
	export type Tbcbs_targeteventorigin = keyof typeof bcbs_targeteventorigin;

}

export namespace task {
	export const activitytypecode = {
		"Fax(4204)" : {
			name: "Fax",
			value: 4204,
			order: 1,
		},
		4204 : {
			name: "Fax",
			value: 4204,
			order: 1,
		},
		"Phone Call(4210)" : {
			name: "Phone Call",
			value: 4210,
			order: 2,
		},
		4210 : {
			name: "Phone Call",
			value: 4210,
			order: 2,
		},
		"Email(4202)" : {
			name: "Email",
			value: 4202,
			order: 3,
		},
		4202 : {
			name: "Email",
			value: 4202,
			order: 3,
		},
		"Letter(4207)" : {
			name: "Letter",
			value: 4207,
			order: 4,
		},
		4207 : {
			name: "Letter",
			value: 4207,
			order: 4,
		},
		"Appointment(4201)" : {
			name: "Appointment",
			value: 4201,
			order: 5,
		},
		4201 : {
			name: "Appointment",
			value: 4201,
			order: 5,
		},
		"Task(4212)" : {
			name: "Task",
			value: 4212,
			order: 6,
		},
		4212 : {
			name: "Task",
			value: 4212,
			order: 6,
		},
		"Recurring Appointment(4251)" : {
			name: "Recurring Appointment",
			value: 4251,
			order: 7,
		},
		4251 : {
			name: "Recurring Appointment",
			value: 4251,
			order: 7,
		},
		"Quick Campaign(4406)" : {
			name: "Quick Campaign",
			value: 4406,
			order: 8,
		},
		4406 : {
			name: "Quick Campaign",
			value: 4406,
			order: 8,
		},
		"Campaign Activity(4402)" : {
			name: "Campaign Activity",
			value: 4402,
			order: 9,
		},
		4402 : {
			name: "Campaign Activity",
			value: 4402,
			order: 9,
		},
		"Campaign Response(4401)" : {
			name: "Campaign Response",
			value: 4401,
			order: 10,
		},
		4401 : {
			name: "Campaign Response",
			value: 4401,
			order: 10,
		},
		"Request Resolution(4206)" : {
			name: "Request Resolution",
			value: 4206,
			order: 11,
		},
		4206 : {
			name: "Request Resolution",
			value: 4206,
			order: 11,
		},
		"Service Activity(4214)" : {
			name: "Service Activity",
			value: 4214,
			order: 12,
		},
		4214 : {
			name: "Service Activity",
			value: 4214,
			order: 12,
		},
		"Opportunity Close(4208)" : {
			name: "Opportunity Close",
			value: 4208,
			order: 13,
		},
		4208 : {
			name: "Opportunity Close",
			value: 4208,
			order: 13,
		},
		"Order Close(4209)" : {
			name: "Order Close",
			value: 4209,
			order: 14,
		},
		4209 : {
			name: "Order Close",
			value: 4209,
			order: 14,
		},
		"Quote Close(4211)" : {
			name: "Quote Close",
			value: 4211,
			order: 15,
		},
		4211 : {
			name: "Quote Close",
			value: 4211,
			order: 15,
		},
		"Customer Voice survey invite(10117)" : {
			name: "Customer Voice survey invite",
			value: 10117,
			order: 16,
		},
		10117 : {
			name: "Customer Voice survey invite",
			value: 10117,
			order: 16,
		},
		"Customer Voice survey response(10118)" : {
			name: "Customer Voice survey response",
			value: 10118,
			order: 17,
		},
		10118 : {
			name: "Customer Voice survey response",
			value: 10118,
			order: 17,
		},
		"Booking Alert(10126)" : {
			name: "Booking Alert",
			value: 10126,
			order: 18,
		},
		10126 : {
			name: "Booking Alert",
			value: 10126,
			order: 18,
		},
		"Alert Subscription(10194)" : {
			name: "Alert Subscription",
			value: 10194,
			order: 19,
		},
		10194 : {
			name: "Alert Subscription",
			value: 10194,
			order: 19,
		},
		"Invite Redemption(10197)" : {
			name: "Invite Redemption",
			value: 10197,
			order: 20,
		},
		10197 : {
			name: "Invite Redemption",
			value: 10197,
			order: 20,
		},
		"Portal Comment(10258)" : {
			name: "Portal Comment",
			value: 10258,
			order: 21,
		},
		10258 : {
			name: "Portal Comment",
			value: 10258,
			order: 21,
		},
		"Customer Voice alert(10288)" : {
			name: "Customer Voice alert",
			value: 10288,
			order: 22,
		},
		10288 : {
			name: "Customer Voice alert",
			value: 10288,
			order: 22,
		},
		"Activity record for the Teams chat(10696)" : {
			name: "Activity record for the Teams chat",
			value: 10696,
			order: 23,
		},
		10696 : {
			name: "Activity record for the Teams chat",
			value: 10696,
			order: 23,
		},
		"Conversation(10987)" : {
			name: "Conversation",
			value: 10987,
			order: 24,
		},
		10987 : {
			name: "Conversation",
			value: 10987,
			order: 24,
		},
		"Session(10997)" : {
			name: "Session",
			value: 10997,
			order: 25,
		},
		10997 : {
			name: "Session",
			value: 10997,
			order: 25,
		},
		"Copilot Transcript(11328)" : {
			name: "Copilot Transcript",
			value: 11328,
			order: 26,
		},
		11328 : {
			name: "Copilot Transcript",
			value: 11328,
			order: 26,
		},
	}
	export type Tactivitytypecode = keyof typeof activitytypecode;

	export const isregularactivity = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tisregularactivity = keyof typeof isregularactivity;

	export const prioritycode = {
		"Low(0)" : {
			name: "Low",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Low",
			value: 0,
			order: 1,
		},
		"Normal(1)" : {
			name: "Normal",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Normal",
			value: 1,
			order: 2,
		},
		"High(2)" : {
			name: "High",
			value: 2,
			order: 3,
		},
		2 : {
			name: "High",
			value: 2,
			order: 3,
		},
	}
	export type Tprioritycode = keyof typeof prioritycode;

	export const statecode = {
		"Open(0)" : {
			name: "Open",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Open",
			value: 0,
			order: 1,
		},
		"Completed(1)" : {
			name: "Completed",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Completed",
			value: 1,
			order: 2,
		},
		"Canceled(2)" : {
			name: "Canceled",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Canceled",
			value: 2,
			order: 3,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const statuscode = {
		"Not Assigned(2)" : {
			name: "Not Assigned",
			value: 2,
			order: 1,
		},
		2 : {
			name: "Not Assigned",
			value: 2,
			order: 1,
		},
		"Assigned(808900000)" : {
			name: "Assigned",
			value: 808900000,
			order: 2,
		},
		808900000 : {
			name: "Assigned",
			value: 808900000,
			order: 2,
		},
		"In Progress(3)" : {
			name: "In Progress",
			value: 3,
			order: 3,
		},
		3 : {
			name: "In Progress",
			value: 3,
			order: 3,
		},
		"Pending Issue(4)" : {
			name: "Pending Issue",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Pending Issue",
			value: 4,
			order: 4,
		},
		"Blocked(7)" : {
			name: "Blocked",
			value: 7,
			order: 5,
		},
		7 : {
			name: "Blocked",
			value: 7,
			order: 5,
		},
		"Pending Billing Cycle(808900001)" : {
			name: "Pending Billing Cycle",
			value: 808900001,
			order: 6,
		},
		808900001 : {
			name: "Pending Billing Cycle",
			value: 808900001,
			order: 6,
		},
		"Completed(5)" : {
			name: "Completed",
			value: 5,
			order: 7,
		},
		5 : {
			name: "Completed",
			value: 5,
			order: 7,
		},
		"Canceled(6)" : {
			name: "Canceled",
			value: 6,
			order: 8,
		},
		6 : {
			name: "Canceled",
			value: 6,
			order: 8,
		},
		"No Action Required(808900002)" : {
			name: "No Action Required",
			value: 808900002,
			order: 9,
		},
		808900002 : {
			name: "No Action Required",
			value: 808900002,
			order: 9,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const isbilled = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tisbilled = keyof typeof isbilled;

	export const isworkflowcreated = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tisworkflowcreated = keyof typeof isworkflowcreated;

	export const bcbs_statuscode = {
		"Not Assigned(808900000)" : {
			name: "Not Assigned",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Not Assigned",
			value: 808900000,
			order: 1,
		},
		"Assigned(808900001)" : {
			name: "Assigned",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Assigned",
			value: 808900001,
			order: 2,
		},
		"In Progress(808900002)" : {
			name: "In Progress",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "In Progress",
			value: 808900002,
			order: 3,
		},
		"Pending Issue(808900003)" : {
			name: "Pending Issue",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Pending Issue",
			value: 808900003,
			order: 4,
		},
		"Blocked(808900004)" : {
			name: "Blocked",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Blocked",
			value: 808900004,
			order: 5,
		},
		"Pending Billing Cycle(808900005)" : {
			name: "Pending Billing Cycle",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: "Pending Billing Cycle",
			value: 808900005,
			order: 6,
		},
		"Completed(808900006)" : {
			name: "Completed",
			value: 808900006,
			order: 7,
		},
		808900006 : {
			name: "Completed",
			value: 808900006,
			order: 7,
		},
		"Not Applicable(808900007)" : {
			name: "Not Applicable",
			value: 808900007,
			order: 8,
		},
		808900007 : {
			name: "Not Applicable",
			value: 808900007,
			order: 8,
		},
		"No Action Required(808900009)" : {
			name: "No Action Required",
			value: 808900009,
			order: 9,
		},
		808900009 : {
			name: "No Action Required",
			value: 808900009,
			order: 9,
		},
		"Cancelled Deactivated(808900008)" : {
			name: "Cancelled Deactivated",
			value: 808900008,
			order: 10,
		},
		808900008 : {
			name: "Cancelled Deactivated",
			value: 808900008,
			order: 10,
		},
	}
	export type Tbcbs_statuscode = keyof typeof bcbs_statuscode;

	export const bcbs_approverequestcode = {
		"Yes(808900000)" : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Yes",
			value: 808900000,
			order: 1,
		},
		"No(808900001)" : {
			name: "No",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "No",
			value: 808900001,
			order: 2,
		},
	}
	export type Tbcbs_approverequestcode = keyof typeof bcbs_approverequestcode;

	export const bcbs_overrideactualenddate = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_overrideactualenddate = keyof typeof bcbs_overrideactualenddate;

}

export namespace contact {
	export const address2_shippingmethodcode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Taddress2_shippingmethodcode = keyof typeof address2_shippingmethodcode;

	export const address3_shippingmethodcode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Taddress3_shippingmethodcode = keyof typeof address3_shippingmethodcode;

	export const isautocreate = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tisautocreate = keyof typeof isautocreate;

	export const preferredappointmentdaycode = {
		"Sunday(0)" : {
			name: "Sunday",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Sunday",
			value: 0,
			order: 1,
		},
		"Monday(1)" : {
			name: "Monday",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Monday",
			value: 1,
			order: 2,
		},
		"Tuesday(2)" : {
			name: "Tuesday",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Tuesday",
			value: 2,
			order: 3,
		},
		"Wednesday(3)" : {
			name: "Wednesday",
			value: 3,
			order: 4,
		},
		3 : {
			name: "Wednesday",
			value: 3,
			order: 4,
		},
		"Thursday(4)" : {
			name: "Thursday",
			value: 4,
			order: 5,
		},
		4 : {
			name: "Thursday",
			value: 4,
			order: 5,
		},
		"Friday(5)" : {
			name: "Friday",
			value: 5,
			order: 6,
		},
		5 : {
			name: "Friday",
			value: 5,
			order: 6,
		},
		"Saturday(6)" : {
			name: "Saturday",
			value: 6,
			order: 7,
		},
		6 : {
			name: "Saturday",
			value: 6,
			order: 7,
		},
	}
	export type Tpreferredappointmentdaycode = keyof typeof preferredappointmentdaycode;

	export const address3_freighttermscode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Taddress3_freighttermscode = keyof typeof address3_freighttermscode;

	export const territorycode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Tterritorycode = keyof typeof territorycode;

	export const customertypecode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Tcustomertypecode = keyof typeof customertypecode;

	export const address1_freighttermscode = {
		"FOB(1)" : {
			name: "FOB",
			value: 1,
			order: 1,
		},
		1 : {
			name: "FOB",
			value: 1,
			order: 1,
		},
		"No Charge(2)" : {
			name: "No Charge",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No Charge",
			value: 2,
			order: 2,
		},
	}
	export type Taddress1_freighttermscode = keyof typeof address1_freighttermscode;

	export const address1_addresstypecode = {
		"Bill To(1)" : {
			name: "Bill To",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Bill To",
			value: 1,
			order: 1,
		},
		"Ship To(2)" : {
			name: "Ship To",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Ship To",
			value: 2,
			order: 2,
		},
		"Primary(3)" : {
			name: "Primary",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Primary",
			value: 3,
			order: 3,
		},
		"Other(4)" : {
			name: "Other",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Other",
			value: 4,
			order: 4,
		},
	}
	export type Taddress1_addresstypecode = keyof typeof address1_addresstypecode;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const familystatuscode = {
		"Single(1)" : {
			name: "Single",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Single",
			value: 1,
			order: 1,
		},
		"Married(2)" : {
			name: "Married",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Married",
			value: 2,
			order: 2,
		},
		"Divorced(3)" : {
			name: "Divorced",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Divorced",
			value: 3,
			order: 3,
		},
		"Widowed(4)" : {
			name: "Widowed",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Widowed",
			value: 4,
			order: 4,
		},
	}
	export type Tfamilystatuscode = keyof typeof familystatuscode;

	export const address3_addresstypecode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Taddress3_addresstypecode = keyof typeof address3_addresstypecode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const address2_freighttermscode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Taddress2_freighttermscode = keyof typeof address2_freighttermscode;

	export const followemail = {
		"Do Not Allow(0)" : {
			name: "Do Not Allow",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Do Not Allow",
			value: 0,
			order: 1,
		},
		"Allow(1)" : {
			name: "Allow",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Allow",
			value: 1,
			order: 2,
		},
	}
	export type Tfollowemail = keyof typeof followemail;

	export const participatesinworkflow = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tparticipatesinworkflow = keyof typeof participatesinworkflow;

	export const gendercode = {
		"Male(1)" : {
			name: "Male",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Male",
			value: 1,
			order: 1,
		},
		"Female(2)" : {
			name: "Female",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Female",
			value: 2,
			order: 2,
		},
	}
	export type Tgendercode = keyof typeof gendercode;

	export const address2_addresstypecode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Taddress2_addresstypecode = keyof typeof address2_addresstypecode;

	export const marketingonly = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tmarketingonly = keyof typeof marketingonly;

	export const donotpostalmail = {
		"Allow(0)" : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		"Do Not Allow(1)" : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
	}
	export type Tdonotpostalmail = keyof typeof donotpostalmail;

	export const preferredcontactmethodcode = {
		"Any(1)" : {
			name: "Any",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Any",
			value: 1,
			order: 1,
		},
		"Email(2)" : {
			name: "Email",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Email",
			value: 2,
			order: 2,
		},
		"Phone(3)" : {
			name: "Phone",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Phone",
			value: 3,
			order: 3,
		},
		"Fax(4)" : {
			name: "Fax",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Fax",
			value: 4,
			order: 4,
		},
		"Mail(5)" : {
			name: "Mail",
			value: 5,
			order: 5,
		},
		5 : {
			name: "Mail",
			value: 5,
			order: 5,
		},
	}
	export type Tpreferredcontactmethodcode = keyof typeof preferredcontactmethodcode;

	export const donotbulkpostalmail = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tdonotbulkpostalmail = keyof typeof donotbulkpostalmail;

	export const donotbulkemail = {
		"Allow(0)" : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		"Do Not Allow(1)" : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
	}
	export type Tdonotbulkemail = keyof typeof donotbulkemail;

	export const customersizecode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Tcustomersizecode = keyof typeof customersizecode;

	export const preferredappointmenttimecode = {
		"Morning(1)" : {
			name: "Morning",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Morning",
			value: 1,
			order: 1,
		},
		"Afternoon(2)" : {
			name: "Afternoon",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Afternoon",
			value: 2,
			order: 2,
		},
		"Evening(3)" : {
			name: "Evening",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Evening",
			value: 3,
			order: 3,
		},
	}
	export type Tpreferredappointmenttimecode = keyof typeof preferredappointmenttimecode;

	export const paymenttermscode = {
		"Net 30(1)" : {
			name: "Net 30",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Net 30",
			value: 1,
			order: 1,
		},
		"2 10 Net 30(2)" : {
			name: "2 10 Net 30",
			value: 2,
			order: 2,
		},
		2 : {
			name: "2 10 Net 30",
			value: 2,
			order: 2,
		},
		"Net 45(3)" : {
			name: "Net 45",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Net 45",
			value: 3,
			order: 3,
		},
		"Net 60(4)" : {
			name: "Net 60",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Net 60",
			value: 4,
			order: 4,
		},
	}
	export type Tpaymenttermscode = keyof typeof paymenttermscode;

	export const leadsourcecode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Tleadsourcecode = keyof typeof leadsourcecode;

	export const merged = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tmerged = keyof typeof merged;

	export const address1_shippingmethodcode = {
		"Airborne(1)" : {
			name: "Airborne",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Airborne",
			value: 1,
			order: 1,
		},
		"DHL(2)" : {
			name: "DHL",
			value: 2,
			order: 2,
		},
		2 : {
			name: "DHL",
			value: 2,
			order: 2,
		},
		"FedEx(3)" : {
			name: "FedEx",
			value: 3,
			order: 3,
		},
		3 : {
			name: "FedEx",
			value: 3,
			order: 3,
		},
		"UPS(4)" : {
			name: "UPS",
			value: 4,
			order: 4,
		},
		4 : {
			name: "UPS",
			value: 4,
			order: 4,
		},
		"Postal Mail(5)" : {
			name: "Postal Mail",
			value: 5,
			order: 5,
		},
		5 : {
			name: "Postal Mail",
			value: 5,
			order: 5,
		},
		"Full Load(6)" : {
			name: "Full Load",
			value: 6,
			order: 6,
		},
		6 : {
			name: "Full Load",
			value: 6,
			order: 6,
		},
		"Will Call(7)" : {
			name: "Will Call",
			value: 7,
			order: 7,
		},
		7 : {
			name: "Will Call",
			value: 7,
			order: 7,
		},
	}
	export type Taddress1_shippingmethodcode = keyof typeof address1_shippingmethodcode;

	export const creditonhold = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tcreditonhold = keyof typeof creditonhold;

	export const donotphone = {
		"Allow(0)" : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		"Do Not Allow(1)" : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
	}
	export type Tdonotphone = keyof typeof donotphone;

	export const donotfax = {
		"Allow(0)" : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		"Do Not Allow(1)" : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
	}
	export type Tdonotfax = keyof typeof donotfax;

	export const donotsendmm = {
		"Send(0)" : {
			name: "Send",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Send",
			value: 0,
			order: 1,
		},
		"Do Not Send(1)" : {
			name: "Do Not Send",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Do Not Send",
			value: 1,
			order: 2,
		},
	}
	export type Tdonotsendmm = keyof typeof donotsendmm;

	export const donotemail = {
		"Allow(0)" : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Allow",
			value: 0,
			order: 1,
		},
		"Do Not Allow(1)" : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Do Not Allow",
			value: 1,
			order: 2,
		},
	}
	export type Tdonotemail = keyof typeof donotemail;

	export const isprivate = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tisprivate = keyof typeof isprivate;

	export const shippingmethodcode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Tshippingmethodcode = keyof typeof shippingmethodcode;

	export const educationcode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Teducationcode = keyof typeof educationcode;

	export const haschildrencode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Thaschildrencode = keyof typeof haschildrencode;

	export const isbackofficecustomer = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tisbackofficecustomer = keyof typeof isbackofficecustomer;

	export const msdyn_orgchangestatus = {
		"No Feedback(0)" : {
			name: "No Feedback",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No Feedback",
			value: 0,
			order: 1,
		},
		"Not at Company(1)" : {
			name: "Not at Company",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Not at Company",
			value: 1,
			order: 2,
		},
		"Ignore(2)" : {
			name: "Ignore",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Ignore",
			value: 2,
			order: 3,
		},
	}
	export type Tmsdyn_orgchangestatus = keyof typeof msdyn_orgchangestatus;

	export const msdyn_gdproptout = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tmsdyn_gdproptout = keyof typeof msdyn_gdproptout;

	export const msdyn_isminorwithparentalconsent = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tmsdyn_isminorwithparentalconsent = keyof typeof msdyn_isminorwithparentalconsent;

	export const msdyn_disablewebtracking = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tmsdyn_disablewebtracking = keyof typeof msdyn_disablewebtracking;

	export const msdyn_isminor = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tmsdyn_isminor = keyof typeof msdyn_isminor;

	export const adx_profileisanonymous = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tadx_profileisanonymous = keyof typeof adx_profileisanonymous;

	export const adx_profilealert = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tadx_profilealert = keyof typeof adx_profilealert;

	export const adx_identity_locallogindisabled = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tadx_identity_locallogindisabled = keyof typeof adx_identity_locallogindisabled;

	export const adx_confirmremovepassword = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tadx_confirmremovepassword = keyof typeof adx_confirmremovepassword;

	export const adx_identity_lockoutenabled = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tadx_identity_lockoutenabled = keyof typeof adx_identity_lockoutenabled;

	export const adx_identity_twofactorenabled = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tadx_identity_twofactorenabled = keyof typeof adx_identity_twofactorenabled;

	export const adx_identity_logonenabled = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tadx_identity_logonenabled = keyof typeof adx_identity_logonenabled;

	export const adx_identity_emailaddress1confirmed = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tadx_identity_emailaddress1confirmed = keyof typeof adx_identity_emailaddress1confirmed;

	export const adx_identity_mobilephoneconfirmed = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tadx_identity_mobilephoneconfirmed = keyof typeof adx_identity_mobilephoneconfirmed;

	export const accountrolecode = {
		"Producer(1)" : {
			name: "Producer",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Producer",
			value: 1,
			order: 1,
		},
		"Manager(2)" : {
			name: "Manager",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Manager",
			value: 2,
			order: 2,
		},
		"Administrative(3)" : {
			name: "Administrative",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Administrative",
			value: 3,
			order: 3,
		},
	}
	export type Taccountrolecode = keyof typeof accountrolecode;

	export const bcbs_employeraccounttype = {
		"Agency(808900000)" : {
			name: "Agency",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Agency",
			value: 808900000,
			order: 1,
		},
		"Group(808900001)" : {
			name: "Group",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Group",
			value: 808900001,
			order: 2,
		},
		"Vendor(808900002)" : {
			name: "Vendor",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Vendor",
			value: 808900002,
			order: 3,
		},
		"Competitor(808900003)" : {
			name: "Competitor",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Competitor",
			value: 808900003,
			order: 4,
		},
		"Other(808900004)" : {
			name: "Other",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Other",
			value: 808900004,
			order: 5,
		},
	}
	export type Tbcbs_employeraccounttype = keyof typeof bcbs_employeraccounttype;

	export const bcbs_grouprole = {
		"Benefits Administrator(808900000)" : {
			name: "Benefits Administrator",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Benefits Administrator",
			value: 808900000,
			order: 1,
		},
		"Decision Maker(808900001)" : {
			name: "Decision Maker",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Decision Maker",
			value: 808900001,
			order: 2,
		},
		"BA  DM(808900002)" : {
			name: "BA  DM",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "BA  DM",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_grouprole = keyof typeof bcbs_grouprole;

	export const bcbs_storefront = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_storefront = keyof typeof bcbs_storefront;

	export const bcbs_sameasphysicaladdress = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_sameasphysicaladdress = keyof typeof bcbs_sameasphysicaladdress;

	export const bcbs_isdistributionlist = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isdistributionlist = keyof typeof bcbs_isdistributionlist;

	export const bcbs_isportalcontact = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isportalcontact = keyof typeof bcbs_isportalcontact;

	export const bcbs_isprimarycontact = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isprimarycontact = keyof typeof bcbs_isprimarycontact;

	export const msdyn_isassistantinorgchart = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tmsdyn_isassistantinorgchart = keyof typeof msdyn_isassistantinorgchart;

	export const msdyn_decisioninfluencetag = {
		"Decision maker(0)" : {
			name: "Decision maker",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Decision maker",
			value: 0,
			order: 1,
		},
		"Influencer(1)" : {
			name: "Influencer",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Influencer",
			value: 1,
			order: 2,
		},
		"Blocker(2)" : {
			name: "Blocker",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Blocker",
			value: 2,
			order: 3,
		},
		"Unknown(3)" : {
			name: "Unknown",
			value: 3,
			order: 4,
		},
		3 : {
			name: "Unknown",
			value: 3,
			order: 4,
		},
	}
	export type Tmsdyn_decisioninfluencetag = keyof typeof msdyn_decisioninfluencetag;

	export const mspp_userpreferredlcid = {
		"Arabic(1025)" : {
			name: "Arabic",
			value: 1025,
			order: 1,
		},
		1025 : {
			name: "Arabic",
			value: 1025,
			order: 1,
		},
		"Basque  Basque(1069)" : {
			name: "Basque  Basque",
			value: 1069,
			order: 2,
		},
		1069 : {
			name: "Basque  Basque",
			value: 1069,
			order: 2,
		},
		"Bulgarian  Bulgaria(1026)" : {
			name: "Bulgarian  Bulgaria",
			value: 1026,
			order: 3,
		},
		1026 : {
			name: "Bulgarian  Bulgaria",
			value: 1026,
			order: 3,
		},
		"Catalan  Catalan(1027)" : {
			name: "Catalan  Catalan",
			value: 1027,
			order: 4,
		},
		1027 : {
			name: "Catalan  Catalan",
			value: 1027,
			order: 4,
		},
		"Chinese  China(2052)" : {
			name: "Chinese  China",
			value: 2052,
			order: 5,
		},
		2052 : {
			name: "Chinese  China",
			value: 2052,
			order: 5,
		},
		"Chinese  Hong Kong SAR(3076)" : {
			name: "Chinese  Hong Kong SAR",
			value: 3076,
			order: 6,
		},
		3076 : {
			name: "Chinese  Hong Kong SAR",
			value: 3076,
			order: 6,
		},
		"Chinese  Traditional(1028)" : {
			name: "Chinese  Traditional",
			value: 1028,
			order: 7,
		},
		1028 : {
			name: "Chinese  Traditional",
			value: 1028,
			order: 7,
		},
		"Croatian  Croatia(1050)" : {
			name: "Croatian  Croatia",
			value: 1050,
			order: 8,
		},
		1050 : {
			name: "Croatian  Croatia",
			value: 1050,
			order: 8,
		},
		"Czech  Czech Republic(1029)" : {
			name: "Czech  Czech Republic",
			value: 1029,
			order: 9,
		},
		1029 : {
			name: "Czech  Czech Republic",
			value: 1029,
			order: 9,
		},
		"Danish  Denmark(1030)" : {
			name: "Danish  Denmark",
			value: 1030,
			order: 10,
		},
		1030 : {
			name: "Danish  Denmark",
			value: 1030,
			order: 10,
		},
		"Dutch  Netherlands(1043)" : {
			name: "Dutch  Netherlands",
			value: 1043,
			order: 11,
		},
		1043 : {
			name: "Dutch  Netherlands",
			value: 1043,
			order: 11,
		},
		"English(1033)" : {
			name: "English",
			value: 1033,
			order: 12,
		},
		1033 : {
			name: "English",
			value: 1033,
			order: 12,
		},
		"Estonian  Estonia(1061)" : {
			name: "Estonian  Estonia",
			value: 1061,
			order: 13,
		},
		1061 : {
			name: "Estonian  Estonia",
			value: 1061,
			order: 13,
		},
		"Finnish  Finland(1035)" : {
			name: "Finnish  Finland",
			value: 1035,
			order: 14,
		},
		1035 : {
			name: "Finnish  Finland",
			value: 1035,
			order: 14,
		},
		"French  France(1036)" : {
			name: "French  France",
			value: 1036,
			order: 15,
		},
		1036 : {
			name: "French  France",
			value: 1036,
			order: 15,
		},
		"Galician  Spain(1110)" : {
			name: "Galician  Spain",
			value: 1110,
			order: 16,
		},
		1110 : {
			name: "Galician  Spain",
			value: 1110,
			order: 16,
		},
		"German  Germany(1031)" : {
			name: "German  Germany",
			value: 1031,
			order: 17,
		},
		1031 : {
			name: "German  Germany",
			value: 1031,
			order: 17,
		},
		"Greek  Greece(1032)" : {
			name: "Greek  Greece",
			value: 1032,
			order: 18,
		},
		1032 : {
			name: "Greek  Greece",
			value: 1032,
			order: 18,
		},
		"Hebrew(1037)" : {
			name: "Hebrew",
			value: 1037,
			order: 19,
		},
		1037 : {
			name: "Hebrew",
			value: 1037,
			order: 19,
		},
		"Hindi  India(1081)" : {
			name: "Hindi  India",
			value: 1081,
			order: 20,
		},
		1081 : {
			name: "Hindi  India",
			value: 1081,
			order: 20,
		},
		"Hungarian  Hungary(1038)" : {
			name: "Hungarian  Hungary",
			value: 1038,
			order: 21,
		},
		1038 : {
			name: "Hungarian  Hungary",
			value: 1038,
			order: 21,
		},
		"Indonesian  Indonesia(1057)" : {
			name: "Indonesian  Indonesia",
			value: 1057,
			order: 22,
		},
		1057 : {
			name: "Indonesian  Indonesia",
			value: 1057,
			order: 22,
		},
		"Italian  Italy(1040)" : {
			name: "Italian  Italy",
			value: 1040,
			order: 23,
		},
		1040 : {
			name: "Italian  Italy",
			value: 1040,
			order: 23,
		},
		"Japanese  Japan(1041)" : {
			name: "Japanese  Japan",
			value: 1041,
			order: 24,
		},
		1041 : {
			name: "Japanese  Japan",
			value: 1041,
			order: 24,
		},
		"Kazakh  Kazakhstan(1087)" : {
			name: "Kazakh  Kazakhstan",
			value: 1087,
			order: 25,
		},
		1087 : {
			name: "Kazakh  Kazakhstan",
			value: 1087,
			order: 25,
		},
		"Korean  Korea(1042)" : {
			name: "Korean  Korea",
			value: 1042,
			order: 26,
		},
		1042 : {
			name: "Korean  Korea",
			value: 1042,
			order: 26,
		},
		"Latvian  Latvia(1062)" : {
			name: "Latvian  Latvia",
			value: 1062,
			order: 27,
		},
		1062 : {
			name: "Latvian  Latvia",
			value: 1062,
			order: 27,
		},
		"Lithuanian  Lithuania(1063)" : {
			name: "Lithuanian  Lithuania",
			value: 1063,
			order: 28,
		},
		1063 : {
			name: "Lithuanian  Lithuania",
			value: 1063,
			order: 28,
		},
		"Malay  Malaysia(1086)" : {
			name: "Malay  Malaysia",
			value: 1086,
			order: 29,
		},
		1086 : {
			name: "Malay  Malaysia",
			value: 1086,
			order: 29,
		},
		"Norwegian Bokml  Norway(1044)" : {
			name: "Norwegian Bokml  Norway",
			value: 1044,
			order: 30,
		},
		1044 : {
			name: "Norwegian Bokml  Norway",
			value: 1044,
			order: 30,
		},
		"Polish  Poland(1045)" : {
			name: "Polish  Poland",
			value: 1045,
			order: 31,
		},
		1045 : {
			name: "Polish  Poland",
			value: 1045,
			order: 31,
		},
		"Portuguese  Brazil(1046)" : {
			name: "Portuguese  Brazil",
			value: 1046,
			order: 32,
		},
		1046 : {
			name: "Portuguese  Brazil",
			value: 1046,
			order: 32,
		},
		"Portuguese  Portugal(2070)" : {
			name: "Portuguese  Portugal",
			value: 2070,
			order: 33,
		},
		2070 : {
			name: "Portuguese  Portugal",
			value: 2070,
			order: 33,
		},
		"Romanian  Romania(1048)" : {
			name: "Romanian  Romania",
			value: 1048,
			order: 34,
		},
		1048 : {
			name: "Romanian  Romania",
			value: 1048,
			order: 34,
		},
		"Russian  Russia(1049)" : {
			name: "Russian  Russia",
			value: 1049,
			order: 35,
		},
		1049 : {
			name: "Russian  Russia",
			value: 1049,
			order: 35,
		},
		"Serbian Cyrillic  Serbia(3098)" : {
			name: "Serbian Cyrillic  Serbia",
			value: 3098,
			order: 36,
		},
		3098 : {
			name: "Serbian Cyrillic  Serbia",
			value: 3098,
			order: 36,
		},
		"Serbian Latin  Serbia(2074)" : {
			name: "Serbian Latin  Serbia",
			value: 2074,
			order: 37,
		},
		2074 : {
			name: "Serbian Latin  Serbia",
			value: 2074,
			order: 37,
		},
		"Slovak  Slovakia(1051)" : {
			name: "Slovak  Slovakia",
			value: 1051,
			order: 38,
		},
		1051 : {
			name: "Slovak  Slovakia",
			value: 1051,
			order: 38,
		},
		"Slovenian  Slovenia(1060)" : {
			name: "Slovenian  Slovenia",
			value: 1060,
			order: 39,
		},
		1060 : {
			name: "Slovenian  Slovenia",
			value: 1060,
			order: 39,
		},
		"Spanish Traditional Sort  Spain(3082)" : {
			name: "Spanish Traditional Sort  Spain",
			value: 3082,
			order: 40,
		},
		3082 : {
			name: "Spanish Traditional Sort  Spain",
			value: 3082,
			order: 40,
		},
		"Swedish  Sweden(1053)" : {
			name: "Swedish  Sweden",
			value: 1053,
			order: 41,
		},
		1053 : {
			name: "Swedish  Sweden",
			value: 1053,
			order: 41,
		},
		"Thai  Thailand(1054)" : {
			name: "Thai  Thailand",
			value: 1054,
			order: 42,
		},
		1054 : {
			name: "Thai  Thailand",
			value: 1054,
			order: 42,
		},
		"Turkish  Trkiye(1055)" : {
			name: "Turkish  Trkiye",
			value: 1055,
			order: 43,
		},
		1055 : {
			name: "Turkish  Trkiye",
			value: 1055,
			order: 43,
		},
		"Ukrainian  Ukraine(1058)" : {
			name: "Ukrainian  Ukraine",
			value: 1058,
			order: 44,
		},
		1058 : {
			name: "Ukrainian  Ukraine",
			value: 1058,
			order: 44,
		},
		"Vietnamese  Vietnam(1066)" : {
			name: "Vietnamese  Vietnam",
			value: 1066,
			order: 45,
		},
		1066 : {
			name: "Vietnamese  Vietnam",
			value: 1066,
			order: 45,
		},
	}
	export type Tmspp_userpreferredlcid = keyof typeof mspp_userpreferredlcid;

}

export namespace systemuser {
	export const preferredaddresscode = {
		"Mailing Address(1)" : {
			name: "Mailing Address",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Mailing Address",
			value: 1,
			order: 1,
		},
		"Other Address(2)" : {
			name: "Other Address",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Other Address",
			value: 2,
			order: 2,
		},
	}
	export type Tpreferredaddresscode = keyof typeof preferredaddresscode;

	export const isemailaddressapprovedbyo365admin = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tisemailaddressapprovedbyo365admin = keyof typeof isemailaddressapprovedbyo365admin;

	export const preferredphonecode = {
		"Main Phone(1)" : {
			name: "Main Phone",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Main Phone",
			value: 1,
			order: 1,
		},
		"Other Phone(2)" : {
			name: "Other Phone",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Other Phone",
			value: 2,
			order: 2,
		},
		"Home Phone(3)" : {
			name: "Home Phone",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Home Phone",
			value: 3,
			order: 3,
		},
		"Mobile Phone(4)" : {
			name: "Mobile Phone",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Mobile Phone",
			value: 4,
			order: 4,
		},
	}
	export type Tpreferredphonecode = keyof typeof preferredphonecode;

	export const setupuser = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tsetupuser = keyof typeof setupuser;

	export const isactivedirectoryuser = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tisactivedirectoryuser = keyof typeof isactivedirectoryuser;

	export const isintegrationuser = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tisintegrationuser = keyof typeof isintegrationuser;

	export const address1_shippingmethodcode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Taddress1_shippingmethodcode = keyof typeof address1_shippingmethodcode;

	export const defaultfilterspopulated = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tdefaultfilterspopulated = keyof typeof defaultfilterspopulated;

	export const caltype = {
		"Professional(0)" : {
			name: "Professional",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Professional",
			value: 0,
			order: 1,
		},
		"Administrative(1)" : {
			name: "Administrative",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Administrative",
			value: 1,
			order: 2,
		},
		"Basic(2)" : {
			name: "Basic",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Basic",
			value: 2,
			order: 3,
		},
		"Device Professional(3)" : {
			name: "Device Professional",
			value: 3,
			order: 4,
		},
		3 : {
			name: "Device Professional",
			value: 3,
			order: 4,
		},
		"Device Basic(4)" : {
			name: "Device Basic",
			value: 4,
			order: 5,
		},
		4 : {
			name: "Device Basic",
			value: 4,
			order: 5,
		},
		"Essential(5)" : {
			name: "Essential",
			value: 5,
			order: 6,
		},
		5 : {
			name: "Essential",
			value: 5,
			order: 6,
		},
		"Device Essential(6)" : {
			name: "Device Essential",
			value: 6,
			order: 7,
		},
		6 : {
			name: "Device Essential",
			value: 6,
			order: 7,
		},
		"Enterprise(7)" : {
			name: "Enterprise",
			value: 7,
			order: 8,
		},
		7 : {
			name: "Enterprise",
			value: 7,
			order: 8,
		},
		"Device Enterprise(8)" : {
			name: "Device Enterprise",
			value: 8,
			order: 9,
		},
		8 : {
			name: "Device Enterprise",
			value: 8,
			order: 9,
		},
		"Sales(9)" : {
			name: "Sales",
			value: 9,
			order: 10,
		},
		9 : {
			name: "Sales",
			value: 9,
			order: 10,
		},
		"Service(10)" : {
			name: "Service",
			value: 10,
			order: 11,
		},
		10 : {
			name: "Service",
			value: 10,
			order: 11,
		},
		"Field Service(11)" : {
			name: "Field Service",
			value: 11,
			order: 12,
		},
		11 : {
			name: "Field Service",
			value: 11,
			order: 12,
		},
		"Project Service(12)" : {
			name: "Project Service",
			value: 12,
			order: 13,
		},
		12 : {
			name: "Project Service",
			value: 12,
			order: 13,
		},
	}
	export type Tcaltype = keyof typeof caltype;

	export const accessmode = {
		"ReadWrite(0)" : {
			name: "ReadWrite",
			value: 0,
			order: 1,
		},
		0 : {
			name: "ReadWrite",
			value: 0,
			order: 1,
		},
		"Administrative(1)" : {
			name: "Administrative",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Administrative",
			value: 1,
			order: 2,
		},
		"Read(2)" : {
			name: "Read",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Read",
			value: 2,
			order: 3,
		},
		"Support User(3)" : {
			name: "Support User",
			value: 3,
			order: 4,
		},
		3 : {
			name: "Support User",
			value: 3,
			order: 4,
		},
		"Noninteractive(4)" : {
			name: "Noninteractive",
			value: 4,
			order: 5,
		},
		4 : {
			name: "Noninteractive",
			value: 4,
			order: 5,
		},
		"Delegated Admin(5)" : {
			name: "Delegated Admin",
			value: 5,
			order: 6,
		},
		5 : {
			name: "Delegated Admin",
			value: 5,
			order: 6,
		},
	}
	export type Taccessmode = keyof typeof accessmode;

	export const isdisabled = {
		"Enabled(0)" : {
			name: "Enabled",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Enabled",
			value: 0,
			order: 1,
		},
		"Disabled(1)" : {
			name: "Disabled",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Disabled",
			value: 1,
			order: 2,
		},
	}
	export type Tisdisabled = keyof typeof isdisabled;

	export const emailrouteraccessapproval = {
		"Empty(0)" : {
			name: "Empty",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Empty",
			value: 0,
			order: 1,
		},
		"Approved(1)" : {
			name: "Approved",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Approved",
			value: 1,
			order: 2,
		},
		"Pending Approval(2)" : {
			name: "Pending Approval",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Pending Approval",
			value: 2,
			order: 3,
		},
		"Rejected(3)" : {
			name: "Rejected",
			value: 3,
			order: 4,
		},
		3 : {
			name: "Rejected",
			value: 3,
			order: 4,
		},
	}
	export type Temailrouteraccessapproval = keyof typeof emailrouteraccessapproval;

	export const address1_addresstypecode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Taddress1_addresstypecode = keyof typeof address1_addresstypecode;

	export const address2_shippingmethodcode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Taddress2_shippingmethodcode = keyof typeof address2_shippingmethodcode;

	export const invitestatuscode = {
		"Invitation Not Sent(0)" : {
			name: "Invitation Not Sent",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Invitation Not Sent",
			value: 0,
			order: 1,
		},
		"Invited(1)" : {
			name: "Invited",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Invited",
			value: 1,
			order: 2,
		},
		"Invitation Near Expired(2)" : {
			name: "Invitation Near Expired",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Invitation Near Expired",
			value: 2,
			order: 3,
		},
		"Invitation Expired(3)" : {
			name: "Invitation Expired",
			value: 3,
			order: 4,
		},
		3 : {
			name: "Invitation Expired",
			value: 3,
			order: 4,
		},
		"Invitation Accepted(4)" : {
			name: "Invitation Accepted",
			value: 4,
			order: 5,
		},
		4 : {
			name: "Invitation Accepted",
			value: 4,
			order: 5,
		},
		"Invitation Rejected(5)" : {
			name: "Invitation Rejected",
			value: 5,
			order: 6,
		},
		5 : {
			name: "Invitation Rejected",
			value: 5,
			order: 6,
		},
		"Invitation Revoked(6)" : {
			name: "Invitation Revoked",
			value: 6,
			order: 7,
		},
		6 : {
			name: "Invitation Revoked",
			value: 6,
			order: 7,
		},
	}
	export type Tinvitestatuscode = keyof typeof invitestatuscode;

	export const islicensed = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tislicensed = keyof typeof islicensed;

	export const issyncwithdirectory = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tissyncwithdirectory = keyof typeof issyncwithdirectory;

	export const preferredemailcode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Tpreferredemailcode = keyof typeof preferredemailcode;

	export const outgoingemaildeliverymethod = {
		"None(0)" : {
			name: "None",
			value: 0,
			order: 1,
		},
		0 : {
			name: "None",
			value: 0,
			order: 1,
		},
		"Microsoft Dynamics 365 for Outlook(1)" : {
			name: "Microsoft Dynamics 365 for Outlook",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Microsoft Dynamics 365 for Outlook",
			value: 1,
			order: 2,
		},
		"ServerSide Synchronization or Email Router(2)" : {
			name: "ServerSide Synchronization or Email Router",
			value: 2,
			order: 3,
		},
		2 : {
			name: "ServerSide Synchronization or Email Router",
			value: 2,
			order: 3,
		},
	}
	export type Toutgoingemaildeliverymethod = keyof typeof outgoingemaildeliverymethod;

	export const address2_addresstypecode = {
		"Default Value(1)" : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Default Value",
			value: 1,
			order: 1,
		},
	}
	export type Taddress2_addresstypecode = keyof typeof address2_addresstypecode;

	export const incomingemaildeliverymethod = {
		"None(0)" : {
			name: "None",
			value: 0,
			order: 1,
		},
		0 : {
			name: "None",
			value: 0,
			order: 1,
		},
		"Microsoft Dynamics 365 for Outlook(1)" : {
			name: "Microsoft Dynamics 365 for Outlook",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Microsoft Dynamics 365 for Outlook",
			value: 1,
			order: 2,
		},
		"ServerSide Synchronization or Email Router(2)" : {
			name: "ServerSide Synchronization or Email Router",
			value: 2,
			order: 3,
		},
		2 : {
			name: "ServerSide Synchronization or Email Router",
			value: 2,
			order: 3,
		},
		"Forward Mailbox(3)" : {
			name: "Forward Mailbox",
			value: 3,
			order: 4,
		},
		3 : {
			name: "Forward Mailbox",
			value: 3,
			order: 4,
		},
	}
	export type Tincomingemaildeliverymethod = keyof typeof incomingemaildeliverymethod;

	export const displayinserviceviews = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tdisplayinserviceviews = keyof typeof displayinserviceviews;

	export const msdyn_gdproptout = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tmsdyn_gdproptout = keyof typeof msdyn_gdproptout;

	export const azurestate = {
		"Exists(0)" : {
			name: "Exists",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Exists",
			value: 0,
			order: 1,
		},
		"Soft deleted(1)" : {
			name: "Soft deleted",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Soft deleted",
			value: 1,
			order: 2,
		},
		"Not found or hard deleted(2)" : {
			name: "Not found or hard deleted",
			value: 2,
			order: 3,
		},
		2 : {
			name: "Not found or hard deleted",
			value: 2,
			order: 3,
		},
	}
	export type Tazurestate = keyof typeof azurestate;

	export const deletedstate = {
		"Not deleted(0)" : {
			name: "Not deleted",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Not deleted",
			value: 0,
			order: 1,
		},
		"Soft deleted(1)" : {
			name: "Soft deleted",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Soft deleted",
			value: 1,
			order: 2,
		},
	}
	export type Tdeletedstate = keyof typeof deletedstate;

	export const ptm_peruserlicensingdocumentscorepack = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tptm_peruserlicensingdocumentscorepack = keyof typeof ptm_peruserlicensingdocumentscorepack;

	export const ptm_peruserlicensingdocumentscorepackserver = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tptm_peruserlicensingdocumentscorepackserver = keyof typeof ptm_peruserlicensingdocumentscorepackserver;

	export const msdyn_usertype = {
		"CRM User(192350000)" : {
			name: "CRM User",
			value: 192350000,
			order: 1,
		},
		192350000 : {
			name: "CRM User",
			value: 192350000,
			order: 1,
		},
		"BOT User(192350001)" : {
			name: "BOT User",
			value: 192350001,
			order: 2,
		},
		192350001 : {
			name: "BOT User",
			value: 192350001,
			order: 2,
		},
	}
	export type Tmsdyn_usertype = keyof typeof msdyn_usertype;

	export const msdyn_isexpertenabledforswarm = {
		"No(0)" : {
			name: "No",
			value: 0,
			order: 1,
		},
		0 : {
			name: "No",
			value: 0,
			order: 1,
		},
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 2,
		},
	}
	export type Tmsdyn_isexpertenabledforswarm = keyof typeof msdyn_isexpertenabledforswarm;

	export const msdyn_agentType = {
		"Application user(192350000)" : {
			name: "Application user",
			value: 192350000,
			order: 1,
		},
		192350000 : {
			name: "Application user",
			value: 192350000,
			order: 1,
		},
		"Bot application user(192350001)" : {
			name: "Bot application user",
			value: 192350001,
			order: 2,
		},
		192350001 : {
			name: "Bot application user",
			value: 192350001,
			order: 2,
		},
	}
	export type Tmsdyn_agentType = keyof typeof msdyn_agentType;

	export const msdyn_botprovider = {
		"Virtual Agent(192350000)" : {
			name: "Virtual Agent",
			value: 192350000,
			order: 1,
		},
		192350000 : {
			name: "Virtual Agent",
			value: 192350000,
			order: 1,
		},
		"Other(192350001)" : {
			name: "Other",
			value: 192350001,
			order: 2,
		},
		192350001 : {
			name: "Other",
			value: 192350001,
			order: 2,
		},
		"None(192350002)" : {
			name: "None",
			value: 192350002,
			order: 3,
		},
		192350002 : {
			name: "None",
			value: 192350002,
			order: 3,
		},
	}
	export type Tmsdyn_botprovider = keyof typeof msdyn_botprovider;

}

export namespace bcbs_config_attribute {
	export const bcbs_requiredforvalidationcode = {
		"General(808900000)" : {
			name: "General",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "General",
			value: 808900000,
			order: 1,
		},
		"MNIL(808900001)" : {
			name: "MNIL",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "MNIL",
			value: 808900001,
			order: 2,
		},
		"Warning Only(808900002)" : {
			name: "Warning Only",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Warning Only",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_requiredforvalidationcode = keyof typeof bcbs_requiredforvalidationcode;

	export const bcbs_isemiteventonclone = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isemiteventonclone = keyof typeof bcbs_isemiteventonclone;

	export const bcbs_isadvancedoption = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isadvancedoption = keyof typeof bcbs_isadvancedoption;

	export const bcbs_istierenabled = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_istierenabled = keyof typeof bcbs_istierenabled;

	export const bcbs_isstoplosschange = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isstoplosschange = keyof typeof bcbs_isstoplosschange;

	export const bcbs_grandfatheredcode = {
		"NonGrandfathered(808900000)" : {
			name: "NonGrandfathered",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "NonGrandfathered",
			value: 808900000,
			order: 1,
		},
		"Grandfathered(808900001)" : {
			name: "Grandfathered",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Grandfathered",
			value: 808900001,
			order: 2,
		},
	}
	export type Tbcbs_grandfatheredcode = keyof typeof bcbs_grandfatheredcode;

	export const bcbs_lineofbusinesscode = {
		"FEP(808900006)" : {
			name: "FEP",
			value: 808900006,
			order: 1,
		},
		808900006 : {
			name: "FEP",
			value: 808900006,
			order: 1,
		},
		"GI(808900000)" : {
			name: "GI",
			value: 808900000,
			order: 2,
		},
		808900000 : {
			name: "GI",
			value: 808900000,
			order: 2,
		},
		"State Group(808900005)" : {
			name: "State Group",
			value: 808900005,
			order: 3,
		},
		808900005 : {
			name: "State Group",
			value: 808900005,
			order: 3,
		},
		"Major Group(808900003)" : {
			name: "Major Group",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Major Group",
			value: 808900003,
			order: 4,
		},
		"National Alliance(808900001)" : {
			name: "National Alliance",
			value: 808900001,
			order: 5,
		},
		808900001 : {
			name: "National Alliance",
			value: 808900001,
			order: 5,
		},
		"BlueChoice(808900002)" : {
			name: "BlueChoice",
			value: 808900002,
			order: 6,
		},
		808900002 : {
			name: "BlueChoice",
			value: 808900002,
			order: 6,
		},
		"GI(808900004)" : {
			name: "GI",
			value: 808900004,
			order: 7,
		},
		808900004 : {
			name: "GI",
			value: 808900004,
			order: 7,
		},
	}
	export type Tbcbs_lineofbusinesscode = keyof typeof bcbs_lineofbusinesscode;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const bcbs_isfinancialchange = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isfinancialchange = keyof typeof bcbs_isfinancialchange;

	export const bcbs_isreadonly = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isreadonly = keyof typeof bcbs_isreadonly;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_isclientbenefitdetailreport = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isclientbenefitdetailreport = keyof typeof bcbs_isclientbenefitdetailreport;

	export const bcbs_isbenefitdetailreport = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isbenefitdetailreport = keyof typeof bcbs_isbenefitdetailreport;

	export const bcbs_nonstandard = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_nonstandard = keyof typeof bcbs_nonstandard;

	export const bcbs_ispsachange = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ispsachange = keyof typeof bcbs_ispsachange;

	export const bcbs_ismnil = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ismnil = keyof typeof bcbs_ismnil;

	export const bcbs_isexcludeoutofnetwork = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isexcludeoutofnetwork = keyof typeof bcbs_isexcludeoutofnetwork;

	export const bcbs_nonstandard_applyto = {
		"Group Configuration(808900000)" : {
			name: "Group Configuration",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Group Configuration",
			value: 808900000,
			order: 1,
		},
		"Benefit Category(808900001)" : {
			name: "Benefit Category",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Benefit Category",
			value: 808900001,
			order: 2,
		},
		"Benefit Category Section(808900002)" : {
			name: "Benefit Category Section",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Benefit Category Section",
			value: 808900002,
			order: 3,
		},
		"Custom(808900003)" : {
			name: "Custom",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Custom",
			value: 808900003,
			order: 4,
		},
		"All(808900004)" : {
			name: "All",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "All",
			value: 808900004,
			order: 5,
		},
	}
	export type Tbcbs_nonstandard_applyto = keyof typeof bcbs_nonstandard_applyto;

	export const bcbs_islockedonproduct = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_islockedonproduct = keyof typeof bcbs_islockedonproduct;

	export const bcbs_isbenefitchange = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isbenefitchange = keyof typeof bcbs_isbenefitchange;

	export const bcbs_isseparatepcpandspecialist = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isseparatepcpandspecialist = keyof typeof bcbs_isseparatepcpandspecialist;

	export const bcbs_isunderwritingreviewnecessary = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isunderwritingreviewnecessary = keyof typeof bcbs_isunderwritingreviewnecessary;

	export const bcbs_isforceapproval = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isforceapproval = keyof typeof bcbs_isforceapproval;

	export const bcbs_isreleased = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isreleased = keyof typeof bcbs_isreleased;

	export const bcbs_isemitevent = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isemitevent = keyof typeof bcbs_isemitevent;

	export const bcbs_isadministrativechange = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isadministrativechange = keyof typeof bcbs_isadministrativechange;

	export const bcbs_fundingtypecode = {
		"Administrative Services Only(808900000)" : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		"ASO with Stop Loss(808900001)" : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		"Fully Insured(808900002)" : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		"National Alliance(808900003)" : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		"Level Funded(808900004)" : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
	}
	export type Tbcbs_fundingtypecode = keyof typeof bcbs_fundingtypecode;

	export const bcbs_erisacode = {
		"NonERISA(808900000)" : {
			name: "NonERISA",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "NonERISA",
			value: 808900000,
			order: 1,
		},
		"ERISA(808900001)" : {
			name: "ERISA",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "ERISA",
			value: 808900001,
			order: 2,
		},
	}
	export type Tbcbs_erisacode = keyof typeof bcbs_erisacode;

	export const bcbs_ispostcancelupdate = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ispostcancelupdate = keyof typeof bcbs_ispostcancelupdate;

	export const bcbs_costsharetypecode = {
		"All(808900000)" : {
			name: "All",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "All",
			value: 808900000,
			order: 1,
		},
		"Currency Only(808900001)" : {
			name: "Currency Only",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Currency Only",
			value: 808900001,
			order: 2,
		},
		"Percentage Only(808900002)" : {
			name: "Percentage Only",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Percentage Only",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_costsharetypecode = keyof typeof bcbs_costsharetypecode;

}

export namespace bcbs_carrier {
	export const bcbs_isparent = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isparent = keyof typeof bcbs_isparent;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

}

export namespace bcbs_bccadmin {
	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const bcbs_ratetype = {
		"Medical(808900000)" : {
			name: "Medical",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Medical",
			value: 808900000,
			order: 1,
		},
		"Dental(808900001)" : {
			name: "Dental",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Dental",
			value: 808900001,
			order: 2,
		},
		"Vision(808900002)" : {
			name: "Vision",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Vision",
			value: 808900002,
			order: 3,
		},
		"Rx(808900003)" : {
			name: "Rx",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Rx",
			value: 808900003,
			order: 4,
		},
	}
	export type Tbcbs_ratetype = keyof typeof bcbs_ratetype;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_stoplosstypecode = {
		"Aggregate(808900000)" : {
			name: "Aggregate",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Aggregate",
			value: 808900000,
			order: 1,
		},
		"Specific(808900001)" : {
			name: "Specific",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Specific",
			value: 808900001,
			order: 2,
		},
	}
	export type Tbcbs_stoplosstypecode = keyof typeof bcbs_stoplosstypecode;

	export const bcbs_fundingtypescode = {
		"Administrative Services Only(808900000)" : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		"ASO with Stop Loss(808900001)" : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		"Fully Insured(808900002)" : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		"National Alliance(808900003)" : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		"Level Funded(808900004)" : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
	}
	export type Tbcbs_fundingtypescode = keyof typeof bcbs_fundingtypescode;

	export const bcbs_fundingtypecode = {
		"Administrative Services Only(808900000)" : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		"ASO with Stop Loss(808900001)" : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		"Fully Insured(808900002)" : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		"National Alliance(808900003)" : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		"Level Funded(808900004)" : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
	}
	export type Tbcbs_fundingtypecode = keyof typeof bcbs_fundingtypecode;

}

export namespace bcbs_opportunityoption {
	export const bcbs_inpatientcopayscode = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_inpatientcopayscode = keyof typeof bcbs_inpatientcopayscode;

	export const bcbs_chiropracticcode = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_chiropracticcode = keyof typeof bcbs_chiropracticcode;

	export const bcbs_hiatypecode = {
		"Deductible Credit(808900000)" : {
			name: "Deductible Credit",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Deductible Credit",
			value: 808900000,
			order: 1,
		},
		"Gift Card(808900001)" : {
			name: "Gift Card",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Gift Card",
			value: 808900001,
			order: 2,
		},
		"None(808900002)" : {
			name: "None",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "None",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_hiatypecode = keyof typeof bcbs_hiatypecode;

	export const bcbs_rxstandardcopayscode = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_rxstandardcopayscode = keyof typeof bcbs_rxstandardcopayscode;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		"Won(808900001)" : {
			name: "Won",
			value: 808900001,
			order: 3,
		},
		808900001 : {
			name: "Won",
			value: 808900001,
			order: 3,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const bcbs_isbenefitsgenerated = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isbenefitsgenerated = keyof typeof bcbs_isbenefitsgenerated;

	export const bcbs_dentaldeductibletypecode = {
		"Regular Deductible(808900000)" : {
			name: "Regular Deductible",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Regular Deductible",
			value: 808900000,
			order: 1,
		},
		"True Family Aggregate(808900001)" : {
			name: "True Family Aggregate",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "True Family Aggregate",
			value: 808900001,
			order: 2,
		},
	}
	export type Tbcbs_dentaldeductibletypecode = keyof typeof bcbs_dentaldeductibletypecode;

	export const bcbs_medicaldeductibletypecode = {
		"Aggregate(808900000)" : {
			name: "Aggregate",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Aggregate",
			value: 808900000,
			order: 1,
		},
		"Embedded(808900001)" : {
			name: "Embedded",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Embedded",
			value: 808900001,
			order: 2,
		},
	}
	export type Tbcbs_medicaldeductibletypecode = keyof typeof bcbs_medicaldeductibletypecode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_orthodonticscovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_orthodonticscovered = keyof typeof bcbs_orthodonticscovered;

	export const bcbs_ercopaycode = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_ercopaycode = keyof typeof bcbs_ercopaycode;

}

export namespace bcbs_config_tab {
	export const bcbs_isalwaysvisible = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isalwaysvisible = keyof typeof bcbs_isalwaysvisible;

	export const bcbs_iscancellation = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_iscancellation = keyof typeof bcbs_iscancellation;

	export const bcbs_isreleased = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isreleased = keyof typeof bcbs_isreleased;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

}

export namespace bcbs_sbc {
	export const bcbs_calc_profservicespttype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_profservicespttype = keyof typeof bcbs_calc_profservicespttype;

	export const bcbs_calc_diagservicesradtype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_diagservicesradtype = keyof typeof bcbs_calc_diagservicesradtype;

	export const bcbs_calc_ambulancetype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_ambulancetype = keyof typeof bcbs_calc_ambulancetype;

	export const bcbs_coinsurancemayapply = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_coinsurancemayapply = keyof typeof bcbs_coinsurancemayapply;

	export const bcbs_rx_preferred_mail_separaterxded = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_rx_preferred_mail_separaterxded = keyof typeof bcbs_rx_preferred_mail_separaterxded;

	export const bcbs_ss_ded_ans = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(2)" : {
			name: "No",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_ss_ded_ans = keyof typeof bcbs_ss_ded_ans;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_snc_yn = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(2)" : {
			name: "No",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_snc_yn = keyof typeof bcbs_snc_yn;

	export const bcbs_numtiers = {
		"1(1)" : {
			name: "1",
			value: 1,
			order: 1,
		},
		1 : {
			name: "1",
			value: 1,
			order: 1,
		},
		"2(2)" : {
			name: "2",
			value: 2,
			order: 2,
		},
		2 : {
			name: "2",
			value: 2,
			order: 2,
		},
		"3(3)" : {
			name: "3",
			value: 3,
			order: 3,
		},
		3 : {
			name: "3",
			value: 3,
			order: 3,
		},
	}
	export type Tbcbs_numtiers = keyof typeof bcbs_numtiers;

	export const bcbs_grandfathered = {
		"NonGrandfather(100000000)" : {
			name: "NonGrandfather",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "NonGrandfather",
			value: 100000000,
			order: 1,
		},
		"Grandfather(100000001)" : {
			name: "Grandfather",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Grandfather",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_grandfathered = keyof typeof bcbs_grandfathered;

	export const bcbs_preferredmailtieroption = {
		"Minimum(1)" : {
			name: "Minimum",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Minimum",
			value: 1,
			order: 1,
		},
		"Maximum(2)" : {
			name: "Maximum",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Maximum",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_preferredmailtieroption = keyof typeof bcbs_preferredmailtieroption;

	export const bcbs_ded_oop_coinsurance = {
		"Included(1)" : {
			name: "Included",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Included",
			value: 1,
			order: 1,
		},
		"Excluded(0)" : {
			name: "Excluded",
			value: 0,
			order: 2,
		},
		0 : {
			name: "Excluded",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ded_oop_coinsurance = keyof typeof bcbs_ded_oop_coinsurance;

	export const bcbs_genericretailtieroption = {
		"Minimum(1)" : {
			name: "Minimum",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Minimum",
			value: 1,
			order: 1,
		},
		"Maximum(2)" : {
			name: "Maximum",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Maximum",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_genericretailtieroption = keyof typeof bcbs_genericretailtieroption;

	export const bcbs_deductiblemayapply = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_deductiblemayapply = keyof typeof bcbs_deductiblemayapply;

	export const bcbs_calc_otheritemsservicesooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_otheritemsservicesooplimit = keyof typeof bcbs_calc_otheritemsservicesooplimit;

	export const bcbs_calc_medicalsuppliesooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_medicalsuppliesooplimit = keyof typeof bcbs_calc_medicalsuppliesooplimit;

	export const bcbs_diabetes = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(2)" : {
			name: "No",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_diabetes = keyof typeof bcbs_diabetes;

	export const bcbs_calchosptype = {
		"Copayment(1)" : {
			name: "Copayment",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Copayment",
			value: 1,
			order: 1,
		},
		"Coinsurance(2)" : {
			name: "Coinsurance",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Coinsurance",
			value: 2,
			order: 2,
		},
		"No Cost Sharing(3)" : {
			name: "No Cost Sharing",
			value: 3,
			order: 3,
		},
		3 : {
			name: "No Cost Sharing",
			value: 3,
			order: 3,
		},
		"Not Covered(4)" : {
			name: "Not Covered",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Not Covered",
			value: 4,
			order: 4,
		},
	}
	export type Tbcbs_calchosptype = keyof typeof bcbs_calchosptype;

	export const bcbs_rx_integrateonmedicaldeductible = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_rx_integrateonmedicaldeductible = keyof typeof bcbs_rx_integrateonmedicaldeductible;

	export const bcbs_calc_inpathoscareooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_inpathoscareooplimit = keyof typeof bcbs_calc_inpathoscareooplimit;

	export const bcbs_acupchk = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_acupchk = keyof typeof bcbs_acupchk;

	export const bcbs_nonemergchk = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_nonemergchk = keyof typeof bcbs_nonemergchk;

	export const bcbs_calc_otheritemsservicestype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_otheritemsservicestype = keyof typeof bcbs_calc_otheritemsservicestype;

	export const bcbs_nonpreferredmailtieroption = {
		"Minimum(1)" : {
			name: "Minimum",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Minimum",
			value: 1,
			order: 1,
		},
		"Maximum(2)" : {
			name: "Maximum",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Maximum",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_nonpreferredmailtieroption = keyof typeof bcbs_nonpreferredmailtieroption;

	export const bcbs_bcbs_privnurschk = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_bcbs_privnurschk = keyof typeof bcbs_bcbs_privnurschk;

	export const bcbs_calcvisittype = {
		"Copayment(1)" : {
			name: "Copayment",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Copayment",
			value: 1,
			order: 1,
		},
		"Coinsurance(2)" : {
			name: "Coinsurance",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Coinsurance",
			value: 2,
			order: 2,
		},
		"No Cost Sharing(3)" : {
			name: "No Cost Sharing",
			value: 3,
			order: 3,
		},
		3 : {
			name: "No Cost Sharing",
			value: 3,
			order: 3,
		},
		"Not Covered(4)" : {
			name: "Not Covered",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Not Covered",
			value: 4,
			order: 4,
		},
	}
	export type Tbcbs_calcvisittype = keyof typeof bcbs_calcvisittype;

	export const bcbs_calc_presdrugsbrandedtype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_presdrugsbrandedtype = keyof typeof bcbs_calc_presdrugsbrandedtype;

	export const bcbs_calc_profservicesprimcaretype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_profservicesprimcaretype = keyof typeof bcbs_calc_profservicesprimcaretype;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const bcbs_calc_profservicesspecialistooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_profservicesspecialistooplimit = keyof typeof bcbs_calc_profservicesspecialistooplimit;

	export const bcbs_calc_presdrugsbrandedooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_presdrugsbrandedooplimit = keyof typeof bcbs_calc_presdrugsbrandedooplimit;

	export const bcbs_calc_presdrugsgenericooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_presdrugsgenericooplimit = keyof typeof bcbs_calc_presdrugsgenericooplimit;

	export const bcbs_calc_diagserviceslabooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_diagserviceslabooplimit = keyof typeof bcbs_calc_diagserviceslabooplimit;

	export const bcbs_calcobgyntype = {
		"Copayment(1)" : {
			name: "Copayment",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Copayment",
			value: 1,
			order: 1,
		},
		"Coinsurance(2)" : {
			name: "Coinsurance",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Coinsurance",
			value: 2,
			order: 2,
		},
		"No Cost Sharing(3)" : {
			name: "No Cost Sharing",
			value: 3,
			order: 3,
		},
		3 : {
			name: "No Cost Sharing",
			value: 3,
			order: 3,
		},
		"Not Covered(4)" : {
			name: "Not Covered",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Not Covered",
			value: 4,
			order: 4,
		},
	}
	export type Tbcbs_calcobgyntype = keyof typeof bcbs_calcobgyntype;

	export const bcbs_net_prov_yn = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(2)" : {
			name: "No",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_net_prov_yn = keyof typeof bcbs_net_prov_yn;

	export const bcbs_calc_diagservicesradooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_diagservicesradooplimit = keyof typeof bcbs_calc_diagservicesradooplimit;

	export const bcbs_routineeyechk = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_routineeyechk = keyof typeof bcbs_routineeyechk;

	export const bcbs_excludedservices6 = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_excludedservices6 = keyof typeof bcbs_excludedservices6;

	export const bcbs_calc_otherfacilityservicestype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_otherfacilityservicestype = keyof typeof bcbs_calc_otherfacilityservicestype;

	export const bcbs_ltcchk = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_ltcchk = keyof typeof bcbs_ltcchk;

	export const bcbs_dentcarechk = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_dentcarechk = keyof typeof bcbs_dentcarechk;

	export const bcbs_erisa = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(2)" : {
			name: "No",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_erisa = keyof typeof bcbs_erisa;

	export const bcbs_calc_profservicesemerdepartmentooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_profservicesemerdepartmentooplimit = keyof typeof bcbs_calc_profservicesemerdepartmentooplimit;

	export const bcbs_calc_medicalsuppliestype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_medicalsuppliestype = keyof typeof bcbs_calc_medicalsuppliestype;

	export const bcbs_routinefootchk = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_routinefootchk = keyof typeof bcbs_routinefootchk;

	export const bcbs_minimumessentialcoverage = {
		"(100000002)" : {
			name: "",
			value: 100000002,
			order: 1,
		},
		100000002 : {
			name: "",
			value: 100000002,
			order: 1,
		},
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 2,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 2,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 3,
		},
	}
	export type Tbcbs_minimumessentialcoverage = keyof typeof bcbs_minimumessentialcoverage;

	export const bcbs_activeenrollment = {
		"No(1)" : {
			name: "No",
			value: 1,
			order: 1,
		},
		1 : {
			name: "No",
			value: 1,
			order: 1,
		},
		"Yes(2)" : {
			name: "Yes",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Yes",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_activeenrollment = keyof typeof bcbs_activeenrollment;

	export const bcbs_maternity = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(2)" : {
			name: "No",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_maternity = keyof typeof bcbs_maternity;

	export const bcbs_rx_preferred_retail_separaterxded = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_rx_preferred_retail_separaterxded = keyof typeof bcbs_rx_preferred_retail_separaterxded;

	export const bcbs_copaymentmayapply = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_copaymentmayapply = keyof typeof bcbs_copaymentmayapply;

	export const bcbs_calc_profservicesprocedurestype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_profservicesprocedurestype = keyof typeof bcbs_calc_profservicesprocedurestype;

	export const bcbs_calc_inpathoscaretype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_inpathoscaretype = keyof typeof bcbs_calc_inpathoscaretype;

	export const bcbs_preferredretailtieroption = {
		"Minimum(1)" : {
			name: "Minimum",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Minimum",
			value: 1,
			order: 1,
		},
		"Maximum(2)" : {
			name: "Maximum",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Maximum",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_preferredretailtieroption = keyof typeof bcbs_preferredretailtieroption;

	export const bcbs_rx_nonpreferred_mail_separaterxded = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_rx_nonpreferred_mail_separaterxded = keyof typeof bcbs_rx_nonpreferred_mail_separaterxded;

	export const bcbs_calcradtype = {
		"Copayment(1)" : {
			name: "Copayment",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Copayment",
			value: 1,
			order: 1,
		},
		"Coinsurance(2)" : {
			name: "Coinsurance",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Coinsurance",
			value: 2,
			order: 2,
		},
		"No Cost Sharing(3)" : {
			name: "No Cost Sharing",
			value: 3,
			order: 3,
		},
		3 : {
			name: "No Cost Sharing",
			value: 3,
			order: 3,
		},
		"Not Covered(4)" : {
			name: "Not Covered",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Not Covered",
			value: 4,
			order: 4,
		},
	}
	export type Tbcbs_calcradtype = keyof typeof bcbs_calcradtype;

	export const bcbs_excludedservices9 = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_excludedservices9 = keyof typeof bcbs_excludedservices9;

	export const bcbs_rx_generic_mail_separaterxded = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_rx_generic_mail_separaterxded = keyof typeof bcbs_rx_generic_mail_separaterxded;

	export const bcbs_cosmsurchk = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_cosmsurchk = keyof typeof bcbs_cosmsurchk;

	export const bcbs_nonpreferredretailtieroption = {
		"Minimum(1)" : {
			name: "Minimum",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Minimum",
			value: 1,
			order: 1,
		},
		"Maximum(2)" : {
			name: "Maximum",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Maximum",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_nonpreferredretailtieroption = keyof typeof bcbs_nonpreferredretailtieroption;

	export const bcbs_specialtydrugnetworks = {
		"Cover at PBM Specialty RX ONLY No retail Rx fills allowed(1)" : {
			name: "Cover at PBM Specialty RX ONLY No retail Rx fills allowed",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Cover at PBM Specialty RX ONLY No retail Rx fills allowed",
			value: 1,
			order: 1,
		},
		"Cover at all network pharmacies(2)" : {
			name: "Cover at all network pharmacies",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Cover at all network pharmacies",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_specialtydrugnetworks = keyof typeof bcbs_specialtydrugnetworks;

	export const bcbs_calc_otcdrugstype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_otcdrugstype = keyof typeof bcbs_calc_otcdrugstype;

	export const bcbs_fundingtype = {
		"Administrative Services Only(808900000)" : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		"ASO with Stop Loss(808900001)" : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		"Fully Insured(808900002)" : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		"National Alliance(808900003)" : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		"Level Funded(808900004)" : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
	}
	export type Tbcbs_fundingtype = keyof typeof bcbs_fundingtype;

	export const bcbs_minimumvaluestandards = {
		"(100000002)" : {
			name: "",
			value: 100000002,
			order: 1,
		},
		100000002 : {
			name: "",
			value: 100000002,
			order: 1,
		},
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 2,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 2,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 3,
		},
	}
	export type Tbcbs_minimumvaluestandards = keyof typeof bcbs_minimumvaluestandards;

	export const bcbs_spec_ref_yn = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(2)" : {
			name: "No",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_spec_ref_yn = keyof typeof bcbs_spec_ref_yn;

	export const bcbs_ded_oop_per_occurrence = {
		"Included(1)" : {
			name: "Included",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Included",
			value: 1,
			order: 1,
		},
		"Excluded(0)" : {
			name: "Excluded",
			value: 0,
			order: 2,
		},
		0 : {
			name: "Excluded",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ded_oop_per_occurrence = keyof typeof bcbs_ded_oop_per_occurrence;

	export const bcbs_calc_dmetype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_dmetype = keyof typeof bcbs_calc_dmetype;

	export const bcbs_manuallyeditedpdf = {
		"No(1)" : {
			name: "No",
			value: 1,
			order: 1,
		},
		1 : {
			name: "No",
			value: 1,
			order: 1,
		},
		"Yes(2)" : {
			name: "Yes",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Yes",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_manuallyeditedpdf = keyof typeof bcbs_manuallyeditedpdf;

	export const bcbs_excludedservices10 = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_excludedservices10 = keyof typeof bcbs_excludedservices10;

	export const bcbs_calc_profservicesobsetriccaretype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_profservicesobsetriccaretype = keyof typeof bcbs_calc_profservicesobsetriccaretype;

	export const bcbs_excludedservices7 = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_excludedservices7 = keyof typeof bcbs_excludedservices7;

	export const bcbs_genericmailtieroption = {
		"Minimum(1)" : {
			name: "Minimum",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Minimum",
			value: 1,
			order: 1,
		},
		"Maximum(2)" : {
			name: "Maximum",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Maximum",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_genericmailtieroption = keyof typeof bcbs_genericmailtieroption;

	export const bcbs_plan_type = {
		"Standard PPO(1)" : {
			name: "Standard PPO",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Standard PPO",
			value: 1,
			order: 1,
		},
		"3 Tier PPO(2)" : {
			name: "3 Tier PPO",
			value: 2,
			order: 2,
		},
		2 : {
			name: "3 Tier PPO",
			value: 2,
			order: 2,
		},
		"Comprehensive(3)" : {
			name: "Comprehensive",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Comprehensive",
			value: 3,
			order: 3,
		},
		"PPO with HSA(4)" : {
			name: "PPO with HSA",
			value: 4,
			order: 4,
		},
		4 : {
			name: "PPO with HSA",
			value: 4,
			order: 4,
		},
		"EPO(5)" : {
			name: "EPO",
			value: 5,
			order: 5,
		},
		5 : {
			name: "EPO",
			value: 5,
			order: 5,
		},
		"3 Tier EPO(6)" : {
			name: "3 Tier EPO",
			value: 6,
			order: 6,
		},
		6 : {
			name: "3 Tier EPO",
			value: 6,
			order: 6,
		},
	}
	export type Tbcbs_plan_type = keyof typeof bcbs_plan_type;

	export const bcbs_hearaidchk = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_hearaidchk = keyof typeof bcbs_hearaidchk;

	export const bcbs_calc_prevservicesvaccinesooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_prevservicesvaccinesooplimit = keyof typeof bcbs_calc_prevservicesvaccinesooplimit;

	export const bcbs_ded_oop_benefit_yr_ded = {
		"Included(1)" : {
			name: "Included",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Included",
			value: 1,
			order: 1,
		},
		"Excluded(0)" : {
			name: "Excluded",
			value: 0,
			order: 2,
		},
		0 : {
			name: "Excluded",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ded_oop_benefit_yr_ded = keyof typeof bcbs_ded_oop_benefit_yr_ded;

	export const bcbs_calc_otcmedsuppliesooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_otcmedsuppliesooplimit = keyof typeof bcbs_calc_otcmedsuppliesooplimit;

	export const bcbs_calc_profservicesobsetriccareooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_profservicesobsetriccareooplimit = keyof typeof bcbs_calc_profservicesobsetriccareooplimit;

	export const bcbs_overridegeneral = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_overridegeneral = keyof typeof bcbs_overridegeneral;

	export const bcbs_excludedservices3 = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_excludedservices3 = keyof typeof bcbs_excludedservices3;

	export const bcbs_rx_nonpreferred_retail_separaterxded = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_rx_nonpreferred_retail_separaterxded = keyof typeof bcbs_rx_nonpreferred_retail_separaterxded;

	export const bcbs_calc_emerdepartmenttype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_emerdepartmenttype = keyof typeof bcbs_calc_emerdepartmenttype;

	export const bcbs_calc_diagserviceslabtype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_diagserviceslabtype = keyof typeof bcbs_calc_diagserviceslabtype;

	export const bcbs_calc_dmeooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_dmeooplimit = keyof typeof bcbs_calc_dmeooplimit;

	export const bcbs_excludedservices4 = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_excludedservices4 = keyof typeof bcbs_excludedservices4;

	export const bcbs_calc_profservicesspecialisttype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_profservicesspecialisttype = keyof typeof bcbs_calc_profservicesspecialisttype;

	export const bcbs_ded_oop_per_adminission = {
		"Included(1)" : {
			name: "Included",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Included",
			value: 1,
			order: 1,
		},
		"Excluded(0)" : {
			name: "Excluded",
			value: 0,
			order: 2,
		},
		0 : {
			name: "Excluded",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ded_oop_per_adminission = keyof typeof bcbs_ded_oop_per_adminission;

	export const bcbs_calc_profservicesemerdepartmenttype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_profservicesemerdepartmenttype = keyof typeof bcbs_calc_profservicesemerdepartmenttype;

	export const bcbs_calc_otcmedsuppliestype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_otcmedsuppliestype = keyof typeof bcbs_calc_otcmedsuppliestype;

	export const bcbs_excludedservices1 = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_excludedservices1 = keyof typeof bcbs_excludedservices1;

	export const bcbs_excludedservices2 = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_excludedservices2 = keyof typeof bcbs_excludedservices2;

	export const bcbs_calc_profservicesproceduresooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_profservicesproceduresooplimit = keyof typeof bcbs_calc_profservicesproceduresooplimit;

	export const bcbs_chirochk = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_chirochk = keyof typeof bcbs_chirochk;

	export const bcbs_aggregateooptype = {
		"No  OOP Types 22 and 27(100000000)" : {
			name: "No  OOP Types 22 and 27",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No  OOP Types 22 and 27",
			value: 100000000,
			order: 1,
		},
		"Yes  OOP Type 24(100000001)" : {
			name: "Yes  OOP Type 24",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes  OOP Type 24",
			value: 100000001,
			order: 2,
		},
		"NA  OOP Type 20(100000002)" : {
			name: "NA  OOP Type 20",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "NA  OOP Type 20",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_aggregateooptype = keyof typeof bcbs_aggregateooptype;

	export const bcbs_calc_presdrugsgenerictype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_presdrugsgenerictype = keyof typeof bcbs_calc_presdrugsgenerictype;

	export const bcbs_servicescoveredbeforeded = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_servicescoveredbeforeded = keyof typeof bcbs_servicescoveredbeforeded;

	export const bcbs_calc_prevservicesvaccinestype = {
		"Coinsurance Only(100000008)" : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		100000008 : {
			name: "Coinsurance Only",
			value: 100000008,
			order: 1,
		},
		"Copayment Only(100000007)" : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		100000007 : {
			name: "Copayment Only",
			value: 100000007,
			order: 2,
		},
		"No Cost Sharing(100000001)" : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		100000001 : {
			name: "No Cost Sharing",
			value: 100000001,
			order: 3,
		},
		"Not Covered(100000000)" : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "Not Covered",
			value: 100000000,
			order: 4,
		},
		"Plan Deductible  Coins(100000014)" : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		100000014 : {
			name: "Plan Deductible  Coins",
			value: 100000014,
			order: 5,
		},
		"Plan Deductible  Copay(100000009)" : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		100000009 : {
			name: "Plan Deductible  Copay",
			value: 100000009,
			order: 6,
		},
		"Plan Deductible Only(100000002)" : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "Plan Deductible Only",
			value: 100000002,
			order: 7,
		},
		"Rx Deductible  Coins(100000015)" : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		100000015 : {
			name: "Rx Deductible  Coins",
			value: 100000015,
			order: 8,
		},
		"Rx Deductible  Copay(100000010)" : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		100000010 : {
			name: "Rx Deductible  Copay",
			value: 100000010,
			order: 9,
		},
		"Rx Deductible Only(100000003)" : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
		100000003 : {
			name: "Rx Deductible Only",
			value: 100000003,
			order: 10,
		},
	}
	export type Tbcbs_calc_prevservicesvaccinestype = keyof typeof bcbs_calc_prevservicesvaccinestype;

	export const bcbs_calc_emerdepartmentooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_emerdepartmentooplimit = keyof typeof bcbs_calc_emerdepartmentooplimit;

	export const bcbs_rx_generic_retail_separaterxded = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_rx_generic_retail_separaterxded = keyof typeof bcbs_rx_generic_retail_separaterxded;

	export const bcbs_calcdmetype = {
		"Copayment(1)" : {
			name: "Copayment",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Copayment",
			value: 1,
			order: 1,
		},
		"Coinsurance(2)" : {
			name: "Coinsurance",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Coinsurance",
			value: 2,
			order: 2,
		},
		"No Cost Sharing(3)" : {
			name: "No Cost Sharing",
			value: 3,
			order: 3,
		},
		3 : {
			name: "No Cost Sharing",
			value: 3,
			order: 3,
		},
		"Not Covered(4)" : {
			name: "Not Covered",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Not Covered",
			value: 4,
			order: 4,
		},
	}
	export type Tbcbs_calcdmetype = keyof typeof bcbs_calcdmetype;

	export const bcbs_calc_otcdrugsooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_otcdrugsooplimit = keyof typeof bcbs_calc_otcdrugsooplimit;

	export const bcbs_excludedservices5 = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_excludedservices5 = keyof typeof bcbs_excludedservices5;

	export const bcbs_calclabtype = {
		"Copayment(1)" : {
			name: "Copayment",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Copayment",
			value: 1,
			order: 1,
		},
		"Coinsurance(2)" : {
			name: "Coinsurance",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Coinsurance",
			value: 2,
			order: 2,
		},
		"No Cost Sharing(3)" : {
			name: "No Cost Sharing",
			value: 3,
			order: 3,
		},
		3 : {
			name: "No Cost Sharing",
			value: 3,
			order: 3,
		},
		"Not Covered(4)" : {
			name: "Not Covered",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Not Covered",
			value: 4,
			order: 4,
		},
	}
	export type Tbcbs_calclabtype = keyof typeof bcbs_calclabtype;

	export const bcbs_calcrxtype = {
		"Copayment(1)" : {
			name: "Copayment",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Copayment",
			value: 1,
			order: 1,
		},
		"Coinsurance(2)" : {
			name: "Coinsurance",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Coinsurance",
			value: 2,
			order: 2,
		},
		"No Cost Sharing(3)" : {
			name: "No Cost Sharing",
			value: 3,
			order: 3,
		},
		3 : {
			name: "No Cost Sharing",
			value: 3,
			order: 3,
		},
		"Not Covered(4)" : {
			name: "Not Covered",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Not Covered",
			value: 4,
			order: 4,
		},
	}
	export type Tbcbs_calcrxtype = keyof typeof bcbs_calcrxtype;

	export const bcbs_barsurchk = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_barsurchk = keyof typeof bcbs_barsurchk;

	export const bcbs_sbctype = {
		"InProgress(1)" : {
			name: "InProgress",
			value: 1,
			order: 1,
		},
		1 : {
			name: "InProgress",
			value: 1,
			order: 1,
		},
		"Ready(6)" : {
			name: "Ready",
			value: 6,
			order: 2,
		},
		6 : {
			name: "Ready",
			value: 6,
			order: 2,
		},
		"Processing(3)" : {
			name: "Processing",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Processing",
			value: 3,
			order: 3,
		},
		"Final(2)" : {
			name: "Final",
			value: 2,
			order: 4,
		},
		2 : {
			name: "Final",
			value: 2,
			order: 4,
		},
		"Failed to Process(4)" : {
			name: "Failed to Process",
			value: 4,
			order: 5,
		},
		4 : {
			name: "Failed to Process",
			value: 4,
			order: 5,
		},
		"Failure Acknowledged(5)" : {
			name: "Failure Acknowledged",
			value: 5,
			order: 6,
		},
		5 : {
			name: "Failure Acknowledged",
			value: 5,
			order: 6,
		},
	}
	export type Tbcbs_sbctype = keyof typeof bcbs_sbctype;

	export const bcbs_calcprevtype = {
		"Copayment(1)" : {
			name: "Copayment",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Copayment",
			value: 1,
			order: 1,
		},
		"Coinsurance(2)" : {
			name: "Coinsurance",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Coinsurance",
			value: 2,
			order: 2,
		},
		"No Cost Sharing(3)" : {
			name: "No Cost Sharing",
			value: 3,
			order: 3,
		},
		3 : {
			name: "No Cost Sharing",
			value: 3,
			order: 3,
		},
		"Not Covered(4)" : {
			name: "Not Covered",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Not Covered",
			value: 4,
			order: 4,
		},
	}
	export type Tbcbs_calcprevtype = keyof typeof bcbs_calcprevtype;

	export const bcbs_calc_profservicesprimcareooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_profservicesprimcareooplimit = keyof typeof bcbs_calc_profservicesprimcareooplimit;

	export const bcbs_infertchk = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_infertchk = keyof typeof bcbs_infertchk;

	export const bcbs_rx_specialty_separaterxded = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_rx_specialty_separaterxded = keyof typeof bcbs_rx_specialty_separaterxded;

	export const bcbs_calc_ambulanceooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_ambulanceooplimit = keyof typeof bcbs_calc_ambulanceooplimit;

	export const bcbs_calc_otherfacilityservicesooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_otherfacilityservicesooplimit = keyof typeof bcbs_calc_otherfacilityservicesooplimit;

	export const bcbs_calc_profservicesptooplimit = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_calc_profservicesptooplimit = keyof typeof bcbs_calc_profservicesptooplimit;

	export const bcbs_excludedservices8 = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_excludedservices8 = keyof typeof bcbs_excludedservices8;

	export const bcbs_aggregatedeductibletype = {
		"No  Deductible Type 27(100000000)" : {
			name: "No  Deductible Type 27",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No  Deductible Type 27",
			value: 100000000,
			order: 1,
		},
		"Yes  Deductible Types 22 and 23(100000001)" : {
			name: "Yes  Deductible Types 22 and 23",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes  Deductible Types 22 and 23",
			value: 100000001,
			order: 2,
		},
		"NA  Deductible Type 21(100000002)" : {
			name: "NA  Deductible Type 21",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "NA  Deductible Type 21",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_aggregatedeductibletype = keyof typeof bcbs_aggregatedeductibletype;

	export const bcbs_weightlosschk = {
		"Covered(1)" : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Covered",
			value: 1,
			order: 1,
		},
		"Excluded(2)" : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Excluded",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_weightlosschk = keyof typeof bcbs_weightlosschk;

}

export namespace bcbs_sbclog {
	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_status = {
		"Success(1)" : {
			name: "Success",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Success",
			value: 1,
			order: 1,
		},
		"Fail(2)" : {
			name: "Fail",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Fail",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_status = keyof typeof bcbs_status;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const bcbs_function = {
		"Generate(1)" : {
			name: "Generate",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Generate",
			value: 1,
			order: 1,
		},
		"Submit SBC(2)" : {
			name: "Submit SBC",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Submit SBC",
			value: 2,
			order: 2,
		},
		"Print(3)" : {
			name: "Print",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Print",
			value: 3,
			order: 3,
		},
		"Delete(4)" : {
			name: "Delete",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Delete",
			value: 4,
			order: 4,
		},
		"Update(5)" : {
			name: "Update",
			value: 5,
			order: 5,
		},
		5 : {
			name: "Update",
			value: 5,
			order: 5,
		},
		"Submit Group(6)" : {
			name: "Submit Group",
			value: 6,
			order: 6,
		},
		6 : {
			name: "Submit Group",
			value: 6,
			order: 6,
		},
	}
	export type Tbcbs_function = keyof typeof bcbs_function;

}

export namespace bcbs_config_tierlevel {
	export const bcbs_isenablepcpspecialist = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isenablepcpspecialist = keyof typeof bcbs_isenablepcpspecialist;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const bcbs_isallownameupdate = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isallownameupdate = keyof typeof bcbs_isallownameupdate;

	export const bcbs_isreleased = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isreleased = keyof typeof bcbs_isreleased;

}

export namespace bcbs_sbcconfig {
	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_fundingtypeid = {
		"Administrative Services Only(808900000)" : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		"ASO with Stop Loss(808900001)" : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		"Fully Insured(808900002)" : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		"National Alliance(808900003)" : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		"Level Funded(808900004)" : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
	}
	export type Tbcbs_fundingtypeid = keyof typeof bcbs_fundingtypeid;

	export const bcbs_tablocation = {
		"SBC Header and Tracking(1)" : {
			name: "SBC Header and Tracking",
			value: 1,
			order: 1,
		},
		1 : {
			name: "SBC Header and Tracking",
			value: 1,
			order: 1,
		},
		"Important Questions(2)" : {
			name: "Important Questions",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Important Questions",
			value: 2,
			order: 2,
		},
		"Common Medical Event(3)" : {
			name: "Common Medical Event",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Common Medical Event",
			value: 3,
			order: 3,
		},
		"Excluded Services  Other Covered Services(4)" : {
			name: "Excluded Services  Other Covered Services",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Excluded Services  Other Covered Services",
			value: 4,
			order: 4,
		},
		"Coverage Examples(5)" : {
			name: "Coverage Examples",
			value: 5,
			order: 5,
		},
		5 : {
			name: "Coverage Examples",
			value: 5,
			order: 5,
		},
	}
	export type Tbcbs_tablocation = keyof typeof bcbs_tablocation;

}

export namespace bcbs_opportunitybenefit {
	export const bcbs_isoutofpocket = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isoutofpocket = keyof typeof bcbs_isoutofpocket;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_iscoinsurance = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_iscoinsurance = keyof typeof bcbs_iscoinsurance;

	export const bcbs_isdrug = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isdrug = keyof typeof bcbs_isdrug;

	export const bcbs_isdeductible = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isdeductible = keyof typeof bcbs_isdeductible;

	export const bcbs_istruefamilyaggregateonly = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_istruefamilyaggregateonly = keyof typeof bcbs_istruefamilyaggregateonly;

	export const bcbs_isercopayonly = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isercopayonly = keyof typeof bcbs_isercopayonly;

	export const bcbs_isinpatientcopayonly = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isinpatientcopayonly = keyof typeof bcbs_isinpatientcopayonly;

	export const bcbs_yesnocode = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_yesnocode = keyof typeof bcbs_yesnocode;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const bcbs_isorthodonticsonly = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isorthodonticsonly = keyof typeof bcbs_isorthodonticsonly;

	export const bcbs_isregulardeductibleonly = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isregulardeductibleonly = keyof typeof bcbs_isregulardeductibleonly;

	export const bcbs_ischiropracticonly = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ischiropracticonly = keyof typeof bcbs_ischiropracticonly;

	export const bcbs_isrxnonstandardcopaysonly = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isrxnonstandardcopaysonly = keyof typeof bcbs_isrxnonstandardcopaysonly;

}

export namespace bcbs_config_tierset {
	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const bcbs_isreleased = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isreleased = keyof typeof bcbs_isreleased;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

}

export namespace bcbs_config_category {
	export const bcbs_istierenabled = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_istierenabled = keyof typeof bcbs_istierenabled;

	export const bcbs_isenablenonstandard = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isenablenonstandard = keyof typeof bcbs_isenablenonstandard;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_isreleased = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isreleased = keyof typeof bcbs_isreleased;

	export const bcbs_isgrandfatherenabled = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isgrandfatherenabled = keyof typeof bcbs_isgrandfatherenabled;

	export const bcbs_isfundingtypeenabled = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isfundingtypeenabled = keyof typeof bcbs_isfundingtypeenabled;

	export const bcbs_applycopaycoinsuranceset = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_applycopaycoinsuranceset = keyof typeof bcbs_applycopaycoinsuranceset;

}

export namespace bcbs_groupconfigurationsnapshotevent {
	export const bcbs_eventtypeid = {
		"Field Event(808900000)" : {
			name: "Field Event",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Field Event",
			value: 808900000,
			order: 1,
		},
		"Benefit Event(808900001)" : {
			name: "Benefit Event",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Benefit Event",
			value: 808900001,
			order: 2,
		},
	}
	export type Tbcbs_eventtypeid = keyof typeof bcbs_eventtypeid;

	export const bcbs_eventtypecode = {
		"Field Event(808900000)" : {
			name: "Field Event",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Field Event",
			value: 808900000,
			order: 1,
		},
		"Benefit Event(808900001)" : {
			name: "Benefit Event",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Benefit Event",
			value: 808900001,
			order: 2,
		},
	}
	export type Tbcbs_eventtypecode = keyof typeof bcbs_eventtypecode;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const bcbs_eventorigincode = {
		"Clone from Parent(808900000)" : {
			name: "Clone from Parent",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Clone from Parent",
			value: 808900000,
			order: 1,
		},
		"Update(808900001)" : {
			name: "Update",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Update",
			value: 808900001,
			order: 2,
		},
	}
	export type Tbcbs_eventorigincode = keyof typeof bcbs_eventorigincode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_benefitstatus = {
		"In Progress(808900000)" : {
			name: "In Progress",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "In Progress",
			value: 808900000,
			order: 1,
		},
		"Released for Notification(808900001)" : {
			name: "Released for Notification",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Released for Notification",
			value: 808900001,
			order: 2,
		},
		"Cancelled(808900002)" : {
			name: "Cancelled",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Cancelled",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_benefitstatus = keyof typeof bcbs_benefitstatus;

}

export namespace bcbs_config_optionset {
	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_isreleased = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isreleased = keyof typeof bcbs_isreleased;

}

export namespace bcbs_config_release {
	export const statuscode = {
		"Draft(1)" : {
			name: "Draft",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Draft",
			value: 1,
			order: 1,
		},
		"Published(2)" : {
			name: "Published",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Published",
			value: 2,
			order: 2,
		},
		"Retired(808900000)" : {
			name: "Retired",
			value: 808900000,
			order: 3,
		},
		808900000 : {
			name: "Retired",
			value: 808900000,
			order: 3,
		},
		"Retired(808900001)" : {
			name: "Retired",
			value: 808900001,
			order: 4,
		},
		808900001 : {
			name: "Retired",
			value: 808900001,
			order: 4,
		},
		"Cancelled(808900002)" : {
			name: "Cancelled",
			value: 808900002,
			order: 5,
		},
		808900002 : {
			name: "Cancelled",
			value: 808900002,
			order: 5,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

}

export namespace bcbs_opportunityproduct {
	export const bcbs_asoother = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_asoother = keyof typeof bcbs_asoother;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_asovision = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_asovision = keyof typeof bcbs_asovision;

	export const bcbs_activelyatworkprovision = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_activelyatworkprovision = keyof typeof bcbs_activelyatworkprovision;

	export const bcbs_contractbasisasl = {
		"1212(808900000)" : {
			name: "1212",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "1212",
			value: 808900000,
			order: 1,
		},
		"1215(808900001)" : {
			name: "1215",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "1215",
			value: 808900001,
			order: 2,
		},
		"1512(808900002)" : {
			name: "1512",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "1512",
			value: 808900002,
			order: 3,
		},
		"Other(808900003)" : {
			name: "Other",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Other",
			value: 808900003,
			order: 4,
		},
	}
	export type Tbcbs_contractbasisasl = keyof typeof bcbs_contractbasisasl;

	export const bcbs_asomedical = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_asomedical = keyof typeof bcbs_asomedical;

	export const bcbs_asodental = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_asodental = keyof typeof bcbs_asodental;

	export const bcbs_asoprescriptiondrugs = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_asoprescriptiondrugs = keyof typeof bcbs_asoprescriptiondrugs;

	export const bcbs_priorblue = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_priorblue = keyof typeof bcbs_priorblue;

	export const bcbs_quotetypecode = {
		"Administrative Services Only(808900000)" : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		"ASO with Stop Loss(808900001)" : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		"Fully Insured(808900002)" : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		"National Alliance(808900003)" : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		"Level Funded(808900004)" : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
	}
	export type Tbcbs_quotetypecode = keyof typeof bcbs_quotetypecode;

	export const bcbs_contractbasis = {
		"1212(808900000)" : {
			name: "1212",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "1212",
			value: 808900000,
			order: 1,
		},
		"1215(808900001)" : {
			name: "1215",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "1215",
			value: 808900001,
			order: 2,
		},
		"1512(808900002)" : {
			name: "1512",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "1512",
			value: 808900002,
			order: 3,
		},
		"Other(808900003)" : {
			name: "Other",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Other",
			value: 808900003,
			order: 4,
		},
	}
	export type Tbcbs_contractbasis = keyof typeof bcbs_contractbasis;

	export const bcbs_benefityearcode = {
		"Contract(808900000)" : {
			name: "Contract",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Contract",
			value: 808900000,
			order: 1,
		},
		"Calendar(808900001)" : {
			name: "Calendar",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Calendar",
			value: 808900001,
			order: 2,
		},
	}
	export type Tbcbs_benefityearcode = keyof typeof bcbs_benefityearcode;

	export const bcbs_underwritingstatus = {
		"Quoted(808900000)" : {
			name: "Quoted",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Quoted",
			value: 808900000,
			order: 1,
		},
		"Declined to Quote(808900001)" : {
			name: "Declined to Quote",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Declined to Quote",
			value: 808900001,
			order: 2,
		},
		"More Information Needed(808900002)" : {
			name: "More Information Needed",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "More Information Needed",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_underwritingstatus = keyof typeof bcbs_underwritingstatus;

	export const bcbs_commissionpercentordollarcode = {
		"Percent (808900000)" : {
			name: "Percent ",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Percent ",
			value: 808900000,
			order: 1,
		},
		"Dollar (808900001)" : {
			name: "Dollar ",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Dollar ",
			value: 808900001,
			order: 2,
		},
	}
	export type Tbcbs_commissionpercentordollarcode = keyof typeof bcbs_commissionpercentordollarcode;

	export const bcbs_producttypecode = {
		"Medical(808900000)" : {
			name: "Medical",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Medical",
			value: 808900000,
			order: 1,
		},
		"Dental(808900001)" : {
			name: "Dental",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Dental",
			value: 808900001,
			order: 2,
		},
	}
	export type Tbcbs_producttypecode = keyof typeof bcbs_producttypecode;

	export const bcbs_priorcarrierdeductiblecarryovercode = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_priorcarrierdeductiblecarryovercode = keyof typeof bcbs_priorcarrierdeductiblecarryovercode;

	export const bcbs_corridor = {
		"125 Standard(808900000)" : {
			name: "125 Standard",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "125 Standard",
			value: 808900000,
			order: 1,
		},
		"Other(808900001)" : {
			name: "Other",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Other",
			value: 808900001,
			order: 2,
		},
	}
	export type Tbcbs_corridor = keyof typeof bcbs_corridor;

}

export namespace bcbs_config_variable {
	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

}

export namespace bcbs_config_securable {
	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

}

export namespace bcbs_config_section {
	export const bcbs_isreleased = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isreleased = keyof typeof bcbs_isreleased;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_isalwaysvisible = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isalwaysvisible = keyof typeof bcbs_isalwaysvisible;

	export const bcbs_isenablenonstandard = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isenablenonstandard = keyof typeof bcbs_isenablenonstandard;

}

export namespace bcbs_config_optionsetitem {
	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const bcbs_isreleased = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isreleased = keyof typeof bcbs_isreleased;

}

export namespace bcbs_grouplibraryprocess {
	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const bcbs_processstate = {
		"Started(808900000)" : {
			name: "Started",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Started",
			value: 808900000,
			order: 1,
		},
		"In Progress(808900001)" : {
			name: "In Progress",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "In Progress",
			value: 808900001,
			order: 2,
		},
		"Completed(808900002)" : {
			name: "Completed",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Completed",
			value: 808900002,
			order: 3,
		},
		"Failed(808900003)" : {
			name: "Failed",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Failed",
			value: 808900003,
			order: 4,
		},
	}
	export type Tbcbs_processstate = keyof typeof bcbs_processstate;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

}

export namespace bcbs_bncreport {
	export const bcbs_ispharmacybenefitscovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_ispharmacybenefitscovered = keyof typeof bcbs_ispharmacybenefitscovered;

	export const bcbs_pdncovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_pdncovered = keyof typeof bcbs_pdncovered;

	export const bcbs_growthhormone = {
		"Option1(100000000)" : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		"Option2(100000001)" : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		"Option3(100000002)" : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_growthhormone = keyof typeof bcbs_growthhormone;

	export const bcbs_cranialexclusion = {
		"Option1(100000000)" : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		"Option2(100000001)" : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		"Option3(100000002)" : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_cranialexclusion = keyof typeof bcbs_cranialexclusion;

	export const bcbs_livinghotdonorexpensescovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_livinghotdonorexpensescovered = keyof typeof bcbs_livinghotdonorexpensescovered;

	export const bcbs_epo_innetworkchirservices = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(2)" : {
			name: "No",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No",
			value: 2,
			order: 2,
		},
		"NA(3)" : {
			name: "NA",
			value: 3,
			order: 3,
		},
		3 : {
			name: "NA",
			value: 3,
			order: 3,
		},
	}
	export type Tbcbs_epo_innetworkchirservices = keyof typeof bcbs_epo_innetworkchirservices;

	export const bcbs_cv_generic_copay_option_gen_drugs_pp = {
		"Covered(100000000)" : {
			name: "Covered",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Covered",
			value: 100000000,
			order: 1,
		},
		"Not Covered(100000001)" : {
			name: "Not Covered",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Not Covered",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_cv_generic_copay_option_gen_drugs_pp = keyof typeof bcbs_cv_generic_copay_option_gen_drugs_pp;

	export const bcbs_numberoftiers = {
		"1(100000000)" : {
			name: "1",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "1",
			value: 100000000,
			order: 1,
		},
		"2(100000001)" : {
			name: "2",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "2",
			value: 100000001,
			order: 2,
		},
		"3(100000002)" : {
			name: "3",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "3",
			value: 100000002,
			order: 3,
		},
		"4(100000003)" : {
			name: "4",
			value: 100000003,
			order: 4,
		},
		100000003 : {
			name: "4",
			value: 100000003,
			order: 4,
		},
	}
	export type Tbcbs_numberoftiers = keyof typeof bcbs_numberoftiers;

	export const bcbs_nodme = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_nodme = keyof typeof bcbs_nodme;

	export const bcbs_epo_aremhsubenefitscovered = {
		"Under BCBS Medical(1)" : {
			name: "Under BCBS Medical",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Under BCBS Medical",
			value: 1,
			order: 1,
		},
		"No Coverage(2)" : {
			name: "No Coverage",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No Coverage",
			value: 2,
			order: 2,
		},
		"Vendor other than BCBS(3)" : {
			name: "Vendor other than BCBS",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Vendor other than BCBS",
			value: 3,
			order: 3,
		},
	}
	export type Tbcbs_epo_aremhsubenefitscovered = keyof typeof bcbs_epo_aremhsubenefitscovered;

	export const bcbs_ifinandoutofnetworkpaythesameoonbyamb = {
		"NA(1)" : {
			name: "NA",
			value: 1,
			order: 1,
		},
		1 : {
			name: "NA",
			value: 1,
			order: 1,
		},
		"In Network(2)" : {
			name: "In Network",
			value: 2,
			order: 2,
		},
		2 : {
			name: "In Network",
			value: 2,
			order: 2,
		},
		"Out of Network(3)" : {
			name: "Out of Network",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Out of Network",
			value: 3,
			order: 3,
		},
	}
	export type Tbcbs_ifinandoutofnetworkpaythesameoonbyamb = keyof typeof bcbs_ifinandoutofnetworkpaythesameoonbyamb;

	export const bcbs_papcovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_papcovered = keyof typeof bcbs_papcovered;

	export const bcbs_orthognathic = {
		"Option1(100000000)" : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		"Option2(100000001)" : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_orthognathic = keyof typeof bcbs_orthognathic;

	export const bcbs_dieticiansacceptedproviders = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_dieticiansacceptedproviders = keyof typeof bcbs_dieticiansacceptedproviders;

	export const bcbs_epo_orthognathicsurgeriescoveredat = {
		"Cover if disorders are attributed to the malposition of the bones and muscles including factor not specific to teeth chewing biting and related dental conditions(100000000)" : {
			name: "Cover if disorders are attributed to the malposition of the bones and muscles including factor not specific to teeth chewing biting and related dental conditions",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Cover if disorders are attributed to the malposition of the bones and muscles including factor not specific to teeth chewing biting and related dental conditions",
			value: 100000000,
			order: 1,
		},
		"Cover if the disorders are attributed to the malposition of the bones and muscles regardless of the symptoms including dental related orthognathic conditions(100000001)" : {
			name: "Cover if the disorders are attributed to the malposition of the bones and muscles regardless of the symptoms including dental related orthognathic conditions",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Cover if the disorders are attributed to the malposition of the bones and muscles regardless of the symptoms including dental related orthognathic conditions",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_epo_orthognathicsurgeriescoveredat = keyof typeof bcbs_epo_orthognathicsurgeriescoveredat;

	export const bcbs_isobesitycovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_isobesitycovered = keyof typeof bcbs_isobesitycovered;

	export const bcbs_containsrsp = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_containsrsp = keyof typeof bcbs_containsrsp;

	export const bcbs_prostheticexclusion = {
		"Option1(100000000)" : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		"Option2(100000001)" : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		"Option3(100000002)" : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_prostheticexclusion = keyof typeof bcbs_prostheticexclusion;

	export const bcbs_sust_health_covered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_sust_health_covered = keyof typeof bcbs_sust_health_covered;

	export const bcbs_cochlearimplantscovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_cochlearimplantscovered = keyof typeof bcbs_cochlearimplantscovered;

	export const bcbs_tensinofficecovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_tensinofficecovered = keyof typeof bcbs_tensinofficecovered;

	export const bcbs_oplabequalsophosptial = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_oplabequalsophosptial = keyof typeof bcbs_oplabequalsophosptial;

	export const bcbs_hospiceexclusion = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_hospiceexclusion = keyof typeof bcbs_hospiceexclusion;

	export const bcbs_residentialtreatmentcenters = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_residentialtreatmentcenters = keyof typeof bcbs_residentialtreatmentcenters;

	export const bcbs_diagnosisandtestingforinfertilitycovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_diagnosisandtestingforinfertilitycovered = keyof typeof bcbs_diagnosisandtestingforinfertilitycovered;

	export const bcbs_pulmonaryexclusion = {
		"Option1(100000000)" : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		"Option2(100000001)" : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		"Option3(100000002)" : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_pulmonaryexclusion = keyof typeof bcbs_pulmonaryexclusion;

	export const bcbs_epo_orthgnathicsurgeriescovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_epo_orthgnathicsurgeriescovered = keyof typeof bcbs_epo_orthgnathicsurgeriescovered;

	export const bcbs_varicoseveintreatmentcovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_varicoseveintreatmentcovered = keyof typeof bcbs_varicoseveintreatmentcovered;

	export const bcbs_epo_outofnetworkchiro100out = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(2)" : {
			name: "No",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No",
			value: 2,
			order: 2,
		},
		"NA(3)" : {
			name: "NA",
			value: 3,
			order: 3,
		},
		3 : {
			name: "NA",
			value: 3,
			order: 3,
		},
	}
	export type Tbcbs_epo_outofnetworkchiro100out = keyof typeof bcbs_epo_outofnetworkchiro100out;

	export const bcbs_nonparticipatingpharmacycovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_nonparticipatingpharmacycovered = keyof typeof bcbs_nonparticipatingpharmacycovered;

	export const bcbs_aggregatedeductibletype = {
		"No  Deductible Type 27(100000000)" : {
			name: "No  Deductible Type 27",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No  Deductible Type 27",
			value: 100000000,
			order: 1,
		},
		"Yes  Deductible Types 22 and 23(100000001)" : {
			name: "Yes  Deductible Types 22 and 23",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes  Deductible Types 22 and 23",
			value: 100000001,
			order: 2,
		},
		"NA  Deductible Type 21(100000002)" : {
			name: "NA  Deductible Type 21",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "NA  Deductible Type 21",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_aggregatedeductibletype = keyof typeof bcbs_aggregatedeductibletype;

	export const bcbs_adjustablecranialorthosescovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_adjustablecranialorthosescovered = keyof typeof bcbs_adjustablecranialorthosescovered;

	export const bcbs_ifinandoutofnetworkpaythesameoonbydsa = {
		"NA(1)" : {
			name: "NA",
			value: 1,
			order: 1,
		},
		1 : {
			name: "NA",
			value: 1,
			order: 1,
		},
		"In Network(2)" : {
			name: "In Network",
			value: 2,
			order: 2,
		},
		2 : {
			name: "In Network",
			value: 2,
			order: 2,
		},
		"Out of Network(3)" : {
			name: "Out of Network",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Out of Network",
			value: 3,
			order: 3,
		},
	}
	export type Tbcbs_ifinandoutofnetworkpaythesameoonbydsa = keyof typeof bcbs_ifinandoutofnetworkpaythesameoonbydsa;

	export const bcbs_fundingtypeid = {
		"Administrative Services Only(808900000)" : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		"ASO with Stop Loss(808900001)" : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		"Fully Insured(808900002)" : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		"National Alliance(808900003)" : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		"Level Funded(808900004)" : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
	}
	export type Tbcbs_fundingtypeid = keyof typeof bcbs_fundingtypeid;

	export const bcbs_trueermatchesnontrueer = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_trueermatchesnontrueer = keyof typeof bcbs_trueermatchesnontrueer;

	export const bcbs_tensunits = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_tensunits = keyof typeof bcbs_tensunits;

	export const bcbs_routinephyagelimit = {
		"No Age Limit(1)" : {
			name: "No Age Limit",
			value: 1,
			order: 1,
		},
		1 : {
			name: "No Age Limit",
			value: 1,
			order: 1,
		},
		"Age Limit Enter(2)" : {
			name: "Age Limit Enter",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Age Limit Enter",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_routinephyagelimit = keyof typeof bcbs_routinephyagelimit;

	export const bcbs_aso_ded_oop_is_oop = {
		"Collective OOP dollars apply to both PB and nonPB maximums even when dollar amounts differ(100000000)" : {
			name: "Collective OOP dollars apply to both PB and nonPB maximums even when dollar amounts differ",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Collective OOP dollars apply to both PB and nonPB maximums even when dollar amounts differ",
			value: 100000000,
			order: 1,
		},
		"Standalone separate(100000001)" : {
			name: "Standalone separate",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Standalone separate",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_aso_ded_oop_is_oop = keyof typeof bcbs_aso_ded_oop_is_oop;

	export const bcbs_mailorderonly = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_mailorderonly = keyof typeof bcbs_mailorderonly;

	export const bcbs_epo_chiropracticserviceslimitestoben = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(3)" : {
			name: "No",
			value: 3,
			order: 2,
		},
		3 : {
			name: "No",
			value: 3,
			order: 2,
		},
	}
	export type Tbcbs_epo_chiropracticserviceslimitestoben = keyof typeof bcbs_epo_chiropracticserviceslimitestoben;

	export const bcbs_bluecardoption = {
		"Option1A(100000000)" : {
			name: "Option1A",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Option1A",
			value: 100000000,
			order: 1,
		},
		"Option2B(100000001)" : {
			name: "Option2B",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Option2B",
			value: 100000001,
			order: 2,
		},
		"Option3C(100000002)" : {
			name: "Option3C",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "Option3C",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_bluecardoption = keyof typeof bcbs_bluecardoption;

	export const bcbs_ispreauthrequired = {
		"Yes(100000000)" : {
			name: "Yes",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Yes",
			value: 100000000,
			order: 1,
		},
		"No(100000001)" : {
			name: "No",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "No",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_ispreauthrequired = keyof typeof bcbs_ispreauthrequired;

	export const bcbs_varicoseexclusion = {
		"Option1(100000000)" : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		"Option2(100000001)" : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		"Option3(100000002)" : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_varicoseexclusion = keyof typeof bcbs_varicoseexclusion;

	export const bcbs_grpconfigservicecenterclaimsprocessing = {
		"Columbia(1)" : {
			name: "Columbia",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Columbia",
			value: 1,
			order: 1,
		},
		"Greenville(2)" : {
			name: "Greenville",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Greenville",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_grpconfigservicecenterclaimsprocessing = keyof typeof bcbs_grpconfigservicecenterclaimsprocessing;

	export const bcbs_chiro_mon_or_max = {
		"Monetary max per benefit period(1)" : {
			name: "Monetary max per benefit period",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Monetary max per benefit period",
			value: 1,
			order: 1,
		},
		"Visit limit benefit period(2)" : {
			name: "Visit limit benefit period",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Visit limit benefit period",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_chiro_mon_or_max = keyof typeof bcbs_chiro_mon_or_max;

	export const bcbs_infertilitytreatmentcovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_infertilitytreatmentcovered = keyof typeof bcbs_infertilitytreatmentcovered;

	export const bcbs_spec_cov_rules_std_ben_smoking = {
		"No coverage(1)" : {
			name: "No coverage",
			value: 1,
			order: 1,
		},
		1 : {
			name: "No coverage",
			value: 1,
			order: 1,
		},
		"Cover at RETAIL and MAIL ORDER(2)" : {
			name: "Cover at RETAIL and MAIL ORDER",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Cover at RETAIL and MAIL ORDER",
			value: 2,
			order: 2,
		},
		"Cover at RETAIL ONLY(3)" : {
			name: "Cover at RETAIL ONLY",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Cover at RETAIL ONLY",
			value: 3,
			order: 3,
		},
		"Cover at MAIL ORDER ONLY(4)" : {
			name: "Cover at MAIL ORDER ONLY",
			value: 4,
			order: 4,
		},
		4 : {
			name: "Cover at MAIL ORDER ONLY",
			value: 4,
			order: 4,
		},
		"ACA Cover at RETAIL and MAIL ORDER(5)" : {
			name: "ACA Cover at RETAIL and MAIL ORDER",
			value: 5,
			order: 5,
		},
		5 : {
			name: "ACA Cover at RETAIL and MAIL ORDER",
			value: 5,
			order: 5,
		},
		"ACA Cover at RETAIL ONLY(6)" : {
			name: "ACA Cover at RETAIL ONLY",
			value: 6,
			order: 6,
		},
		6 : {
			name: "ACA Cover at RETAIL ONLY",
			value: 6,
			order: 6,
		},
		"ACA Cover at MAIL ORDER ONLY(7)" : {
			name: "ACA Cover at MAIL ORDER ONLY",
			value: 7,
			order: 7,
		},
		7 : {
			name: "ACA Cover at MAIL ORDER ONLY",
			value: 7,
			order: 7,
		},
	}
	export type Tbcbs_spec_cov_rules_std_ben_smoking = keyof typeof bcbs_spec_cov_rules_std_ben_smoking;

	export const bcbs_dentalanesthesia = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_dentalanesthesia = keyof typeof bcbs_dentalanesthesia;

	export const bcbs_assistedreproductioncovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_assistedreproductioncovered = keyof typeof bcbs_assistedreproductioncovered;

	export const bcbs_accidentaldentalinjury = {
		"Option1(100000000)" : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		"Option2(100000001)" : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		"Option3(100000002)" : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_accidentaldentalinjury = keyof typeof bcbs_accidentaldentalinjury;

	export const bcbs_aso_ded_oop_per_adminission = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_aso_ded_oop_per_adminission = keyof typeof bcbs_aso_ded_oop_per_adminission;

	export const bcbs_aso_ded_oop_per_occurrence = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_aso_ded_oop_per_occurrence = keyof typeof bcbs_aso_ded_oop_per_occurrence;

	export const bcbs_outofpockettype = {
		"Individual Coinsurance Indicator 20(100000000)" : {
			name: "Individual Coinsurance Indicator 20",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Individual Coinsurance Indicator 20",
			value: 100000000,
			order: 1,
		},
		"Family Coinsurance Indicator 22(100000001)" : {
			name: "Family Coinsurance Indicator 22",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Family Coinsurance Indicator 22",
			value: 100000001,
			order: 2,
		},
		"Individual and Family Combination Coinsurance Indicator 24(100000002)" : {
			name: "Individual and Family Combination Coinsurance Indicator 24",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "Individual and Family Combination Coinsurance Indicator 24",
			value: 100000002,
			order: 3,
		},
		"Individual and Family Coinsurance Based on Member Coverage Status Indicator 27(100000003)" : {
			name: "Individual and Family Coinsurance Based on Member Coverage Status Indicator 27",
			value: 100000003,
			order: 4,
		},
		100000003 : {
			name: "Individual and Family Coinsurance Based on Member Coverage Status Indicator 27",
			value: 100000003,
			order: 4,
		},
	}
	export type Tbcbs_outofpockettype = keyof typeof bcbs_outofpockettype;

	export const bcbs_epoarediabeticsuppliescoveredundermedical = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_epoarediabeticsuppliescoveredundermedical = keyof typeof bcbs_epoarediabeticsuppliescoveredundermedical;

	export const bcbs_epo_allservicesfortmjcovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_epo_allservicesfortmjcovered = keyof typeof bcbs_epo_allservicesfortmjcovered;

	export const bcbs_prostheticce = {
		"Option1(100000000)" : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		"Option2(100000001)" : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		"Option3(100000002)" : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_prostheticce = keyof typeof bcbs_prostheticce;

	export const bcbs_servicescoveredbeforeded = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_servicescoveredbeforeded = keyof typeof bcbs_servicescoveredbeforeded;

	export const bcbs_dependentmaternity = {
		"Option1(100000000)" : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		"Option2(100000001)" : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		"Option3(100000002)" : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
		"Option4(100000003)" : {
			name: "Option4",
			value: 100000003,
			order: 4,
		},
		100000003 : {
			name: "Option4",
			value: 100000003,
			order: 4,
		},
	}
	export type Tbcbs_dependentmaternity = keyof typeof bcbs_dependentmaternity;

	export const bcbs_hypnotismexclusion = {
		"Option1(100000000)" : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		"Option2(100000001)" : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		"Option3(100000002)" : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_hypnotismexclusion = keyof typeof bcbs_hypnotismexclusion;

	export const bcbs_physicalcovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_physicalcovered = keyof typeof bcbs_physicalcovered;

	export const bcbs_aso_ded_oop_per_occurrence_oon = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_aso_ded_oop_per_occurrence_oon = keyof typeof bcbs_aso_ded_oop_per_occurrence_oon;

	export const bcbs_hcr_accidental_dental = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(2)" : {
			name: "No",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No",
			value: 2,
			order: 2,
		},
		"Other(3)" : {
			name: "Other",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Other",
			value: 3,
			order: 3,
		},
	}
	export type Tbcbs_hcr_accidental_dental = keyof typeof bcbs_hcr_accidental_dental;

	export const bcbs_partnerplan = {
		"BCBSAZ(100000012)" : {
			name: "BCBSAZ",
			value: 100000012,
			order: 1,
		},
		100000012 : {
			name: "BCBSAZ",
			value: 100000012,
			order: 1,
		},
		"BCBSNE(100000009)" : {
			name: "BCBSNE",
			value: 100000009,
			order: 2,
		},
		100000009 : {
			name: "BCBSNE",
			value: 100000009,
			order: 2,
		},
		"BCBSRI(100000010)" : {
			name: "BCBSRI",
			value: 100000010,
			order: 3,
		},
		100000010 : {
			name: "BCBSRI",
			value: 100000010,
			order: 3,
		},
		"BCBSF(100000000)" : {
			name: "BCBSF",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "BCBSF",
			value: 100000000,
			order: 4,
		},
		"Blue Cross NC(100000001)" : {
			name: "Blue Cross NC",
			value: 100000001,
			order: 5,
		},
		100000001 : {
			name: "Blue Cross NC",
			value: 100000001,
			order: 5,
		},
		"BCBSVT(100000011)" : {
			name: "BCBSVT",
			value: 100000011,
			order: 6,
		},
		100000011 : {
			name: "BCBSVT",
			value: 100000011,
			order: 6,
		},
		"BCBSKC(100000002)" : {
			name: "BCBSKC",
			value: 100000002,
			order: 7,
		},
		100000002 : {
			name: "BCBSKC",
			value: 100000002,
			order: 7,
		},
		"Blue Cross(100000003)" : {
			name: "Blue Cross",
			value: 100000003,
			order: 8,
		},
		100000003 : {
			name: "Blue Cross",
			value: 100000003,
			order: 8,
		},
		"Excellus BCBS(100000004)" : {
			name: "Excellus BCBS",
			value: 100000004,
			order: 9,
		},
		100000004 : {
			name: "Excellus BCBS",
			value: 100000004,
			order: 9,
		},
		"BlueCross BlueShield(100000005)" : {
			name: "BlueCross BlueShield",
			value: 100000005,
			order: 10,
		},
		100000005 : {
			name: "BlueCross BlueShield",
			value: 100000005,
			order: 10,
		},
		"CareFirst(100000006)" : {
			name: "CareFirst",
			value: 100000006,
			order: 11,
		},
		100000006 : {
			name: "CareFirst",
			value: 100000006,
			order: 11,
		},
		"BlueCross(100000007)" : {
			name: "BlueCross",
			value: 100000007,
			order: 12,
		},
		100000007 : {
			name: "BlueCross",
			value: 100000007,
			order: 12,
		},
		"BCBSKS(100000008)" : {
			name: "BCBSKS",
			value: 100000008,
			order: 13,
		},
		100000008 : {
			name: "BCBSKS",
			value: 100000008,
			order: 13,
		},
		"Capital(100000013)" : {
			name: "Capital",
			value: 100000013,
			order: 14,
		},
		100000013 : {
			name: "Capital",
			value: 100000013,
			order: 14,
		},
		"BSA(100000014)" : {
			name: "BSA",
			value: 100000014,
			order: 15,
		},
		100000014 : {
			name: "BSA",
			value: 100000014,
			order: 15,
		},
	}
	export type Tbcbs_partnerplan = keyof typeof bcbs_partnerplan;

	export const bcbs_grandfathered = {
		"NonGrandfather(100000000)" : {
			name: "NonGrandfather",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "NonGrandfather",
			value: 100000000,
			order: 1,
		},
		"Grandfather(100000001)" : {
			name: "Grandfather",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Grandfather",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_grandfathered = keyof typeof bcbs_grandfathered;

	export const bcbs_isvisioncovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_isvisioncovered = keyof typeof bcbs_isvisioncovered;

	export const bcbs_wigscovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_wigscovered = keyof typeof bcbs_wigscovered;

	export const bcbs_aggregateooptype = {
		"No  OOP Types 22 and 27(100000000)" : {
			name: "No  OOP Types 22 and 27",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No  OOP Types 22 and 27",
			value: 100000000,
			order: 1,
		},
		"Yes  OOP Type 24(100000001)" : {
			name: "Yes  OOP Type 24",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes  OOP Type 24",
			value: 100000001,
			order: 2,
		},
		"NA  OOP Type 20(100000002)" : {
			name: "NA  OOP Type 20",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "NA  OOP Type 20",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_aggregateooptype = keyof typeof bcbs_aggregateooptype;

	export const bcbs_wheelchairlanguage = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_wheelchairlanguage = keyof typeof bcbs_wheelchairlanguage;

	export const bcbs_acc_dental_covered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_acc_dental_covered = keyof typeof bcbs_acc_dental_covered;

	export const bcbs_aso_ded_oop_per_admission_oon = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_aso_ded_oop_per_admission_oon = keyof typeof bcbs_aso_ded_oop_per_admission_oon;

	export const bcbs_wheelchairexclusion3 = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_wheelchairexclusion3 = keyof typeof bcbs_wheelchairexclusion3;

	export const bcbs_generic_incentive_program_options = {
		"HARD GENERIC INCENTIVE(1)" : {
			name: "HARD GENERIC INCENTIVE",
			value: 1,
			order: 1,
		},
		1 : {
			name: "HARD GENERIC INCENTIVE",
			value: 1,
			order: 1,
		},
		"SOFT GENERIC INCENTIVE(2)" : {
			name: "SOFT GENERIC INCENTIVE",
			value: 2,
			order: 2,
		},
		2 : {
			name: "SOFT GENERIC INCENTIVE",
			value: 2,
			order: 2,
		},
		"NO GENERIC INCENTIVE(3)" : {
			name: "NO GENERIC INCENTIVE",
			value: 3,
			order: 3,
		},
		3 : {
			name: "NO GENERIC INCENTIVE",
			value: 3,
			order: 3,
		},
	}
	export type Tbcbs_generic_incentive_program_options = keyof typeof bcbs_generic_incentive_program_options;

	export const bcbs_nutritionalcounselingcovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_nutritionalcounselingcovered = keyof typeof bcbs_nutritionalcounselingcovered;

	export const bcbs_hearingaidexamscovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_hearingaidexamscovered = keyof typeof bcbs_hearingaidexamscovered;

	export const bcbs_fi_ppocompanionchooseone = {
		"One Office visit only Payment will apply Evaluation and Management procedures only(3)" : {
			name: "One Office visit only Payment will apply Evaluation and Management procedures only",
			value: 3,
			order: 1,
		},
		3 : {
			name: "One Office visit only Payment will apply Evaluation and Management procedures only",
			value: 3,
			order: 1,
		},
		"Two  ALL office services including Allergy Injections Dialysis LabsXRaysSurgery and Second Surgical Opinions(4)" : {
			name: "Two  ALL office services including Allergy Injections Dialysis LabsXRaysSurgery and Second Surgical Opinions",
			value: 4,
			order: 2,
		},
		4 : {
			name: "Two  ALL office services including Allergy Injections Dialysis LabsXRaysSurgery and Second Surgical Opinions",
			value: 4,
			order: 2,
		},
		"Three  ALL office services excluding Allergy Injections Dialysis LabsXRaysSurgery and Second Surgical Opinions(5)" : {
			name: "Three  ALL office services excluding Allergy Injections Dialysis LabsXRaysSurgery and Second Surgical Opinions",
			value: 5,
			order: 3,
		},
		5 : {
			name: "Three  ALL office services excluding Allergy Injections Dialysis LabsXRaysSurgery and Second Surgical Opinions",
			value: 5,
			order: 3,
		},
	}
	export type Tbcbs_fi_ppocompanionchooseone = keyof typeof bcbs_fi_ppocompanionchooseone;

	export const bcbs_medicaldeductibletype = {
		"Individual Indicator 21(4)" : {
			name: "Individual Indicator 21",
			value: 4,
			order: 1,
		},
		4 : {
			name: "Individual Indicator 21",
			value: 4,
			order: 1,
		},
		"True Family Aggregate Deductible Indicator 22 Embedded(3)" : {
			name: "True Family Aggregate Deductible Indicator 22 Embedded",
			value: 3,
			order: 2,
		},
		3 : {
			name: "True Family Aggregate Deductible Indicator 22 Embedded",
			value: 3,
			order: 2,
		},
		"Standard Deductible Indicator 23(1)" : {
			name: "Standard Deductible Indicator 23",
			value: 1,
			order: 3,
		},
		1 : {
			name: "Standard Deductible Indicator 23",
			value: 1,
			order: 3,
		},
		"Family Aggregate Deductible Indicator 27(2)" : {
			name: "Family Aggregate Deductible Indicator 27",
			value: 2,
			order: 4,
		},
		2 : {
			name: "Family Aggregate Deductible Indicator 27",
			value: 2,
			order: 4,
		},
	}
	export type Tbcbs_medicaldeductibletype = keyof typeof bcbs_medicaldeductibletype;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const bcbs_immunizationsagelimit = {
		"No Age Limits(1)" : {
			name: "No Age Limits",
			value: 1,
			order: 1,
		},
		1 : {
			name: "No Age Limits",
			value: 1,
			order: 1,
		},
		"Enter Age(2)" : {
			name: "Enter Age",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Enter Age",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_immunizationsagelimit = keyof typeof bcbs_immunizationsagelimit;

	export const bcbs_aso_ded_oop_provisions = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_aso_ded_oop_provisions = keyof typeof bcbs_aso_ded_oop_provisions;

	export const bcbs_hottexclusion = {
		"Option1(100000000)" : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		"Option2(100000001)" : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		"Option3(100000002)" : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_hottexclusion = keyof typeof bcbs_hottexclusion;

	export const bcbs_ss_ded_ans = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(2)" : {
			name: "No",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_ss_ded_ans = keyof typeof bcbs_ss_ded_ans;

	export const bcbs_oopcontributors = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_oopcontributors = keyof typeof bcbs_oopcontributors;

	export const bcbs_asodependentmaternity = {
		"Option1(100000000)" : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		"Option2(100000001)" : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		"Option3(100000002)" : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
		"Option4(100000003)" : {
			name: "Option4",
			value: 100000003,
			order: 4,
		},
		100000003 : {
			name: "Option4",
			value: 100000003,
			order: 4,
		},
		"Option5(100000004)" : {
			name: "Option5",
			value: 100000004,
			order: 5,
		},
		100000004 : {
			name: "Option5",
			value: 100000004,
			order: 5,
		},
	}
	export type Tbcbs_asodependentmaternity = keyof typeof bcbs_asodependentmaternity;

	export const bcbs_diabetespreventionprogramming = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_diabetespreventionprogramming = keyof typeof bcbs_diabetespreventionprogramming;

	export const bcbs_hemophilia = {
		"Option1(100000000)" : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		"Option2(100000001)" : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		"Option3(100000002)" : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_hemophilia = keyof typeof bcbs_hemophilia;

	export const bcbs_net_prov_yn = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(2)" : {
			name: "No",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_net_prov_yn = keyof typeof bcbs_net_prov_yn;

	export const bcbs_erisa = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_erisa = keyof typeof bcbs_erisa;

	export const bcbs_epo_servicesforimpactedteethcovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_epo_servicesforimpactedteethcovered = keyof typeof bcbs_epo_servicesforimpactedteethcovered;

	export const bcbs_epo_drgugsarecoveredunder = {
		"BCBS with Caremark(1)" : {
			name: "BCBS with Caremark",
			value: 1,
			order: 1,
		},
		1 : {
			name: "BCBS with Caremark",
			value: 1,
			order: 1,
		},
		"Direct Contact with Caremark(2)" : {
			name: "Direct Contact with Caremark",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Direct Contact with Caremark",
			value: 2,
			order: 2,
		},
		"CarveOut Vendor(3)" : {
			name: "CarveOut Vendor",
			value: 3,
			order: 3,
		},
		3 : {
			name: "CarveOut Vendor",
			value: 3,
			order: 3,
		},
		"BCBS Rx(100000000)" : {
			name: "BCBS Rx",
			value: 100000000,
			order: 4,
		},
		100000000 : {
			name: "BCBS Rx",
			value: 100000000,
			order: 4,
		},
	}
	export type Tbcbs_epo_drgugsarecoveredunder = keyof typeof bcbs_epo_drgugsarecoveredunder;

	export const bcbs_aso_ded_is_ded = {
		"Collective BYD dollars apply to both PB and nonPB maximums even when dollar amounts differ Standard Option(100000000)" : {
			name: "Collective BYD dollars apply to both PB and nonPB maximums even when dollar amounts differ Standard Option",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Collective BYD dollars apply to both PB and nonPB maximums even when dollar amounts differ Standard Option",
			value: 100000000,
			order: 1,
		},
		"Standalone separate(100000001)" : {
			name: "Standalone separate",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Standalone separate",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_aso_ded_is_ded = keyof typeof bcbs_aso_ded_is_ded;

	export const bcbs_certaindiagexclusion = {
		"Option1(100000000)" : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		"Option2(100000001)" : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		"Option3(100000002)" : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_certaindiagexclusion = keyof typeof bcbs_certaindiagexclusion;

	export const bcbs_wellbabycovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_wellbabycovered = keyof typeof bcbs_wellbabycovered;

	export const bcbs_plan_type = {
		"Standard PPO(1)" : {
			name: "Standard PPO",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Standard PPO",
			value: 1,
			order: 1,
		},
		"3 Tier PPO(2)" : {
			name: "3 Tier PPO",
			value: 2,
			order: 2,
		},
		2 : {
			name: "3 Tier PPO",
			value: 2,
			order: 2,
		},
		"Comprehensive(3)" : {
			name: "Comprehensive",
			value: 3,
			order: 3,
		},
		3 : {
			name: "Comprehensive",
			value: 3,
			order: 3,
		},
		"PPO with HSA(4)" : {
			name: "PPO with HSA",
			value: 4,
			order: 4,
		},
		4 : {
			name: "PPO with HSA",
			value: 4,
			order: 4,
		},
		"EPO(5)" : {
			name: "EPO",
			value: 5,
			order: 5,
		},
		5 : {
			name: "EPO",
			value: 5,
			order: 5,
		},
		"3 Tier EPO(6)" : {
			name: "3 Tier EPO",
			value: 6,
			order: 6,
		},
		6 : {
			name: "3 Tier EPO",
			value: 6,
			order: 6,
		},
	}
	export type Tbcbs_plan_type = keyof typeof bcbs_plan_type;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_genderdysphoriacounselingcovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_genderdysphoriacounselingcovered = keyof typeof bcbs_genderdysphoriacounselingcovered;

	export const bcbs_aso_ded_oop_coinsurance_oon = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_aso_ded_oop_coinsurance_oon = keyof typeof bcbs_aso_ded_oop_coinsurance_oon;

	export const bcbs_aso_ded_oop_benefit_yr_ded = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_aso_ded_oop_benefit_yr_ded = keyof typeof bcbs_aso_ded_oop_benefit_yr_ded;

	export const bcbs_foodsuppliments = {
		"Option1(100000000)" : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		"Option2(100000001)" : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		"Option3(100000002)" : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_foodsuppliments = keyof typeof bcbs_foodsuppliments;

	export const bcbs_aso_ded_oop_coinsurance = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_aso_ded_oop_coinsurance = keyof typeof bcbs_aso_ded_oop_coinsurance;

	export const bcbs_copaycontributestooopmax = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_copaycontributestooopmax = keyof typeof bcbs_copaycontributestooopmax;

	export const bcbs_hhcexclusion = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_hhcexclusion = keyof typeof bcbs_hhcexclusion;

	export const bcbs_hearingaidscovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_hearingaidscovered = keyof typeof bcbs_hearingaidscovered;

	export const bcbs_snc_yn = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(2)" : {
			name: "No",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_snc_yn = keyof typeof bcbs_snc_yn;

	export const bcbs_spec_ref_yn = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(2)" : {
			name: "No",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_spec_ref_yn = keyof typeof bcbs_spec_ref_yn;

	export const bcbs_accidentbenefits = {
		"Accident pays as all other services Standard Option(100000000)" : {
			name: "Accident pays as all other services Standard Option",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Accident pays as all other services Standard Option",
			value: 100000000,
			order: 1,
		},
		"Supplemental accident pays at X up to Xthen subject to contract coinsurance and deductible This provision is per benefit period Fill out below(100000001)" : {
			name: "Supplemental accident pays at X up to Xthen subject to contract coinsurance and deductible This provision is per benefit period Fill out below",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Supplemental accident pays at X up to Xthen subject to contract coinsurance and deductible This provision is per benefit period Fill out below",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_accidentbenefits = keyof typeof bcbs_accidentbenefits;

	export const bcbs_pharmacypaysbycopay = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_pharmacypaysbycopay = keyof typeof bcbs_pharmacypaysbycopay;

	export const bcbs_prescriptiondrugdeductible = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_prescriptiondrugdeductible = keyof typeof bcbs_prescriptiondrugdeductible;

	export const bcbs_flushotsagelimit = {
		"No Age Limit(1)" : {
			name: "No Age Limit",
			value: 1,
			order: 1,
		},
		1 : {
			name: "No Age Limit",
			value: 1,
			order: 1,
		},
		"Enter Age Limit(2)" : {
			name: "Enter Age Limit",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Enter Age Limit",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_flushotsagelimit = keyof typeof bcbs_flushotsagelimit;

	export const bcbs_lifethreateningdepmaternitycovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_lifethreateningdepmaternitycovered = keyof typeof bcbs_lifethreateningdepmaternitycovered;

	export const bcbs_pdexclusion = {
		"Option1(100000000)" : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "Option1",
			value: 100000000,
			order: 1,
		},
		"Option2(100000001)" : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Option2",
			value: 100000001,
			order: 2,
		},
		"Option3(100000002)" : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
		100000002 : {
			name: "Option3",
			value: 100000002,
			order: 3,
		},
	}
	export type Tbcbs_pdexclusion = keyof typeof bcbs_pdexclusion;

	export const bcbs_prostatecovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_prostatecovered = keyof typeof bcbs_prostatecovered;

	export const bcbs_ispreauthorizationrequiredfordmeprostheti = {
		"Yes purchases of Enter Amount(1)" : {
			name: "Yes purchases of Enter Amount",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes purchases of Enter Amount",
			value: 1,
			order: 1,
		},
		"No(2)" : {
			name: "No",
			value: 2,
			order: 2,
		},
		2 : {
			name: "No",
			value: 2,
			order: 2,
		},
	}
	export type Tbcbs_ispreauthorizationrequiredfordmeprostheti = keyof typeof bcbs_ispreauthorizationrequiredfordmeprostheti;

	export const bcbs_impactedteethexclusion = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_impactedteethexclusion = keyof typeof bcbs_impactedteethexclusion;

	export const bcbs_gendersurgerycovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_gendersurgerycovered = keyof typeof bcbs_gendersurgerycovered;

	export const bcbs_mammographycovered = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_mammographycovered = keyof typeof bcbs_mammographycovered;

	export const bcbs_snfexclusion = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_snfexclusion = keyof typeof bcbs_snfexclusion;

	export const bcbs_aso_ded_oop_benefit_yr_ded_oon = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_aso_ded_oop_benefit_yr_ded_oon = keyof typeof bcbs_aso_ded_oop_benefit_yr_ded_oon;

	export const bcbs_immunizationexclusion = {
		"No(100000000)" : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		100000000 : {
			name: "No",
			value: 100000000,
			order: 1,
		},
		"Yes(100000001)" : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
		100000001 : {
			name: "Yes",
			value: 100000001,
			order: 2,
		},
	}
	export type Tbcbs_immunizationexclusion = keyof typeof bcbs_immunizationexclusion;

	export const bcbs_core_disease_management = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_core_disease_management = keyof typeof bcbs_core_disease_management;

	export const bcbs_preventivecarepackage = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_preventivecarepackage = keyof typeof bcbs_preventivecarepackage;

	export const bcbs_ispreauthorizationrequiredforoutpatientfa = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ispreauthorizationrequiredforoutpatientfa = keyof typeof bcbs_ispreauthorizationrequiredforoutpatientfa;

	export const bcbs_areobesityservicescovered = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_areobesityservicescovered = keyof typeof bcbs_areobesityservicescovered;

	export const bcbs_psaslabworkinterpretation = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_psaslabworkinterpretation = keyof typeof bcbs_psaslabworkinterpretation;

	export const bcbs_ancmyhealthessentialsengagementsuiteaso = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ancmyhealthessentialsengagementsuiteaso = keyof typeof bcbs_ancmyhealthessentialsengagementsuiteaso;

	export const bcbs_ispreauthorizationrequiredforinpatientfac = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ispreauthorizationrequiredforinpatientfac = keyof typeof bcbs_ispreauthorizationrequiredforinpatientfac;

	export const bcbs_ded_oop_per_adminission = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ded_oop_per_adminission = keyof typeof bcbs_ded_oop_per_adminission;

	export const bcbs_customarrangements = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_customarrangements = keyof typeof bcbs_customarrangements;

	export const bcbs_other_ben_progs_quantity_v_time = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_other_ben_progs_quantity_v_time = keyof typeof bcbs_other_ben_progs_quantity_v_time;

	export const bcbs_ancbenquitforlife = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ancbenquitforlife = keyof typeof bcbs_ancbenquitforlife;

	export const bcbs_healthcoachingchroniccondition = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_healthcoachingchroniccondition = keyof typeof bcbs_healthcoachingchroniccondition;

	export const bcbs_ishospicesubjecttoanymaximum = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ishospicesubjecttoanymaximum = keyof typeof bcbs_ishospicesubjecttoanymaximum;

	export const bcbs_aremorbidobesityservicescovered = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_aremorbidobesityservicescovered = keyof typeof bcbs_aremorbidobesityservicescovered;

	export const bcbs_mhinpatientrequired = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_mhinpatientrequired = keyof typeof bcbs_mhinpatientrequired;

	export const bcbs_rx_standardpriorauthorizationdruglist = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_rx_standardpriorauthorizationdruglist = keyof typeof bcbs_rx_standardpriorauthorizationdruglist;

	export const bcbs_istravelandlodgingfordonorfamilycovered = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_istravelandlodgingfordonorfamilycovered = keyof typeof bcbs_istravelandlodgingfordonorfamilycovered;

	export const bcbs_alldomesticpartnercoveragesthesame = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_alldomesticpartnercoveragesthesame = keyof typeof bcbs_alldomesticpartnercoveragesthesame;

	export const bcbs_oncologymanagement = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_oncologymanagement = keyof typeof bcbs_oncologymanagement;

	export const bcbs_isoutpatientspeechtherapycovered = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isoutpatientspeechtherapycovered = keyof typeof bcbs_isoutpatientspeechtherapycovered;

	export const bcbs_areinfertilityservicescovered = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_areinfertilityservicescovered = keyof typeof bcbs_areinfertilityservicescovered;

	export const bcbs_ancpersonalhealthassessmentbasic = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ancpersonalhealthassessmentbasic = keyof typeof bcbs_ancpersonalhealthassessmentbasic;

	export const bcbs_subluxcovered = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_subluxcovered = keyof typeof bcbs_subluxcovered;

	export const bcbs_areinfertilityservicessubjecttoanymaximum = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_areinfertilityservicessubjecttoanymaximum = keyof typeof bcbs_areinfertilityservicessubjecttoanymaximum;

	export const bcbs_istravelandlodgingforrecipientfamilycover = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_istravelandlodgingforrecipientfamilycover = keyof typeof bcbs_istravelandlodgingforrecipientfamilycover;

	export const bcbs_ded_oop_benefit_yr_ded = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ded_oop_benefit_yr_ded = keyof typeof bcbs_ded_oop_benefit_yr_ded;

	export const bcbs_domesticpartnerscovered = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_domesticpartnerscovered = keyof typeof bcbs_domesticpartnerscovered;

	export const bcbs_dotheipfacilitybenefitcopayswhenapplicabl = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_dotheipfacilitybenefitcopayswhenapplicabl = keyof typeof bcbs_dotheipfacilitybenefitcopayswhenapplicabl;

	export const bcbs_modalitiescovered = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_modalitiescovered = keyof typeof bcbs_modalitiescovered;

	export const bcbs_doescompanionbenefitalternativecbamanagep = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_doescompanionbenefitalternativecbamanagep = keyof typeof bcbs_doescompanionbenefitalternativecbamanagep;

	export const bcbs_fi_ppoofficevisitscoveredforchiroben = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_fi_ppoofficevisitscoveredforchiroben = keyof typeof bcbs_fi_ppoofficevisitscoveredforchiroben;

	export const bcbs_istravelandlodgingmaximumcombinedforrecip = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_istravelandlodgingmaximumcombinedforrecip = keyof typeof bcbs_istravelandlodgingmaximumcombinedforrecip;

	export const bcbs_try_generics_program = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_try_generics_program = keyof typeof bcbs_try_generics_program;

	export const bcbs_xrayscovered = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_xrayscovered = keyof typeof bcbs_xrayscovered;

	export const bcbs_fi_ppo_modalitiesandtherapiescovered = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_fi_ppo_modalitiesandtherapiescovered = keyof typeof bcbs_fi_ppo_modalitiesandtherapiescovered;

	export const bcbs_epo_xrays = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_epo_xrays = keyof typeof bcbs_epo_xrays;

	export const bcbs_ded_oop_coinsurance = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ded_oop_coinsurance = keyof typeof bcbs_ded_oop_coinsurance;

	export const bcbs_areacupunctureservicescovered = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_areacupunctureservicescovered = keyof typeof bcbs_areacupunctureservicescovered;

	export const bcbs_ancbencomplexcare = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ancbencomplexcare = keyof typeof bcbs_ancbencomplexcare;

	export const bcbs_epo_hasthisgrouppurchasedaba = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_epo_hasthisgrouppurchasedaba = keyof typeof bcbs_epo_hasthisgrouppurchasedaba;

	export const bcbs_rx_clinicalsteptherapyprogram = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_rx_clinicalsteptherapyprogram = keyof typeof bcbs_rx_clinicalsteptherapyprogram;

	export const bcbs_chiroofficevisitscovered = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_chiroofficevisitscovered = keyof typeof bcbs_chiroofficevisitscovered;

	export const bcbs_fi_ppo_manipulationsubluxationcovered = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_fi_ppo_manipulationsubluxationcovered = keyof typeof bcbs_fi_ppo_manipulationsubluxationcovered;

	export const bcbs_haspharmacybenefit = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_haspharmacybenefit = keyof typeof bcbs_haspharmacybenefit;

	export const bcbs_ishomehealthcaresubjecttoanymaximum = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ishomehealthcaresubjecttoanymaximum = keyof typeof bcbs_ishomehealthcaresubjecttoanymaximum;

	export const bcbs_pharmacyisbluerx = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_pharmacyisbluerx = keyof typeof bcbs_pharmacyisbluerx;

	export const bcbs_healthcoachinglifestyle = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_healthcoachinglifestyle = keyof typeof bcbs_healthcoachinglifestyle;

	export const bcbs_naturallyslim = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_naturallyslim = keyof typeof bcbs_naturallyslim;

	export const bcbs_routinebonedensityscreening = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_routinebonedensityscreening = keyof typeof bcbs_routinebonedensityscreening;

	export const bcbs_essentialadvocate = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_essentialadvocate = keyof typeof bcbs_essentialadvocate;

	export const bcbs_aresurgicalproceduresforthetreatmentofmor = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_aresurgicalproceduresforthetreatmentofmor = keyof typeof bcbs_aresurgicalproceduresforthetreatmentofmor;

	export const bcbs_isoutpatientphysicaloccupationalther = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isoutpatientphysicaloccupationalther = keyof typeof bcbs_isoutpatientphysicaloccupationalther;

	export const bcbs_isoutpatientphysicaloccupationaltherapysu = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isoutpatientphysicaloccupationaltherapysu = keyof typeof bcbs_isoutpatientphysicaloccupationaltherapysu;

	export const bcbs_hasincentive = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_hasincentive = keyof typeof bcbs_hasincentive;

	export const bcbs_fi_ppo_grouphavechirocoverage = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_fi_ppo_grouphavechirocoverage = keyof typeof bcbs_fi_ppo_grouphavechirocoverage;

	export const bcbs_isoutpatientspeechtherapysubjecttoanymaxi = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isoutpatientspeechtherapysubjecttoanymaxi = keyof typeof bcbs_isoutpatientspeechtherapysubjecttoanymaxi;

	export const bcbs_routinecolonscopy = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_routinecolonscopy = keyof typeof bcbs_routinecolonscopy;

	export const bcbs_ded_oop_per_occurrence = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_ded_oop_per_occurrence = keyof typeof bcbs_ded_oop_per_occurrence;

	export const bcbs_rally = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_rally = keyof typeof bcbs_rally;

}

export namespace bcbs_config_row {
	export const bcbs_isreleased = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isreleased = keyof typeof bcbs_isreleased;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

}

export namespace bcbs_quoterequest {
	export const bcbs_requestedtierratingstructure = {
		"Comprehensive(808900000)" : {
			name: "Comprehensive",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Comprehensive",
			value: 808900000,
			order: 1,
		},
		"2 Tier(808900001)" : {
			name: "2 Tier",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "2 Tier",
			value: 808900001,
			order: 2,
		},
		"3 Tier(808900002)" : {
			name: "3 Tier",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "3 Tier",
			value: 808900002,
			order: 3,
		},
		"4 Tier(808900003)" : {
			name: "4 Tier",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "4 Tier",
			value: 808900003,
			order: 4,
		},
		"5 Tier(808900004)" : {
			name: "5 Tier",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "5 Tier",
			value: 808900004,
			order: 5,
		},
		" 6 Tier(808900005)" : {
			name: " 6 Tier",
			value: 808900005,
			order: 6,
		},
		808900005 : {
			name: " 6 Tier",
			value: 808900005,
			order: 6,
		},
	}
	export type Tbcbs_requestedtierratingstructure = keyof typeof bcbs_requestedtierratingstructure;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const bcbs_quotetypecode = {
		"Administrative Services Only(808900000)" : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		"ASO with Stop Loss(808900001)" : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		"Fully Insured(808900002)" : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		"National Alliance(808900003)" : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		"Level Funded(808900004)" : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
	}
	export type Tbcbs_quotetypecode = keyof typeof bcbs_quotetypecode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_currentfundingtypecode = {
		"Administrative Services Only(808900000)" : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Administrative Services Only",
			value: 808900000,
			order: 1,
		},
		"ASO with Stop Loss(808900001)" : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "ASO with Stop Loss",
			value: 808900001,
			order: 2,
		},
		"Fully Insured(808900002)" : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Fully Insured",
			value: 808900002,
			order: 3,
		},
		"National Alliance(808900003)" : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "National Alliance",
			value: 808900003,
			order: 4,
		},
		"Level Funded(808900004)" : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Level Funded",
			value: 808900004,
			order: 5,
		},
	}
	export type Tbcbs_currentfundingtypecode = keyof typeof bcbs_currentfundingtypecode;

	export const bcbs_status = {
		"Sales  Development(808900000)" : {
			name: "Sales  Development",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Sales  Development",
			value: 808900000,
			order: 1,
		},
		"Sales  Sent to Underwriting(808900001)" : {
			name: "Sales  Sent to Underwriting",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Sales  Sent to Underwriting",
			value: 808900001,
			order: 2,
		},
		"Underwriting  Assigned(808900002)" : {
			name: "Underwriting  Assigned",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Underwriting  Assigned",
			value: 808900002,
			order: 3,
		},
		"Underwriting  On Hold Incomplete Data(808900003)" : {
			name: "Underwriting  On Hold Incomplete Data",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Underwriting  On Hold Incomplete Data",
			value: 808900003,
			order: 4,
		},
		"Underwriting  Completed(808900004)" : {
			name: "Underwriting  Completed",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Underwriting  Completed",
			value: 808900004,
			order: 5,
		},
	}
	export type Tbcbs_status = keyof typeof bcbs_status;

	export const bcbs_willofferhratoemployees = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_willofferhratoemployees = keyof typeof bcbs_willofferhratoemployees;

}

export namespace bcbs_enrollmentdetails {
	export const bcbs_idcardorderingoptioncode = {
		"Rollout as ordered(808900000)" : {
			name: "Rollout as ordered",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Rollout as ordered",
			value: 808900000,
			order: 1,
		},
		"Suppress Cards and Mass Order(808900001)" : {
			name: "Suppress Cards and Mass Order",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Suppress Cards and Mass Order",
			value: 808900001,
			order: 2,
		},
		"NA(808900002)" : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "NA",
			value: 808900002,
			order: 3,
		},
	}
	export type Tbcbs_idcardorderingoptioncode = keyof typeof bcbs_idcardorderingoptioncode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

}

export namespace bcbs_config_masterattribute {
	export const bcbs_isreleased = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isreleased = keyof typeof bcbs_isreleased;

	export const bcbs_isacceptsdefaultvalue = {
		"Yes(1)" : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Yes",
			value: 1,
			order: 1,
		},
		"No(0)" : {
			name: "No",
			value: 0,
			order: 2,
		},
		0 : {
			name: "No",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isacceptsdefaultvalue = keyof typeof bcbs_isacceptsdefaultvalue;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const bcbs_attributetypecode = {
		"Boolean(808900000)" : {
			name: "Boolean",
			value: 808900000,
			order: 1,
		},
		808900000 : {
			name: "Boolean",
			value: 808900000,
			order: 1,
		},
		"Costshare(808900001)" : {
			name: "Costshare",
			value: 808900001,
			order: 2,
		},
		808900001 : {
			name: "Costshare",
			value: 808900001,
			order: 2,
		},
		"Currency(808900002)" : {
			name: "Currency",
			value: 808900002,
			order: 3,
		},
		808900002 : {
			name: "Currency",
			value: 808900002,
			order: 3,
		},
		"Date(808900003)" : {
			name: "Date",
			value: 808900003,
			order: 4,
		},
		808900003 : {
			name: "Date",
			value: 808900003,
			order: 4,
		},
		"Decimal(808900004)" : {
			name: "Decimal",
			value: 808900004,
			order: 5,
		},
		808900004 : {
			name: "Decimal",
			value: 808900004,
			order: 5,
		},
		"Lookup(808900006)" : {
			name: "Lookup",
			value: 808900006,
			order: 6,
		},
		808900006 : {
			name: "Lookup",
			value: 808900006,
			order: 6,
		},
		"Message(808900014)" : {
			name: "Message",
			value: 808900014,
			order: 7,
		},
		808900014 : {
			name: "Message",
			value: 808900014,
			order: 7,
		},
		"Multiple Lines of Text(808900009)" : {
			name: "Multiple Lines of Text",
			value: 808900009,
			order: 8,
		},
		808900009 : {
			name: "Multiple Lines of Text",
			value: 808900009,
			order: 8,
		},
		"Option Set(808900007)" : {
			name: "Option Set",
			value: 808900007,
			order: 9,
		},
		808900007 : {
			name: "Option Set",
			value: 808900007,
			order: 9,
		},
		"Percentage(808900005)" : {
			name: "Percentage",
			value: 808900005,
			order: 10,
		},
		808900005 : {
			name: "Percentage",
			value: 808900005,
			order: 10,
		},
		"Pharmacy Costshare(808900013)" : {
			name: "Pharmacy Costshare",
			value: 808900013,
			order: 11,
		},
		808900013 : {
			name: "Pharmacy Costshare",
			value: 808900013,
			order: 11,
		},
		"Single Line of Text(808900008)" : {
			name: "Single Line of Text",
			value: 808900008,
			order: 12,
		},
		808900008 : {
			name: "Single Line of Text",
			value: 808900008,
			order: 12,
		},
		"Vision Costshare(808900012)" : {
			name: "Vision Costshare",
			value: 808900012,
			order: 13,
		},
		808900012 : {
			name: "Vision Costshare",
			value: 808900012,
			order: 13,
		},
		"Whole Number(808900010)" : {
			name: "Whole Number",
			value: 808900010,
			order: 14,
		},
		808900010 : {
			name: "Whole Number",
			value: 808900010,
			order: 14,
		},
		"Attribute Set(808900015)" : {
			name: "Attribute Set",
			value: 808900015,
			order: 15,
		},
		808900015 : {
			name: "Attribute Set",
			value: 808900015,
			order: 15,
		},
	}
	export type Tbcbs_attributetypecode = keyof typeof bcbs_attributetypecode;

}

export namespace bcbs_config_segment {
	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const bcbs_isreleased = {
		"True(1)" : {
			name: "True",
			value: 1,
			order: 1,
		},
		1 : {
			name: "True",
			value: 1,
			order: 1,
		},
		"False(0)" : {
			name: "False",
			value: 0,
			order: 2,
		},
		0 : {
			name: "False",
			value: 0,
			order: 2,
		},
	}
	export type Tbcbs_isreleased = keyof typeof bcbs_isreleased;

}

export namespace bcbs_agencydetail {
	export const statecode = {
		"Active(0)" : {
			name: "Active",
			value: 0,
			order: 1,
		},
		0 : {
			name: "Active",
			value: 0,
			order: 1,
		},
		"Inactive(1)" : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
		1 : {
			name: "Inactive",
			value: 1,
			order: 2,
		},
	}
	export type Tstatecode = keyof typeof statecode;

	export const statuscode = {
		"Active(1)" : {
			name: "Active",
			value: 1,
			order: 1,
		},
		1 : {
			name: "Active",
			value: 1,
			order: 1,
		},
		"Inactive(2)" : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
		2 : {
			name: "Inactive",
			value: 2,
			order: 2,
		},
	}
	export type Tstatuscode = keyof typeof statuscode;

}

